(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49fb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49fb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1ND9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $14f8bce2df879bb2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Component", () => (parcelRequire("6WiAp")).default);
$parcel$export(module.exports, "HostComponent", () => (parcelRequire("6WiAp")).HostComponent);
$parcel$export(module.exports, "EventBus", () => (parcelRequire("cRMCj")).default);
$parcel$export(module.exports, "Router", () => (parcelRequire("iLAKo")).default);
/*
 * Copyright 2022 Nicolas Lochet Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
var $6WiAp = parcelRequire("6WiAp");

var $cRMCj = parcelRequire("cRMCj");

var $iLAKo = parcelRequire("iLAKo");
function $14f8bce2df879bb2$export$2e2bcd8739ae039(options) {
    return new $14f8bce2df879bb2$var$LlamaConfig(options).buildRouter();
}
/**
 * @typedef {Object} RouteTarget
 * @property {Class<Component>} [type]
 * @property {string} [name] name of the component to serve as source for event listeners
 * @property {string} [box] the id of an HTML element the component is rendered into
 * @property {string} [sub_box] the id of an HTML element the embedded sub-component are rendered into
 * @property {string|(args: object, path: string, this:Component)=>string} [html] a string or a function that produce a html to be injected before init
 * @property {string} [css] a string of CSS to be injected
 * @property {(args: object, path: string)=>{}} [onLoad] a hook for action on load of the component
 * @property {(args: object, path: string)=>{}} [onPostLoad] a hook for action after load of the component
 * @property {()=>{}} [onBeforeClean] a hook for action on load of the component
 * @property {()=>{}} [onAfterClean] a hook for action on load of the component
 * @property {Console} [logger] define a logger, can be {logger: console} to send on the javascript console
 * @property {Object.<string, RouteTarget>} embed embedded route
 */ /**
 * The Llama config parser
 *
 * @class LlamaConfig
 * @private
 *
 * @param {Object} options
 * @param {string} [options.box] the id of the div we load components in
 * @param {EventBus} [options.eventBus]
 * @param {Object} [options.context]
 * @param {Object.<string, Class<Component>|RouteTarget>} options.routes
 * @param {Console} [options.logger] define a logger, can be {logger: console} to send on the javascript console
 */ class $14f8bce2df879bb2$var$LlamaConfig {
    constructor(options){
        if (!('routes' in options)) throw new Error('options.routes is compulsory');
        this.routes = options.routes;
        this.context = options?.context || {};
        this.box = options?.box || 'app';
        this.eventBus = options?.eventBus || new (0, $cRMCj.default)();
        this.logger = options?.logger;
        this.options = options;
    }
    /**
   * Build a new router from Llama config
   *
   * @returns {Router} a new router that match the config
   */ buildRouter() {
        const router = new (0, $iLAKo.default)(this.eventBus, this.addLogger());
        for (const [path, Target] of Object.entries(this.routes))if (typeof Target === 'object') {
            const Type = Target.type || (!('embed' in Target) ? (0, $6WiAp.default) : (0, $6WiAp.HostComponent));
            const opt = this.targetOpt(Target);
            if (this.logger) this.logger.debug(`adding root component ${path}`);
            const component = new Type(opt);
            if ('embed' in Target && !(component instanceof (0, $6WiAp.HostComponent))) throw new Error('llama.host.component.must.be.type.HostComponent');
            router.on(path, component);
            if ('embed' in Target) {
                const recOpt = Object.assign(this.basicOpts(), this.extractFieldIfExists(Target, 'sub_box'), this.addLogger({
                    o: opt
                }));
                const subRoute = this.recBuildEmbedded(path, Target.embed, recOpt);
                component.setSubRoute(subRoute);
                for (const p of this.flattenSubRoute(subRoute))router.on(p, component);
            }
        } else {
            if (this.logger) this.logger.debug(`adding root component ${path}`);
            router.on(path, new Target(this.targetOpt({})));
        }
        return router;
    }
    /**
   * Recursively parse route config for {@link LlamaConfig.buildRouter}
   *
   * @param {string} path
   * @param {Object.<string, RouteTarget>} embed
   * @param {Object} opt
   * @returns {Object} an embedded route object description to be added to parent route
   */ recBuildEmbedded(path, embed, opt) {
        const res = {};
        for (const [p, T] of Object.entries(embed)){
            const subPath = `${path}/${p}/`.replace(/\/{2,}/g, '/');
            if (this.logger) this.logger.debug(`adding sub component ${subPath}`);
            const box = T.box || opt.sub_box || 'sub';
            const eventBus = opt.eventBus;
            const context = opt.context;
            if (typeof T === 'object') {
                const subOpt = this.targetOpt(T, opt, {
                    box: box,
                    eventBus: eventBus,
                    context: context
                });
                const Type = T.type || (!('embed' in T) ? (0, $6WiAp.default) : (0, $6WiAp.HostComponent));
                const component = new Type(subOpt);
                if ('embed' in T) {
                    if (!(component instanceof (0, $6WiAp.HostComponent))) throw new Error('llama.host.component.must.be.type.HostComponent');
                    const recOpt = Object.assign({
                        box: box,
                        eventBus: eventBus,
                        context: context
                    }, this.extractFieldIfExists(opt, 'sub_box'), this.extractFieldIfExists(T, 'sub_box'), this.addLogger({
                        o: subOpt
                    }));
                    const subRoute = this.recBuildEmbedded(subPath, T.embed, recOpt);
                    component.setSubRoute(subRoute);
                }
                res[subPath] = component;
            } else {
                const subOpt = this.targetOpt({}, opt, {
                    box: box,
                    eventBus: eventBus,
                    context: context
                });
                res[subPath] = new T(subOpt);
            }
        }
        return res;
    }
    /**
   * Recursively parse an embedded route object description and return all the paths
   *
   * @param {object} subRoute an embedded route object description
   * @param {Set.<string>} [res] the intermediate result
   * @returns {Set.<string>} all the paths of the
   */ flattenSubRoute(subRoute, res = new Set()) {
        for (const [p, t] of Object.entries(subRoute))if (!(t instanceof (0, $6WiAp.HostComponent))) res.add(p);
        else this.flattenSubRoute(t.getSubRoute(), res);
        return res;
    }
    targetOpt(target, opt = this, altOpts) {
        return Object.assign({}, target, altOpts || this.basicOpts(), this.addLogger({
            o: opt,
            cond: !('logger' in target)
        }));
    }
    basicOpts() {
        const { box: box, eventBus: eventBus, context: context } = this;
        return {
            box: box,
            eventBus: eventBus,
            context: context
        };
    }
    addLogger({ o: o = this, cond: cond = true } = {}) {
        return this.extractFieldIfExists(o, 'logger', cond);
    }
    extractFieldIfExists(o, field, cond = true) {
        return field in o && o[field] && cond ? {
            [field]: o[field]
        } : {};
    }
} /**
 * @private
 * @template T
 * @typedef {new (...args: any[]) => T} Class
 */ 

});
parcelRegister("6WiAp", function(module, exports) {

$parcel$export(module.exports, "default", () => $50d693ac5aac4ff5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "HostComponent", () => $50d693ac5aac4ff5$export$603eebd61acee9b0);
/*
 * Copyright 2022 Nicolas Lochet Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
var $cRMCj = parcelRequire("cRMCj");
class $50d693ac5aac4ff5$export$2e2bcd8739ae039 {
    static LOAD = 'llama-component-load';
    constructor(options = {}){
        this.id = (Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0');
        this.name = options?.name || this.constructor.name;
        if (typeof options?.eventBus === 'object' && !(options?.eventBus instanceof (0, $cRMCj.default))) throw new Error('options.eventBus must be instance of EventBus');
        this.eventBus = options?.eventBus;
        if (typeof options?.box !== 'undefined' && typeof options.box !== 'string') throw new Error('options.box must be of type string');
        this.box = options?.box || 'app';
        this.context = options?.context || {};
        if (options?.logger) this.logger = options?.logger;
        if (options?.html) this.html = options.html;
        if (options?.css) this.css = options.css;
        if (options?.onLoad) this.onLoad = options?.onLoad;
        if (options?.onPostLoad) this.onPostLoad = options?.onPostLoad;
        if (options?.onBeforeClean) this.onBeforeClean = options?.onBeforeClean;
        if (options?.onAfterClean) this.onAfterClean = options?.onAfterClean;
        this.children = [];
        this.parent = undefined;
        this.active = false;
        this.listening = false;
        if (this.logger) this.logger.info(`${this.name}: created, id:${this.id}`);
    }
    /**
   * Listen events
   */ listen() {
        if (!this.listening) {
            this.listening = true;
            if (this.logger) this.logger.info(`${this.name}: listening`);
            this.on($50d693ac5aac4ff5$export$2e2bcd8739ae039.LOAD).before((loadingComponent, args, path)=>{
                const isNotMe = loadingComponent !== this;
                const isUnloading = this.active && isNotMe;
                if (this.logger) this.logger.debug(`${this.name}: unload? ${isUnloading} (active: ${this.active}, isNotMe: ${isNotMe})`);
                if (isUnloading) this.unload(path);
            })?.do((loadingComponent, args, path)=>{
                if (loadingComponent === this) {
                    if (this.logger) this.logger.info(`${this.name}.load(${JSON.stringify(args)}, ${path} )`);
                    this.load(args, path);
                    if (this.logger) this.logger.info(`${this.name}.postLoad(${JSON.stringify(args)}, ${path} )`);
                    this.postLoad(args, path);
                }
            });
        }
    }
    /**
   * Call for loading of the component
   *
   * @param {object} args
   * @param {string} path
   */ call(args, path) {
        if (this.logger) this.logger.debug(`${this.name}: calling(${JSON.stringify(args)}, ${path})`);
        this.emit($50d693ac5aac4ff5$export$2e2bcd8739ae039.LOAD, this, args, path);
    }
    /**
   * Load component inside the box
   *
   * @param {object} args
   * @param {string} path
   */ load(args, path) {
        this.active = true;
        // fill with HTML and CSS (if exists)
        this.populate(args, path);
        // initiate the component
        if (this.logger) this.logger.debug(`${this.name}.init()`);
        this.init(args, path);
    }
    /**
   * Unload component
   */ unload() {
        if (this.logger) this.logger.info(`${this.name}.unload()`);
        this.active = false;
        if (this.onBeforeClean) this.onBeforeClean();
        this.clean();
        if (this.onAfterClean) this.onAfterClean();
    }
    /**
   *
   * @returns {ShadowRoot|HTMLElement}
   */ prepareBox() {
        if (this.logger) this.logger.debug(`${this.name}.prepareBox(id='${this.box}'`);
        // root component
        if (!this.parent) {
            const tmp = document.getElementById(this.box);
            if (!tmp.shadowRoot) {
                tmp.attachShadow({
                    mode: 'open'
                });
                while(tmp.hasChildNodes())tmp.shadowRoot.appendChild(tmp.firstChild);
            }
            return tmp.shadowRoot;
        } else return this.parent.gId(this.box);
    }
    /**
   *
   * @param {object} args
   * @param {string} path
   */ populate(args, path) {
        if (this.logger) this.logger.debug(`${this.name}.populate()`);
        // fill box with HTML if necessary
        if (this.hasHTML()) {
            const box = this.prepareBox();
            this.empty(box);
            this.injectCSS(box);
            this.injectHTML(box, args, path);
        }
    }
    /**
   *
   * @param {object} [args]
   * @param {string} [path]
   * @param {...Component} children
  */ addChildren(args, path, ...children) {
        if (path instanceof $50d693ac5aac4ff5$export$2e2bcd8739ae039) {
            children.unshift(path);
            path = undefined;
        }
        if (args instanceof $50d693ac5aac4ff5$export$2e2bcd8739ae039) {
            children.unshift(args);
            args = undefined;
        }
        children.forEach((child)=>{
            child.parent = this;
            this.children.push(child);
            if (this.logger) this.logger.debug(`${this.name}: ${child.name}.load()`);
            child.load(args, path);
        });
        if (this.logger) this.logger.log(`${this.name}.addChildren:`, this.children.map((x)=>x.name));
    }
    /**
   *
   * @param {...Component} children
  */ removeChildren(...children) {
        if (children.length === 0) children = this.children.slice();
        if (this.logger) this.logger.log(`${this.name}.removeChildren:`, this.children.map((x)=>x.name));
        children.forEach((child)=>{
            child.clean();
            const idx = this.children.indexOf(child);
            if (idx !== -1) this.children.splice(idx, 1);
        });
    }
    /**
   * init the component after appending to DOM
   * @param {object} args
   * @param {string} path
   */ init(args, path) {
        if (this.onLoad) this.onLoad(args, path);
    }
    /**
   * activate after load
   * @param {object} args
   * @param {string} path
   */ postLoad(args, path) {
        if (this.onPostLoad) this.onPostLoad(args, path);
    }
    /**
   * clean the component after removing from DOM
   */ clean() {
        // remove the listeners of this component in the eventBus
        this.eventBus?.clear(this.name, (k)=>k !== $50d693ac5aac4ff5$export$2e2bcd8739ae039.LOAD);
        // clean the children
        this.removeChildren();
        if (this.hasHTML()) this.empty();
    }
    /**
   * Attach an event listener for this source component
   * @param {string|string[]} e the event(s) key(s) to attach the listener
   * @param {(...r) => {}} [f] the listener function
   */ on(e, f) {
        return this.eventBus?.on(this.name, e, f);
    }
    /**
   * Emit an event for a given key that are sent to every attached events listeners
   * @param {string} k the event key
   * @param {...any} p the optional args
   */ emit(k, ...p) {
        this.eventBus?.emit(k, ...p);
    }
    /**
   * @param {string} id
   * @returns {HTMLElement}
   */ gId(id) {
        if (this.parent) {
            if (this.logger) this.logger.debug(`${this.name}: gId search in parent: ${this.parent.name} (${id})`);
            return this.parent.gId(id);
        } else {
            const box = this.prepareBox();
            if (this.logger) this.logger.debug(`${this.name}: gId (${id})`);
            return box.getElementById(id);
        }
    }
    /**
   * @param {string} id
   * @param {*} evt
   * @param {*} cb
   */ addEvtById(id, evt, cb) {
        this.gId(id)?.addEventListener(evt, cb);
    }
    /**
   * @returns {boolean}
   */ hasHTML() {
        if (this.logger) this.logger.debug(`${this.name}: has HTML? ${typeof this.html !== 'undefined'}`);
        return typeof this.html !== 'undefined';
    }
    /**
   * Clear the box contents
   * @param {Node} box
   */ empty(box = this.prepareBox()) {
        if (box) while(box.hasChildNodes())box.removeChild(box.firstChild);
    }
    /**
   * Generate DOM Element from source HTML
   *
   * @param {string} html some HTML code
   * @returns {DocumentFragment} the generated DOM Element
   */ fragmentFromHtml(html) {
        const fragment = document.createDocumentFragment();
        const template = document.createElement('template');
        template.innerHTML = html.trim() // Never return a text node of whitespace as the result
        ;
        // template.content.childNodes.forEach((node) => fragment.append(node))
        fragment.append(...template.content.childNodes);
        return fragment;
    }
    /**
   * Inject component defined CSS into the box (if it exists)
   * @param {Node} box
   */ injectCSS(box = this.prepareBox()) {
        if (this.css) {
            const style = document.createElement('style');
            style.textContent = this.css;
            if (this.logger) this.logger.debug(`${this.name}: inject CSS`);
            box.appendChild(style);
        } else if (this.logger) this.logger.debug(`${this.name}: no CSS injected`);
    }
    /**
   * Inject component defined HTML into the box (if it exists)
   * @param {Node} box
   * @param {object} [args]
   * @param {string} [path]
   */ injectHTML(box = this.prepareBox(), args, path) {
        if (this.html) {
            if (this.logger) this.logger.debug(`${this.name}: inject HTML (format:${typeof this.html})`);
            if (typeof this.html === 'string') box.appendChild(this.fragmentFromHtml(this.html));
            else if (typeof this.html === 'function') box.appendChild(this.fragmentFromHtml(this.html(args, path, this)));
        } else if (this.logger) this.logger.debug(`${this.name}: no HTML injected`);
    }
    toString() {
        return `${this.constructor.name}{ ${this.name} }`;
    }
}
class $50d693ac5aac4ff5$export$603eebd61acee9b0 extends $50d693ac5aac4ff5$export$2e2bcd8739ae039 {
    /**
   *
   * @param {Object.<string, number>} subRoute
   */ setSubRoute(subRoute) {
        this.subRoute = subRoute;
        Object.values(this.subRoute).forEach((sub)=>{
            sub.parent = this;
            if (sub instanceof $50d693ac5aac4ff5$export$603eebd61acee9b0) Object.keys(sub.getSubRoute()).forEach((path)=>{
                this.subRoute[path] = sub;
            });
        });
        if (this.logger) this.logger.debug(`${this.name}.subRoute:`, Object.fromEntries(Object.entries(subRoute).map(([p, x])=>[
                p,
                x.name
            ])));
    }
    getSubRoute() {
        return this.subRoute;
    }
    getSubComponent(path) {
        return this.getSubRoute()[path];
    }
    load(args, path) {
        if (!this.active) super.load(args, path);
        if (this.logger) this.logger.debug(`${this.name}: load embedded`);
        const sub = this.getSubComponent(path);
        if (sub) {
            sub.parent = this;
            this.children.push(sub);
            sub.listen();
            if (this.logger) this.logger.debug(`${this.name}: ${sub.name}.load(${JSON.stringify(args)},${path})`);
            sub.load(args, path);
            if (sub.postLoad) {
                if (sub.logger) sub.logger.debug(`${this.name}: ${sub.name}.postLoad(${JSON.stringify(args)}, ${path} )`);
                sub.postLoad(args, path);
            }
        }
    }
    unload(path) {
        if (!this.parent) super.unload();
        else {
            const sub = this.getSubComponent(path);
            if (!sub) {
                // remove the listeners of this component in the eventBus
                this.eventBus?.clear(this.name, (k)=>k !== $50d693ac5aac4ff5$export$2e2bcd8739ae039.LOAD);
                super.unload();
            }
        }
    }
}

});
parcelRegister("cRMCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e02592d1325253$export$2e2bcd8739ae039);
/*
 * Copyright 2022 Nicolas Lochet Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and limitations under the License.
 */ /**
 * A simple event bus to enable event-driven architecture
 *
 * @class SimpleEventBus
 *
 * @param {Object} options optional parameters
 * @param {string} [options.name] define a name, in a multi EventBus scenario
 * @param {(e:Error) => {}} [options.catcher] define an error catching function
 * @param {Console} [options.logger] define a logger, can be {logger: console} to send on the javascript console
 */ class $95e02592d1325253$export$9b7aab182bd16a75 {
    constructor(options = {}){
        this._hook = new Map();
        this.name = options?.name || 'emit';
        this.catcher = options?.catcher;
        this.logger = options?.logger;
    }
    /**
   * Attach an event listener for a source
   * @param {string} s name of the source of the listener
   * @param {string|string[]} e the event(s) key(s) to attach the listener
   * @param {(...r) => {}} f the listener function
   */ on(s, e, f) {
        if (this.logger && (!this.logger?.logFor || this.logger?.logFor('on'))) this.logger.debug(`EventBus.on<${this.name}>: %s / %s`, s, e /*, f.toString() */ );
        const l = e instanceof Array ? e : [
            e
        ];
        l.forEach((k)=>{
            let d = this._hook.get(k);
            if (!d) {
                d = {};
                this._hook.set(k, d);
            }
            d[s] = f;
        });
    }
    /**
   * Emit an event for a given key that are sent to every attached events listeners
   * @param {string} k the event key
   * @param  {...any} p the optional args
   */ emit(k, ...p) {
        if (this.logger && (!this.logger?.logFor || this.logger?.logFor(this.name))) this.logger.debug(`EventBus.emit<${this.name}>: %s`, k, ...p);
        setTimeout(()=>{
            try {
                this._run(k, p);
            } catch (error) {
                if (this.catcher) this.catcher(error, this.name);
                else throw error;
            }
        }, 1);
    }
    _run(k, p) {
        const handlers = this._hook.get(k);
        if (handlers) Object.entries(handlers).forEach(([s, f])=>{
            if (this.logger && (!this.logger?.logFor || this.logger?.logFor(this.name))) this.logger.debug(`EventBus.emit<${this.name}>: %s to %s`, k, s);
            f(...p);
        });
    }
    /**
   * Clear event listeners for a source
   * @param {string} s the name of the source to clear events for
   * @param {(k:string)=> boolean} [filter] filter the keys that should be cleared (return true for keys to be cleared)
   */ clear(s, filter = ()=>true) {
        if (this.logger && (!this.logger?.logFor || this.logger?.logFor('clear'))) this.logger.debug(`EventBus.clear<${this.name}>: %s`, s);
        for (const [k, d] of this._hook.entries())if (s in d && filter(k)) delete d[s];
    }
}
class $95e02592d1325253$export$39747b9eb99de {
    constructor(sqEventBus, src, evt){
        Object.assign(this, {
            sqEventBus: sqEventBus,
            src: src,
            evt: evt
        });
    }
    before(f) {
        this.sqEventBus._before.on(this.src, this.evt, f);
        return this;
    }
    do(f) {
        this.sqEventBus._emit.on(this.src, this.evt, f);
        return this;
    }
    after(f) {
        this.sqEventBus._after.on(this.src, this.evt, f);
        return this;
    }
}
class $95e02592d1325253$export$316f37b9fa3ba60 {
    constructor(options = {}){
        this._before = new $95e02592d1325253$export$9b7aab182bd16a75({
            name: 'before',
            catcher: options?.catcher,
            logger: options?.logger
        });
        this._emit = new $95e02592d1325253$export$9b7aab182bd16a75({
            name: 'emit',
            catcher: options?.catcher,
            logger: options?.logger
        });
        this._after = new $95e02592d1325253$export$9b7aab182bd16a75({
            name: 'after',
            catcher: options?.catcher,
            logger: options?.logger
        });
        this.catcher = options?.catcher;
        this.logger = options?.logger;
    }
    /**
   * Attach an event listener for a source
   * @param {string} s name of the source of the listener
   * @param {string|string[]} e the event(s) key(s) to attach the listener
   * @param {(...r) => {}} [f] the listener function
   */ on(s, e, f) {
        if (f) this._emit.on(s, e, f);
        return new $95e02592d1325253$export$39747b9eb99de(this, s, e);
    }
    /**
   * Emit an event for a given key that are sent to every attached events listeners
   * @param {string} k the event key
   * @param  {...any} p the optional args
   */ emit(k, ...p) {
        if (this.logger && (!this.logger?.logFor || this.logger?.logFor('emit'))) this.logger.debug('EventBus.emit: %s', k, ...p);
        setTimeout(()=>{
            this._before._run(k, p);
            this._emit._run(k, p);
            this._after._run(k, p);
        }, 1);
    }
    /**
   * Clear event listeners for a source
   * @param {string} s the name of the source to clear events for
   * @param {(k:string)=> boolean} [filter] filter the keys that should be cleared (return true for keys to be cleared)
   */ clear(s, filter = ()=>true) {
        if (this.logger && (!this.logger?.logFor || this.logger?.logFor('clear'))) this.logger.debug('EventBus.clear: %s', s);
        this._before.clear(s, filter);
        this._emit.clear(s, filter);
        this._after.clear(s, filter);
    }
}
const $95e02592d1325253$var$EventBus = $95e02592d1325253$export$316f37b9fa3ba60;
var $95e02592d1325253$export$2e2bcd8739ae039 = $95e02592d1325253$var$EventBus;

});


parcelRegister("iLAKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $da991effc688f54a$export$2e2bcd8739ae039);
/*
 * Copyright 2022 Nicolas Lochet Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and limitations under the License.
 */ // JSDoc
// eslint-disable-next-line no-unused-vars
parcelRequire("cRMCj");

var $6WiAp = parcelRequire("6WiAp");
const $da991effc688f54a$var$pathRx = /\/(?:(?::([0-9A-Za-z.+-]+))|([0-9A-Za-z.+-]+))/g;
const $da991effc688f54a$var$urlRx = /\/([0-9A-Za-z.+-]+)/g;
class $da991effc688f54a$export$1ca45c9a47aec42c {
    constructor(name){
        this.name = name;
    }
    addTo(args, val) {
        args[this.name] = val;
    }
}
class $da991effc688f54a$export$4b2950bdac9b6ee9 {
    /**
   *
   * @param {string} path
   * @param {Array} pathParts
   */ constructor(path, pathParts){
        this.path = path;
        this.path_parts = pathParts;
    }
    static build(path) {
        const pathParts = [];
        let parts;
        while((parts = $da991effc688f54a$var$pathRx.exec(path)) !== null){
            if (typeof parts[1] !== 'undefined') pathParts.push(new $da991effc688f54a$export$1ca45c9a47aec42c(parts[1]));
            else if (typeof parts[2] !== 'undefined') pathParts.push(parts[2]);
        }
        return new $da991effc688f54a$export$4b2950bdac9b6ee9(path, pathParts);
    }
    check(parts) {
        if (parts.length === this.path_parts.length) {
            const args = {};
            if (this.path_parts.every((v, i)=>{
                if (v instanceof $da991effc688f54a$export$1ca45c9a47aec42c) {
                    v.addTo(args, parts[i]);
                    return true;
                } else return v === parts[i];
            })) return new $da991effc688f54a$export$bf00b4cafcb0e27b(this.path, args);
        }
    }
}
class $da991effc688f54a$export$bf00b4cafcb0e27b {
    constructor(path, args){
        this.path = path;
        this.args = args;
    }
    toString() {
        return `Parsed{"${this.path}", ${JSON.stringify(this.args)}}`;
    }
}
class $da991effc688f54a$export$2e2bcd8739ae039 {
    static GO = 'router-go';
    static LAND = 'router-land';
    static NOT_FOUND = 'router-notfound';
    static ERROR = 'router-error';
    constructor(eventBus, options){
        /**
     * @property {Path[]} routes
     */ this.routes = [];
        this.actions = {};
        this.before_action = undefined;
        this.eventBus = eventBus;
        this.logger = options?.logger || undefined;
    }
    /**
   *
   * @param {function} action
   */ before(action) {
        this.before_action = action;
    }
    /**
   *
   * @param {string} path
   * @param {function|Component} action
   */ on(path, action) {
        if (this.logger) this.logger.debug(`router.on(${path}, ${action.toString()})`);
        this.routes.push($da991effc688f54a$export$4b2950bdac9b6ee9.build(path));
        this.actions[path] = action;
        if (action instanceof (0, $6WiAp.default)) action.listen(path);
    }
    /**
   * Run the router
   */ run() {
        if (this.logger) this.logger.debug('router.run()');
        this._route = ()=>this.route();
        window.addEventListener('hashchange', this._route);
        window.addEventListener('load', this._route);
        if (this.eventBus) this.eventBus.on('router', $da991effc688f54a$export$2e2bcd8739ae039.GO, (path)=>{
            this.go(path);
        });
    }
    /**
   * Stop the router
   */ stop() {
        window.removeEventListener('hashchange', this._route);
        window.removeEventListener('load', this._route);
    }
    /**
   * Go to a route matching the given path
   * @param {string} path
   */ go(path) {
        window.location.hash = path;
    }
    /**
   * Route the browser
   */ async route() {
        if (this.logger) this.logger.debug(`router.route(): ${window.location.hash}`);
        const path = window.location.hash.at(0) === '#' ? window.location.hash.substring(1) : window.location.hash || '/';
        try {
            const urlParts = [];
            let parts;
            while((parts = $da991effc688f54a$var$urlRx.exec(path)) !== null)if (parts[1] !== '') urlParts.push(parts[1]);
            let parsed;
            for (const route of this.routes){
                parsed = route.check(urlParts);
                if (parsed) break;
            }
            if (this.logger) this.logger.debug(`router.route() ${parsed ? 'found ' + parsed.toString() : 'not found'}`);
            if (typeof parsed === 'undefined') {
                if (this.eventBus) this.eventBus.emit($da991effc688f54a$export$2e2bcd8739ae039.LAND, $da991effc688f54a$export$2e2bcd8739ae039.NOT_FOUND, {
                    path: path
                });
                if ($da991effc688f54a$export$2e2bcd8739ae039.NOT_FOUND in this.actions) {
                    const action = this.actions[$da991effc688f54a$export$2e2bcd8739ae039.NOT_FOUND];
                    if (action instanceof (0, $6WiAp.default)) await action.call({}, path);
                    else await action({}, path);
                }
            } else {
                if (this.eventBus) this.eventBus.emit($da991effc688f54a$export$2e2bcd8739ae039.LAND, parsed.args, parsed.path);
                if (this.before_action) await this.before_action(parsed);
                const action = this.actions[parsed.path];
                if (this.logger) this.logger.debug(`router.route() action: ${action.name}`);
                if (action instanceof (0, $6WiAp.default)) await action.call(parsed.args, parsed.path);
                else await action(parsed.args, parsed.path);
            }
        } catch (error) {
            if (this.eventBus) this.eventBus.emit($da991effc688f54a$export$2e2bcd8739ae039.LAND, $da991effc688f54a$export$2e2bcd8739ae039.ERROR, {
                path: path
            });
            if ($da991effc688f54a$export$2e2bcd8739ae039.ERROR in this.actions) {
                const action = this.actions[$da991effc688f54a$export$2e2bcd8739ae039.ERROR];
                if (action instanceof (0, $6WiAp.default)) await action.call({
                    error: error
                }, path);
                else await action({
                    error: error
                }, path);
            } else // otherwise let's it keep bubbling
            throw error;
        }
    }
}

});


parcelRegister("iqDbY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6a90e7593ab3764$export$2e2bcd8739ae039);
// use this fix to bypass error in HMR management https://github.com/parcel-bundler/parcel/issues/1591#issuecomment-1011359782
var $d6a90e7593ab3764$export$2e2bcd8739ae039 = (port = 3001)=>{};

});

parcelRegister("2SPoJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21987e7af72f71c0$export$2e2bcd8739ae039);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2025
 */ 
var $1VUfl = parcelRequire("1VUfl");

var $4XVaH = parcelRequire("4XVaH");

var $hkt5c = parcelRequire("hkt5c");

var $9bXwx = parcelRequire("9bXwx");
const $21987e7af72f71c0$var$i18n = {};
(0, $hkt5c.defineOnboarding)($21987e7af72f71c0$var$i18n);
(0, $9bXwx.defineRegister)($21987e7af72f71c0$var$i18n);
(0, $4XVaH.defineModal)($21987e7af72f71c0$var$i18n);
(0, $1VUfl.defineGame)($21987e7af72f71c0$var$i18n);
var $21987e7af72f71c0$export$2e2bcd8739ae039 = $21987e7af72f71c0$var$i18n;

});
parcelRegister("1VUfl", function(module, exports) {

$parcel$export(module.exports, "defineGame", () => $1686beae6f970ceb$export$9c68c03f64f8dc14);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2025
 */ function $1686beae6f970ceb$export$9c68c03f64f8dc14(i18n) {
    i18n.game = {};
    i18n.game.common = {
        name: 'Nom&nbsp;:'
    };
    i18n.game.tabs = {
        map: 'Carte',
        inventory: 'Inventaire',
        exchange: 'Echanger',
        history: 'Historique'
    };
    i18n.game.map = {};
    i18n.game.map.tabs = {
        action: 'Action',
        people: 'Rencontre',
        settlement: 'Habitations',
        vehicle: 'Vehicules'
    };
    i18n.game.map.vehicle = {
        no_move_inland: "Impossible de se d\xe9placer \xe0 terre",
        name: 'Nom',
        type: 'Type',
        storage: 'Stockage',
        equipped: 'Equipement',
        occupants: {
            title: "Pr\xe9sent \xe0 bord",
            header: {
                name: 'Nom',
                rank: 'Rang',
                teams: 'Equipes',
                leader: 'Leader',
                actions: 'Actions'
            }
        },
        empty: 'Vide',
        provide: 'Approsionner le chantier de construction',
        confirm_work: 'Souhaitez vous travailler sur ce chantier',
        new_build: 'Nouvelle construction',
        building_site: 'Construction en cours',
        ready: "V\xe9hicules \xe0 proximit\xe9",
        proposal: 'Ma contribution',
        onboard: (t, n)=>`A bord du ${t} '${n}'`,
        info: (t, n)=>`Information sur le ${t} '${n}'`,
        state: {
            title: 'Etape du chantier',
            advancement: 'Avancement',
            working: 'Travailleur En cours',
            tool: 'Outil requis',
            materials_next_step: "Mat\xe9riaux n\xe9cessaires pour la prochaine tranche de chantier",
            materials_to_finish: "Mat\xe9riaux n\xe9cessaires pour compl\xe9ter le chantier"
        },
        transfer: {
            accept: 'Souhaitez-vous valider vos modifications ?',
            reset: 'Souhaitez-vous annuler vos modifications ?'
        },
        access: {
            own: 'Mon rang',
            view: "G\xe9rer les acc\xe8s",
            not_member: 'Non membre',
            blacklisted: "Acc\xe8s refus\xe9 - Liste noire",
            member_count: 'Nombre de membre',
            name: 'Nom',
            rank: 'Rang',
            members: 'Membres',
            waiting_list: 'Liste d\'attente',
            blacklist: 'Liste noire',
            kick: (n)=>`Voulez-vous d\xe9barquer de force "${n}" ?`,
            ask: {
                demand: "Demander un acc\xe8s",
                waiting: 'Demande en attente de validation',
                confirm: "Souhaitez-vous demander un acc\xe8s ?",
                accept: "Souhaitez-vous accepter la demande d'acc\xe8s ?",
                reject: "Souhaitez-vous rejeter la demande d'acc\xe8s ?",
                choose_rank: 'Choisissez un rang',
                change_rank_valid: (n, r)=>`Validez vous le changement de rang de "${n}" en "${i18n.game.map.vehicle.access.ranks[r]}" ?`,
                blacklist: (n)=>`Voulez-vous mettre "${n}" en liste noire ?`,
                unblacklist: (n)=>`Voulez-vous sortir "${n}" de la liste noire ?`,
                remove: (n)=>`Voulez-vous retirer "${n}" des membres ?`
            },
            ranks: {
                Owner: "Propri\xe9taire",
                Officer: 'Officier',
                Mate: 'Maistre',
                Crew: 'Equipage',
                Passenger: 'Passager'
            }
        },
        job: {
            join: "Rejoindre une \xe9quipe",
            type: {
                drive: 'manoeuvre',
                fishing: "p\xeache",
                //
                bake: 'cuisson du pain',
                install: 'installation',
                destroy: 'destruction',
                cultivate: 'culture',
                livestock: "\xe9levage"
            },
            type_target: {
                oven: 'four',
                cereal: "c\xe9r\xe9ale",
                linen: 'lin',
                fowl: 'faisan'
            },
            info: {
                title: 'Equipe de travail:',
                no_team: "Pas d'\xe9quipe de travail."
            },
            team: {
                manage: "G\xe9rer les \xe9quipes de travail",
                see: "Voir les \xe9quipes de travail",
                title: (n, t)=>`Equipe de ${i18n.game.map.vehicle.job.type[n]}${t ? ` (${i18n.game.map.vehicle.job.type_target[t]})` : ''}`,
                lookup: (t)=>t in i18n.game.map.vehicle.job.type ? i18n.game.map.vehicle.job.type[t] : t,
                join: 'Rejoindre',
                leave: 'Quitter',
                add: 'Ajouter un membre',
                no_team: "Pas d'\xe9quipe."
            },
            drive: {
                not_leader: "Vous n'\xeates pas en charge.",
                no_team: "Pas d'\xe9quipage.",
                current_team: (n)=>`Equipage actuel: ${n}`,
                minimal_team: (n)=>`Equipage minimal pour manoeuvrer: ${n}`,
                optimal_team: (n)=>`Equipage optimal pour manoeuvrer: ${n}`,
                team_join: "Rejoindre l'\xe9quipage"
            },
            actions: {
                lookup: (t)=>t in i18n.game.map.vehicle.job.type ? i18n.game.map.vehicle.job.type[t] : t,
                work: (t)=>`Faire travailler l'\xe9quipe de ${i18n.game.map.vehicle.job.actions.lookup(t)}`,
                tool_required: (j, m)=>`Equipement de ${i18n.game.map.vehicle.job.actions.lookup(j)} requis: ${i18n.game.item.lookup(m)}`,
                current_team: (j, c)=>`Equipe de ${i18n.game.map.vehicle.job.actions.lookup(j)} actuelle: ${c}`,
                minimal_team: (j, m)=>`Equipe de ${i18n.game.map.vehicle.job.actions.lookup(j)} minimale: ${m}`,
                optimal_team: (j, b)=>`Equipe de ${i18n.game.map.vehicle.job.actions.lookup(j)} optimale: ${b}`
            }
        }
    };
    i18n.game.map.settlement = {
        ready: "Habitations \xe0 proximit\xe9",
        inside: (t, n)=>`\xc0 l'int\xe9rieur de ${i18n.game.construct.article.lookup(t)}${i18n.game.construct.lookup(t)} '${n}'`,
        info: (t, n)=>`Information sur ${i18n.game.construct.article.lookup(t)}${i18n.game.construct.lookup(t)} '${n}'`,
        must_leave_to_move: "Pour vous d\xe9placer, vous devez d'abord sortir de cette habitation.",
        storage: 'Stockage',
        empty: 'Vide',
        occupants: {
            title: "Pr\xe9sents",
            header: {
                name: 'Nom',
                rank: 'Rang',
                teams: 'Equipes',
                actions: 'Actions'
            }
        },
        access: {
            kick: (n)=>`Voulez-vous expulser "${n}" ?`
        },
        transfer: {
            accept: 'Souhaitez-vous valider vos modifications ?',
            reset: 'Souhaitez-vous annuler vos modifications ?'
        },
        job: {
            show: 'Afficher les travaux'
        },
        production: {
            growing: 'en croissance',
            waiting: "pr\xeat \xe0 travailler"
        },
        extensions: {
            buildings: "D\xe9pendances",
            tiles: "Champs/\xc9levage",
            empty: 'Aucune',
            view: 'Voir',
            lookup: (t)=>t in i18n.game.map.vehicle.job.type_target ? i18n.game.map.vehicle.job.type_target[t] : t in i18n.game.item ? i18n.game.item[t] : t,
            status: {
                building: 'en construction',
                destroying: (i, n)=>`en destruction (${i}/${n})`,
                install: (i, n)=>`en construction (${i}/${n})`,
                ready: "pr\xeat"
            },
            farming: {
                plough: "Pr\xeat \xe0 labourer",
                weed: "Pr\xeat \xe0 d\xe9sherber",
                sow: "Pr\xeat \xe0 semer",
                growth: 'En pousse',
                feed: "En \xe9levage",
                harvest: "Pr\xeat \xe0 r\xe9colter",
                slaughter: "Pr\xeat \xe0 abattre",
                breed: "Pr\xeat \xe0 reproduire",
                lookup: (name, prodStatus, phaseMode)=>{
                    const f = i18n.game.map.settlement.extensions.farming;
                    if (prodStatus === 'growing' || phaseMode === 'auto') return f[name] ?? f.growth ?? name;
                    return f[name] ?? name;
                }
            },
            detail: {
                title: (n)=>n,
                step: (n, total)=>total ? `\xc9tape ${n}/${total}` : `\xc9tape ${n}`,
                phase: (n)=>`Phase ${n}`,
                phaseProgress: (i, n)=>`Phase ${i}/${n}`,
                stage: (n)=>`Stade ${n}`,
                jobs: 'Travaux disponibles',
                no_jobs: 'Aucun travail disponible pour vous.'
            }
        }
    };
    i18n.game.objects = {
        tabs: {
            inventory: 'Inventaire',
            craft: 'Fabriquer'
        },
        bag: 'Sac',
        equipped: 'Equipement',
        tools: 'Outils',
        materials: "Mat\xe9riaux",
        food: 'Nourriture',
        vehicles: 'Vehicules',
        games: 'Gibiers',
        target: 'Cible',
        transform: {
            tool: "Merci d'\xe9quiper l'outil"
        },
        bargain: {
            title: 'Trocs en cours',
            items: (content)=>i18n.game.bargain.print_content(content)
        },
        working: {
            title: "Utilis\xe9 par l'action en cours",
            items: (content)=>i18n.game.bargain.print_content(content)
        }
    };
    i18n.game.actions = {
        move: "D\xe9placement",
        eat: 'Manger',
        no_actions: 'Aucune action possible ici.',
        collect: (r)=>{
            if ([
                'cereal',
                'fruit',
                'linen',
                'vegetable'
            ].includes(r)) return i18n.game.actions.forage + ' ' + i18n.game.item.lookup(r);
            else return i18n.game.actions.pickup + ' ' + i18n.game.item.lookup(r);
        },
        pickup: 'Ramasser',
        forage: 'Cueillir',
        using: 'avec',
        notool: 'sans outil',
        hunt: (a, b, c)=>{
            if ([
                'harpoon'
            ].includes(a)) return "P\xeacher au harpon";
            else return a !== b ? `Chasser avec ${i18n.game.item.lookup(a)} et ${i18n.game.item.lookup(b)} (${c})` : `Chasser avec ${i18n.game.item.lookup(a)}`;
        },
        craft: 'Fabriquer',
        build: {
            init: 'Ouvrir un chantier',
            see: 'Voir',
            access: "Acc\xe9der au chantier",
            provide: 'Approvisionner',
            work: 'Construire'
        },
        vehicle: {
            embark: 'Embarquer',
            disembark: "D\xe9barquer",
            ask_embark: 'Souhaitez-vous embarquer ?',
            ask_disembark: "Souhaitez-vous d\xe9barquer ?"
        },
        settlement: {
            enter: 'Entrer',
            leave: 'Sortir',
            ask_enter: 'Souhaitez-vous entrer ?',
            ask_leave: 'Souhaitez-vous sortir ?'
        },
        transform: 'Transformer',
        exchange: 'Echanger',
        equip: 'Equiper',
        unequip: 'Ranger'
    };
    i18n.game.doing = {
        move: ({ dir: dir })=>`${i18n.game.actions.move} ${i18n.game.dir[dir]}`,
        'Job.drive.lead': ({ dir: dir })=>`Dirige la manoeuvre vers ${i18n.game.dir.article_le(dir)}${i18n.game.dir[dir]}`,
        'Job.drive.work': ({ dir: dir })=>`Participe \xe0 la manoeuvre vers ${i18n.game.dir.article_le(dir)}${i18n.game.dir[dir]}`,
        collect: ({ r: r })=>{
            if ([
                'cereal',
                'fruit',
                'linen',
                'vegetable'
            ].includes(r)) return i18n.game.actions.forage + ' ' + i18n.game.item.lookup(r);
            else return i18n.game.actions.pickup + ' ' + i18n.game.item.lookup(r);
        },
        hunt: (o)=>{
            if ([
                'harpoon',
                'fishing_net'
            ].includes(o.w)) return `P\xeacher au ${i18n.game.item.lookup(o.w)}`;
            else return `Chasser \xe0 ${o.w === 'bow' ? 'l\'' : 'la '}${i18n.game.item.lookup(o.w)}`;
        },
        'Job.cultivate.lead': ({ c: c })=>`Dirige la culture sur '${c}'`,
        'Job.cultivate.work': ({ c: c })=>`Participe \xe0 la culture sur '${c}'`,
        'Job.livestock.lead': ({ c: c })=>`Dirige l'\xe9levage sur '${c}'`,
        'Job.livestock.work': ({ c: c })=>`Participe \xe0 l'\xe9levage sur '${c}'`,
        'Job.bake.lead': ({ c: c })=>`Dirige la cuisson du pain sur '${c}'`,
        'Job.bake.work': ({ c: c })=>`Participe \xe0 la cuisson du pain sur '${c}'`
    };
    i18n.game.withTool = (x)=>`avec ${x}`;
    i18n.game.item = {
        lookup: (t)=>t in i18n.game.item ? i18n.game.item[t] : t,
        present: (e)=>i18n.game.item.lookup(e.t) + ('n' in e ? ` (${e.n})` : ''),
        axe: 'hache',
        arrow: "fl\xe8che",
        bucket: 'seau',
        bow: 'arc',
        bread: 'pain',
        cereal: "c\xe9r\xe9ale",
        dough: "p\xe2ton",
        duck: 'canard',
        egg: 'oeufs',
        feather: 'plume',
        fish: 'poisson',
        fruit: 'fruit',
        fowl: 'faisan',
        fishing_net: "filet de p\xeache",
        grinder: 'meule',
        harpoon: 'harpon',
        hoe: 'houe',
        javelin: 'javelot',
        knife: 'couteau',
        linen: 'lin',
        meat: 'viande',
        pan: "po\xeale",
        pebble: 'galet',
        pelt: 'fourrure',
        rabbit: 'lapin',
        reed: 'roseau',
        scythe: 'faux',
        sling: 'fronde',
        stone: 'roche',
        string: 'corde',
        vegetable: "l\xe9gume",
        waterskin: 'outre',
        wood: 'bois',
        none: 'aucun'
    };
    i18n.game.construct = {
        lookup: (t)=>t in i18n.game.construct.type ? i18n.game.construct.type[t] : t,
        type: {
            canoe: 'canoe',
            sailboat: 'voilier',
            farm: 'ferme',
            port: 'port'
        },
        article: {
            lookup: (t)=>t in i18n.game.construct.article.type ? i18n.game.construct.article.type[t] : t,
            type: {
                canoe: 'le ',
                sailboat: 'le ',
                farm: 'la ',
                port: 'le '
            }
        },
        build_stage: {
            lookup: (t)=>t in i18n.game.construct.build_stage ? i18n.game.construct.build_stage[t] : t,
            // canoe, sailboat
            frame: 'ossature',
            hull: 'coque',
            keel: 'quille',
            spars: 'espars',
            sails: 'voiles',
            // farm
            foundation: 'fondations',
            dome: "d\xf4me",
            framework: 'charpente',
            wall: 'murs',
            roof: 'toiture',
            // port
            jetty: "jet\xe9e",
            quay: 'quai',
            pontoon: 'ponton'
        },
        state: {
            current_stage_finishing: "Finalisation de l'\xe9tape en cours..."
        }
    };
    i18n.game.dir = {
        N: 'Nord',
        NE: 'Nord-Est',
        E: 'Est',
        SE: 'Sud-Est',
        S: 'Sud',
        SW: 'Sud-Ouest',
        W: 'Ouest',
        NW: 'Nord-Ouest',
        article_le: (d)=>[
                'E',
                'W'
            ].includes(d) ? 'l\'' : 'le ',
        article_de: (d)=>[
                'E',
                'W'
            ].includes(d) ? 'd\'' : 'de '
    };
    i18n.game.exchange = {
        none: 'Aucune conversation.',
        new: 'Inconnus',
        chat: 'Discuter',
        add: 'Ajouter',
        known: 'Conversations',
        unread: 'Non lu :'
    };
    i18n.game.chat = {
        with_members: 'Conversation avec : '
    };
    i18n.game.bargain = {
        title: (char)=>`Troc avec ${char.name}`,
        other_proposal: 'Sa proposition',
        my_proposal: 'Ma proposition',
        my_bag: ()=>"Disponible \xe0 l'\xe9change",
        is_open: 'Transaction ouverte aux modifications',
        locked_by_me: "Transaction ferm\xe9e aux modifications&nbsp;: accept\xe9e par vous",
        locked_by_other: (char)=>`Transaction ferm\xe9e aux modifications&nbsp;: accept\xe9e par ${char.name}`,
        more_than_zero: "Selectionnez une quantit\xe9 sup\xe9rieur \xe0 z\xe9ro.",
        empty: 'Vide',
        add: 'Ajouter',
        remove: 'Retirer',
        propose: 'Proposer',
        edit: 'Modifier',
        send: 'Envoyer',
        reset: 'Reinitialiser',
        unlock: "R\xe9ouvrir",
        accept: 'Valider',
        cancel: 'Annuler',
        confirm_bargain_accepted: 'Souhaitez-vous accepter cette transaction ?',
        confirm_bargain_rejected: 'Souhaitez-vous annuler cette transaction ?',
        confirm_edit_proposal: 'Souhaitez-vous modifier votre proposition ?',
        confirm_send_proposal: 'Souhaitez-vous envoyer votre nouvelle proposition ?',
        confirm_unlock_proposal: "En envoyant cette proposition, vous r\xe9ouvrez la transaction.",
        confirm_reset_proposal: "Souhaitez-vous annuler vos derni\xe8res modifications ?",
        change_in_bargain: "Un changement dans votre proposition de troc est intervenu par une autre connection, nous devons reinitialiser vos modification non envoy\xe9es.",
        change_in_bag: "Un changement est intervenu dans le contenu de votre sac, nous devons reinitialiser vos modification non envoy\xe9es.",
        me: 'moi',
        unknown: 'inconnu',
        format_message: (b, who, isSelf)=>{
            switch(b.t){
                case 'o':
                    return i18n.game.bargain.chat.open(who);
                case 'u':
                    return i18n.game.bargain.chat.update(who, b.received);
                case 'r':
                    return i18n.game.bargain.chat.reopen(who);
                case 'a':
                    return i18n.game.bargain.chat.accept(who);
                case 'c':
                    return i18n.game.bargain.chat.close(who, isSelf, b);
                case 'x':
                    return i18n.game.bargain.chat.cancel(who);
                default:
                    return `${b.t}: ${b.bi}`;
            }
        },
        chat: {
            propal: "Proposition d'\xe9change",
            open: (who)=>`${i18n.game.bargain.chat.propal} <b>ouverte</b> par ${who}`,
            update: (who)=>`${i18n.game.bargain.chat.propal} <b>mise \xe0 jour</b> par ${who}`,
            reopen: (who)=>`${i18n.game.bargain.chat.propal} <b>d\xe9bloqu\xe9e</b> par ${who}`,
            accept: (who)=>`${i18n.game.bargain.chat.propal} <b>accept\xe9e</b> par ${who}`,
            cancel: (who)=>`${i18n.game.bargain.chat.propal} <b>rejet\xe9e</b> par ${who}`,
            close: (who, isSelf, b)=>isSelf ? `Echange conclue avec ${who}.<br> Donn\xe9 : ${i18n.game.bargain.print_content(b.given)}.<br> Re\xe7u : ${i18n.game.bargain.print_content(b.received)}.` : `Echange conclue par ${who}.<br> Donn\xe9 : ${i18n.game.bargain.print_content(b.received)}.<br> Re\xe7u : ${i18n.game.bargain.print_content(b.given)}.`
        },
        print_content: (what)=>`${what.length > 0 ? what.map(i18n.game.item.present).join(', ') : '--rien--'}`
    };
    i18n.game.history = {
        present: (l, p)=>{
            const prefix = l.split('.')[0];
            if (prefix in i18n.game.history) {
                if (typeof i18n.game.history[prefix] === 'function') return i18n.game.history[prefix](l, p);
                else if (l in i18n.game.history[prefix]) {
                    if (typeof i18n.game.history[prefix][l] === 'function') return i18n.game.history[prefix][l](p);
                    else return i18n.game.history[prefix][l];
                } else return `+-- ${l}: ${p.map(JSON.stringify).join(', ')}`;
            } else return `--- ${l}: ${p.map(JSON.stringify).join(', ')}`;
        },
        character: {
            'character.eat.complete': ([p])=>`Mange ${i18n.game.item.present(p)}`,
            'character.equip.item': ([p])=>`Equipe ${i18n.game.item.present(p)}`,
            'character.unequip.item': ([p])=>`Range ${i18n.game.item.present(p)}`
        },
        bargain: {
            'bargain.send.open.to': ([, , who])=>`Proposition de troc ouverte avec ${who}.`,
            'bargain.receive.open.from': ([, , who])=>`Proposition de troc ouverte par ${who}.`,
            'bargain.send.update.content.to': ([content, , who])=>`Proposition de troc mise \xe0 jour avec ${who} : ${i18n.game.bargain.print_content(content)}.`,
            'bargain.receive.update.content.from': ([content, , who])=>`Proposition de troc mise \xe0 jour par ${who} : ${i18n.game.bargain.print_content(content)}.`,
            'bargain.send.accept.to': ([, , who])=>`Proposition de troc accept\xe9e avec ${who}.`,
            'bargain.receive.accept.from': ([, , who])=>`Proposition de troc accept\xe9e par ${who}.`,
            'bargain.send.cancel.to': ([, , who])=>`Proposition de troc rejet\xe9e avec ${who}.`,
            'bargain.receive.cancel.from': ([, , who])=>`Proposition de troc rejet\xe9e par ${who}.`,
            'bargain.send.reopen.to': ([, , who])=>`Proposition de troc d\xe9bloqu\xe9e par ${who}.`,
            'bargain.receive.reopen.from': ([, , who])=>`Proposition de troc d\xe9bloqu\xe9e par ${who}.`,
            'bargain.send.accept.finalize.to': ([given, received, , who])=>`Proposition de troc conclue avec ${who}.<br> Donn\xe9 : ${i18n.game.bargain.print_content(given)}.<br> Re\xe7u : ${i18n.game.bargain.print_content(received)}.`,
            'bargain.receive.accept.finalize.from': ([given, received, , who])=>`Proposition de troc conclue par ${who}.<br> Donn\xe9 : ${i18n.game.bargain.print_content(given)}.<br> Re\xe7u : ${i18n.game.bargain.print_content(received)}.`
        },
        collect: {
            'collect.success': ([p])=>{
                const r = {
                    ...p
                };
                const { tool: tool } = r;
                delete r.tool;
                return `Ramassage de ${Object.entries(r).map(([t, n])=>i18n.game.item.present({
                        t: t,
                        n: n
                    }))}${tool !== 'none' ? ` avec ${i18n.game.item.lookup(tool)}` : ''}`;
            },
            'collect.failure': ([p])=>{
                const r = {
                    ...p
                };
                const { tool: tool } = r;
                delete r.tool;
                return `Echec du ramassage de ${Object.entries(r).map(([t])=>i18n.game.item.lookup(t))}${tool !== 'none' ? ` avec ${i18n.game.item.lookup(tool)}` : ''}`;
            }
        },
        hunt: {
            'hunt.success': ([p])=>{
                const r = {
                    ...p
                };
                delete r.kill;
                const { res: res } = r;
                delete r.res;
                const prises = Object.entries(res).map(([k, n])=>i18n.game.item.lookup(k) + ' (' + n + ')');
                const pertes = Object.entries(r).filter(([, n])=>n > 0).map(([t, n])=>i18n.game.item.present({
                        t: t,
                        n: n
                    }));
                return `Chasse r\xe9ussie. Prises: ${prises.join(', ')}.${pertes.length > 0 ? ` Pertes : ${pertes.join(', ')}.` : ''}`;
            },
            'hunt.failure': ([r])=>{
                const pertes = Object.entries(r).filter(([, n])=>n > 0).map(([t, n])=>i18n.game.item.present({
                        t: t,
                        n: n
                    }));
                return `Chasse infructueuse.${pertes.length > 0 ? ` Pertes : ${pertes.join(', ')}.` : ''}`;
            }
        },
        transform: {
            'transform.success': ([r])=>`Transformation de ${Object.entries(r).map(([k, v])=>i18n.game.item.lookup(k) + ' en ' + Object.entries(v).map(([t, n])=>i18n.game.item.present({
                            t: t,
                            n: n
                        })).join(', '))}`,
            'transform.failure': ([r])=>`Echec de transformation de ${Object.entries(r).map(([k, v])=>i18n.game.item.lookup(k) + ' en ' + Object.entries(v).map(([t, n])=>i18n.game.item.present({
                            t: t,
                            n: n
                        })).join(', '))}`
        },
        craft: {
            'craft.success': ([res, from])=>`Fabrication de ${Object.entries(res).map(([t, n])=>i18n.game.item.present({
                        t: t,
                        n: n
                    })).join(', ')} avec ${from.map(i18n.game.item.present).join(', ')}`,
            'craft.failure': ([res, from])=>`Echec de fabrication de ${Object.entries(res).map(([t, n])=>i18n.game.item.present({
                        t: t,
                        n: n
                    })).join(', ')} avec ${from.map(i18n.game.item.present).join(', ')}`
        },
        build: {
            'build.provide.content': ([given])=>`Approvisionnement du chantier: ${i18n.game.bargain.print_content(given)}`,
            'build.stage.complete': ([{ target: target, stage: stage, name: name }])=>`Etape de construction '${i18n.game.build_stage.lookup(stage)}' sur le ${target} "${name}"`
        },
        move: {
            'move.complete': ([d])=>`D\xe9placement vers ${i18n.game.dir.article_le(d)}${i18n.game.dir[d]}`
        },
        vehicle: {
            'vehicle.embark': ([, n])=>`Embarquement \xe0 bord de "${n}"`,
            'vehicle.disembark': ([, n])=>`D\xe9barquement de "${n}"`,
            'vehicle.drive.complete': ([d, n])=>`D\xe9placement de "${n}" vers ${i18n.game.dir.article_le(d)}${i18n.game.dir[d]}`,
            'vehicle.transfer.bag': ([{ add: add, del: del }])=>'Transfert:' + (add && add.length > 0 ? `<br>Vers le sac :"${i18n.game.bargain.print_content(add)}"` : '') + (del && del.length > 0 ? `<br>Vers la cale :"${i18n.game.bargain.print_content(del)}"` : ''),
            'vehicle.kick.out': ([, n, t, , c])=>`Vous avez d\xe9barqu\xe9 de force "${c}" du ${t} "${n}"`,
            'vehicle.equip.item': ([p, n])=>`Equipement de '${i18n.game.item.present(p)}' sur '${n}'`,
            'vehicle.unequip.item': ([p, n])=>`Rangement de '${i18n.game.item.present(p)}' sur '${n}'`
        },
        access: {
            'access.ask': ([, t, n])=>`Demande d'acc\xe8s au ${t} "${n}".`,
            'access.accept': ([, t, n, b])=>`Acc\xe8s accord\xe9 par "${b}" au ${t} "${n}".`,
            'access.reject': ([, t, n, b, x])=>`Acc\xe8s rejet\xe9 par "${b}" au ${t} "${n}"${x ? ' (et mise en liste noire)' : ''}.`,
            'access.remove': ([, t, n, b])=>`Acc\xe8s retir\xe9 par "${b}" au ${t} "${n}".`,
            'access.blacklist': ([, t, n, b])=>`Mise en liste noire par "${b}" sur le ${t} "${n}".`,
            'access.unblacklist': ([, t, n, b])=>`Retrait de la liste noire par "${b}" sur le ${t} "${n}".`,
            'access.change-rank': ([, t, n, b, o, r])=>`Rang pour le ${t} "${n}" changer de "${i18n.game.map.vehicle.access.ranks[o]}" \xe0 "${i18n.game.map.vehicle.access.ranks[r]}" par "${b}"`
        },
        skill_rx: /^skill\.(.*)\.level\.up$/,
        skill_type: {
            lookup: (t)=>t in i18n.game.history.skill_type ? i18n.game.history.skill_type[t] : t,
            collect: 'Ramassage/Cueillette',
            'collect.wood': 'Ramassage du bois',
            'collect.linen': 'Ramassage du lin',
            'collect.fruit': 'Cueillette de fruits',
            'collect.pebble': 'Ramassage de galets',
            'collect.reed': 'Ramassage de roseaux',
            'collect.stone': 'Ramassage de roche',
            'collect.egg': 'Ramassage d\'oeuf',
            hunt: "Chasse/P\xeache",
            'hunt.sling': "Chasse \xe0 la fronde",
            'hunt.bow': "Chasse \xe0 l'arc",
            'hunt.harpoon': "P\xeache au harpon",
            craft: 'Fabrication',
            'craft.string': 'Fabrication de cordage',
            'craft.arrow': "Fabrication de fl\xe8che",
            'craft.pebble': 'Fabrication de galet',
            transform: 'Transformation',
            'transform.rabbit': 'Transformation de lapin',
            'transform.duck': 'Transformation de canard',
            'transform.fowl': 'Transformation de faisan'
        },
        skill: (l, [p])=>{
            const s = l.replace(i18n.game.history.skill_rx, ($0, $1)=>$1);
            // TODO inspect this code
            if (i18n.game.history.skill_type.lookup(s) === s) console.log(s, p, i18n.game.history.skill_rx.test(l));
            return `Progression au niveau ${p} en ${i18n.game.history.skill_type.lookup(s)}`;
        },
        team: {
            'team.join': ([, n, t, j, i])=>`Rejoint l'\xe9quipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,
            'team.leave': ([, n, t, j, i])=>`Quitte l'\xe9quipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,
            'team.add.lead': ([, n, t, j, i, b])=>`Ajoute ${b} de l'\xe9quipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,
            'team.add.by': ([, n, t, j, i, b])=>`Ajout\xe9 par ${b} de l'\xe9quipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,
            'team.remove.lead': ([, n, t, j, i, b])=>`Retire ${b} de l'\xe9quipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,
            'team.remove.by': ([, n, t, j, i, b])=>`Retir\xe9 par ${b} de l'\xe9quipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,
            'team.leader.lead': ([, n, t, j, i, _, b, s])=>`Commandement ${s ? "donn\xe9" : "retir\xe9"} \xe0 ${b} pour l'\xe9quipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,
            'team.leader.by': ([, n, t, j, i, _, b, s])=>`Commandement ${s ? "donn\xe9" : "retir\xe9"} par ${b} pour l'\xe9quipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`
        },
        job: {
            'job.fishing.success': ([p])=>{
                const r = {
                    ...p
                };
                delete r.kill;
                const { res: res } = r;
                delete r.res;
                const prises = Object.entries(res).map(([k, n])=>i18n.game.item.lookup(k) + ' (' + n + ')');
                const pertes = Object.entries(r).filter(([, n])=>n > 0).map(([t, n])=>i18n.game.item.present({
                        t: t,
                        n: n
                    }));
                return `P\xeache r\xe9ussie. Prises: ${prises.join(', ')}.${pertes.length > 0 ? ` Pertes : ${pertes.join(', ')}.` : ''}`;
            },
            'job.fishing.failure': ([r])=>{
                const pertes = Object.entries(r).filter(([, n])=>n > 0).map(([t, n])=>i18n.game.item.present({
                        t: t,
                        n: n
                    }));
                return `P\xeache infructueuse.${pertes.length > 0 ? ` Pertes : ${pertes.join(', ')}.` : ''}`;
            }
        },
        teleport: {
            'teleport.complete': "T\xe9l\xe9portation..."
        }
    };
    i18n.game.invalid = {
        'character.eat.not.available': ()=>"Impossible de manger, le personnage est d\xe9j\xe0 occup\xe9.",
        'collect.start.character.not.available': ()=>"Ramassage/Cueillette impossible, le personnage est d\xe9j\xe0 occup\xe9.",
        'craft.start.character.not.available': ()=>"Fabrication impossible, le personnage est d\xe9j\xe0 occup\xe9.",
        'hunt.start.character.not.available': ()=>"Chasse/P\xeache impossible, le personnage est d\xe9j\xe0 occup\xe9.",
        'move.start.character.not.available': ()=>"D\xe9placement impossible, le personnage est d\xe9j\xe0 occup\xe9.",
        'transform.start.character.not.available': ()=>"Transformation impossible, le personnage est d\xe9j\xe0 occup\xe9.",
        'character.unequip.cannot.working.with': ([p])=>`Impossible de ranger un outil en cours d'usage: "${i18n.game.item.lookup(p.t)}"`,
        'collect.start.character.has.not.enough.energy': ()=>"Ramassage/Cueillette impossible, votre personnage manque d'\xe9nergie.",
        'collect.start.equipped.does.not.have.tool': ([tool])=>`Ramassage/Cueillette impossible, outil manquant: ${i18n.game.item.lookup(tool.t ?? tool)}.`,
        'craft.start.character.has.not.enough.energy': ()=>"Fabrication impossible, votre personnage manque d'\xe9nergie.",
        'hunt.start.character.has.not.enough.energy': ()=>"Chasse/P\xeache impossible, votre personnage manque d'\xe9nergie.",
        'move.start.character.has.not.enough.energy': ()=>"D\xe9placement impossible, votre personnage manque d'\xe9nergie.",
        'transform.start.character.has.not.enough.energy': ()=>"Transformation impossible, votre personnage manque d'\xe9nergie.",
        'move.start.target.terrain.invalid': ([d])=>`D\xe9placement impossible vers ${i18n.game.dir.article_le(d)}${i18n.game.dir[d]}`,
        'move.start.target.coord.should.not.be.identical': ()=>"D\xe9placement sur place impossible.",
        'move.start.character.not.outside': ()=>"D\xe9placement impossible quand embarqu\xe9",
        'craft.start.equipped.does.not.have.tool': ([t, , tool])=>`Fabrication de "${i18n.game.item.lookup(t)}" impossible un outil est n\xe9cessaire: ${i18n.game.item.lookup(tool)}`,
        'craft.start.bag.does.not.have.material': ([t, , , o])=>`Fabrication de "${i18n.game.item.lookup(t)}" impossible, mat\xe9riau manquant dans le sac: ${i18n.game.item.present(o)}`,
        'craft.start.item.must.be.in.bag': ([t, , , o])=>`Fabrication de "${i18n.game.item.lookup(t)}" impossible, d\xe9placez d'abord dans le sac: ${i18n.game.item.present(o)}`,
        'craft.start.cannot.with.bargained.item': ([t, , , o, b, n])=>`Fabrication de "${i18n.game.item.lookup(t)}" impossible car un \xe9l\xe9ment est inclus dans ${b === 1 ? 'une transaction' : b + ' transactions'}: ${i18n.game.item.present(o)}`,
        'transform.start.equipped.does.not.have.tool': ([tool])=>`Transformation impossible, outil manquant: ${i18n.game.item.lookup(tool.t ?? tool)}.`,
        'transform.start.material.must.be.moved.in.bag': ([item])=>`Transformation impossible, rangez d'abord dans le sac: ${i18n.game.item.present(item)}`,
        'transform.start.bag.does.not.have.item': ([item])=>`Transformation impossible, objet absent du sac: ${i18n.game.item.present(item)}`,
        'transform.start.cannot.with.bargained.item': ([item, , , o, b])=>`Transformation de "${i18n.game.item.lookup(item.t ?? item)}" impossible car un \xe9l\xe9ment est inclus dans ${b === 1 ? 'une transaction' : b + ' transactions'}: ${i18n.game.item.present(o)}`,
        'bargain.accept.must.be.on.same.coord': ()=>"Acceptation de troc possible uniquement si les participants sont au m\xeame endroi.",
        'bargain.accept.cannot.do.if.already.accepted.by.oneself': ([other])=>`Vous avez d\xe9j\xe0 accept\xe9 ce troc. Attendez la r\xe9ponse de ${other}.`,
        'build.storage.does.not.have.material': ([, k])=>`Materiaux de construction indisponible: ${i18n.game.item.lookup(k)}`,
        'build.storage.does.not.have.enough.material': ([, k, i, n])=>`Materiaux de construction insuffisant: ${i18n.game.item.lookup(k)} (${i}/${n}) `,
        'build.init.name.empty': ()=>"Impossible de d\xe9marrer un chantier : le nom est vide.",
        'build.init.character.not.available': ()=>"Impossible de d\xe9marrer un chantier, le personnage est d\xe9j\xe0 occup\xe9.",
        'build.invalid.location': ()=>'Emplacement invalide pour ce chantier.',
        'build.invalid.settlement.already.exists.here': ()=>"Un lieu d'habitation existe d\xe9j\xe0 \xe0 cet endroit.",
        'build.invalid.settlement.already.exists.in_radius': ()=>"Un lieu d'habitation existe d\xe9j\xe0 trop pr\xe8s.",
        'build.invalid.infrastructure.already.exists.here': ([t])=>`${i18n.game.construct.article.lookup(t)}${i18n.game.construct.lookup(t)} existe d\xe9j\xe0 \xe0 cet endroit.`,
        'build.invalid.infrastructure.already.exists.in_radius': ([t])=>`${i18n.game.construct.article.lookup(t)}${i18n.game.construct.lookup(t)} existe d\xe9j\xe0 trop pr\xe8s.`,
        'build.invalid.get.stage.name': ([stage])=>`\xc9tape de construction inconnue : "${stage}".`,
        'build.invalid.is.last.stage.name': ([stage])=>`\xc9tape "${i18n.game.construct.build_stage.lookup(stage)}" : erreur interne (derni\xe8re \xe9tape).`,
        'build.invalid.next.stage.name': ([stage])=>`\xc9tape "${i18n.game.construct.build_stage.lookup(stage)}" : pas d'\xe9tape suivante.`,
        'build.invalid.stage': ([stage])=>`Impossible de travailler sur l'\xe9tape "${i18n.game.construct.build_stage.lookup(stage)}" : ce n'est pas l'\xe9tape en cours.`,
        'build.invalid.stage.construct': ([s])=>{
            const stage = s?.state?.stage?.name ?? s?.stage?.name;
            return stage ? `L'\xe9tape en cours est "${i18n.game.construct.build_stage.lookup(stage)}", pas celle demand\xe9e.` : "L'\xe9tape demand\xe9e ne correspond pas \xe0 l'\xe9tape en cours du chantier.";
        },
        'build.invalid.stage.construct.already.finished': ([s])=>{
            const stage = s?.state?.stage?.name ?? s?.stage?.name;
            return stage ? `L'\xe9tape "${i18n.game.construct.build_stage.lookup(stage)}" est d\xe9j\xe0 termin\xe9e.` : "Cette \xe9tape de construction est d\xe9j\xe0 termin\xe9e.";
        },
        'build.invalid.stage.construct.stage.step.complete': ()=>"Impossible de d\xe9marrer cette \xe9tape : tous les cr\xe9neaux de travail sont d\xe9j\xe0 occup\xe9s.",
        'build.from.not.defined': ([k])=>`Mat\xe9riau de construction non d\xe9fini : ${i18n.game.item.lookup(k)}.`,
        'build.target.not.defined': ([t])=>`Type de construction non d\xe9fini : ${t}.`,
        'build.status.set.invalid.status': ([status])=>`Statut de chantier invalide : ${status}.`,
        'build.provide.character.cannot.access': ()=>"Apport de mat\xe9riaux impossible : acc\xe8s refus\xe9 au chantier.",
        'build.provide.character.not.available': ()=>"Apport de mat\xe9riaux impossible, le personnage est d\xe9j\xe0 occup\xe9.",
        'build.provide.content.cannot.be.empty': ()=>"Apport de mat\xe9riaux impossible : rien \xe0 d\xe9poser.",
        'build.provide.cannot.if.equipped': ([items])=>`Apport impossible : retirez d'abord l'objet \xe9quip\xe9 (${items.map(i18n.game.item.present).join(', ')}).`,
        'build.provide.cannot.if.not.enough.in.bag': ([items])=>`Apport impossible, quantit\xe9 insuffisante dans le sac : ${items.map(i18n.game.item.present).join(', ')}.`,
        'job.cultivate.tool.not.equipped': ([tool])=>`${i18n.game.map.vehicle.job.actions.lookup('cultivate')} impossible, outil manquant : ${i18n.game.item.lookup(tool)}.`,
        'job.cultivate.getFrom.not.enough': ([itemType, qty])=>`${i18n.game.map.vehicle.job.actions.lookup('cultivate')} impossible, ${i18n.game.item.lookup(itemType)} insuffisant (${qty} requis).`,
        'job.livestock.tool.not.equipped': ([tool])=>`${i18n.game.map.vehicle.job.actions.lookup('livestock')} impossible, outil manquant : ${i18n.game.item.lookup(tool)}.`,
        'job.install.tool.not.equipped': ([tool])=>`${i18n.game.map.vehicle.job.actions.lookup('install')} impossible, outil manquant : ${i18n.game.item.lookup(tool)}.`,
        'job.install.getFrom.not.enough': ([itemType, qty])=>`${i18n.game.map.vehicle.job.actions.lookup('install')} impossible, ${i18n.game.item.lookup(itemType)} insuffisant (${qty} requis).`,
        'job.destroy.tool.not.equipped': ([tool])=>`${i18n.game.map.vehicle.job.actions.lookup('destroy')} impossible, outil manquant : ${i18n.game.item.lookup(tool)}.`,
        'job.bake.getFrom.fuel.not.found': ([fuel])=>`${i18n.game.map.vehicle.job.actions.lookup('bake')} impossible, combustible manquant dans le stock : ${i18n.game.item.lookup(fuel)}.`,
        'job.bake.getFrom.fuel.not.enough': ([fuel, qty])=>`${i18n.game.map.vehicle.job.actions.lookup('bake')} impossible, ${i18n.game.item.lookup(fuel)} insuffisant (${qty} requis).`,
        'job.bake.getFrom.from.not.found': ([itemType])=>`${i18n.game.map.vehicle.job.actions.lookup('bake')} impossible, mati\xe8re manquante dans le stock : ${i18n.game.item.lookup(itemType)}.`,
        'job.bake.getFrom.from.not.enough': ([itemType])=>`${i18n.game.map.vehicle.job.actions.lookup('bake')} impossible, ${i18n.game.item.lookup(itemType)} insuffisant.`,
        'job.bake.check.from.not.found': ()=>`${i18n.game.map.vehicle.job.actions.lookup('bake')} impossible, mat\xe9riaux manquants dans le stock.`,
        'build.start.character.cannot.access': ([, n])=>`Participation au chantier "${n}" impossible : acc\xe8s refus\xe9.`,
        'build.start.character.not.available': ()=>"Participation au chantier impossible, le personnage est d\xe9j\xe0 occup\xe9.",
        'build.start.character.not.at.construct': ([, n])=>`Participation au chantier "${n}" impossible : vous devez \xeatre sur place.`,
        'build.start.character.rank.not.sufficient': ([, n, r])=>`Rang "${i18n.game.map.vehicle.access.ranks[r]}" insuffisant pour participer au chantier de "${n}"`,
        'build.done.is.not.worker': ()=>"Erreur interne : fin de chantier r\xe9serv\xe9e au worker.",
        'build.done.is.not.finished': ([stage, constructId])=>`Erreur interne : travail non termin\xe9 (\xe9tape ${stage}, chantier ${constructId}).`,
        'vehicle.disembark.must.be.on.land': ()=>"Vous devez \xeatre \xe0 terre pour d\xe9barquer",
        'vehicle.embark.character.cannot.access': ([, n])=>`Embarquement impossible sur "${n}": Acc\xe8s refus\xe9.`,
        'vehicle.move.target.terrain.invalid': ([d])=>`D\xe9placement impossible vers ${i18n.game.dir.article_le(d)}${i18n.game.dir[d]}`,
        'vehicle.move.character.rank.not.sufficient': ([, t, r])=>`Rang "${i18n.game.map.vehicle.access.ranks[r]}" insuffisant pour conduire le ${t}.`,
        'vehicle.kick.must.be.on.land': ()=>"Vous devez \xeatre \xe0 terre pour d\xe9barquer",
        'vehicle.kick.character.rank.not.sufficient': ([, r, n, s])=>`Rang "${i18n.game.map.vehicle.access.ranks[r]}" insuffissant: Impossible de d\xe9barquer de force "${n}" de rang "${i18n.game.map.vehicle.access.ranks[s]}"`
    };
}

});

parcelRegister("4XVaH", function(module, exports) {

$parcel$export(module.exports, "defineModal", () => $39d90537ff897027$export$9fb53a59701820f6);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2025
 */ function $39d90537ff897027$export$9fb53a59701820f6(i18n) {
    i18n.modal = {};
    i18n.modal.logout_confirmation = 'Etes-vous sur de vouloir quitter le jeux ?';
    i18n.modal.confirm = 'Confirmer';
    i18n.modal.cancel = 'Annuler';
    i18n.modal.close = 'Fermer';
    i18n.modal.test = 'Test';
}

});

parcelRegister("hkt5c", function(module, exports) {

$parcel$export(module.exports, "defineOnboarding", () => $c9dadd2e3ea45cd2$export$6c78af22ec9b9f91);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2025
 */ function $c9dadd2e3ea45cd2$export$6c78af22ec9b9f91(i18n) {
    i18n.onboarding = {};
    i18n.onboarding.facerandom = 'Nouveau visage';
    i18n.onboarding.fullsize = 'Pleine taille';
    i18n.onboarding.return = 'Revenir';
    i18n.onboarding.continue = 'Continuer';
    i18n.onboarding.submit = 'Terminer';
    i18n.onboarding.name_please = 'Veuillez choisir un nom.';
    i18n.onboarding.name_not_conform = 'Veuillez choisir un nom comportant uniquement des lettres.';
    i18n.onboarding.choose_name = 'Choisis ton nom';
    i18n.onboarding.choose_description = "D\xe9cris-toi en quelques mots (facultatif)";
    i18n.onboarding.email = 'Email';
    i18n.onboarding.password = 'Mot de passe';
    i18n.onboarding.see_password = 'Voir le mot de passe';
    i18n.onboarding.error = {};
    i18n.onboarding.error.email = 'Veuillez saisir une adresse email.';
    i18n.onboarding.error.email_correct = 'Veuillez saisir une adresse email correcte.';
    i18n.onboarding.error.password = 'Veuillez saisir un mot de passe.';
    i18n.onboarding.error.password_correct = 'Veuillez saisir un mot de passe respectant les conditions.';
    i18n.onboarding.error.both = 'Veuillez saisir votre adresse email et votre mot de passe.';
    i18n.onboarding.password_requirement = {};
    i18n.onboarding.password_requirement.min8 = "Minimum 8 caract\xe8res";
    i18n.onboarding.password_requirement.letter = 'Une lettre (majuscule ou minuscule)';
    i18n.onboarding.password_requirement.digit = 'Un chiffre';
    i18n.onboarding.password_requirement.special = "Un caract\xe8re special (.:;,?!@#$%^&*+_/'\"{}()[] -)";
}

});

parcelRegister("9bXwx", function(module, exports) {

$parcel$export(module.exports, "defineRegister", () => $6b13505843aea079$export$56c6df47e86f5e49);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2025
 */ function $6b13505843aea079$export$56c6df47e86f5e49(i18n) {
    i18n.register = {};
    i18n.register.invalid_passwd = 'Mot de passe invalide';
}

});


parcelRegister("fFqMn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b67f752dc3e83b21$export$2e2bcd8739ae039);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2022
 */ class $b67f752dc3e83b21$export$2e2bcd8739ae039 {
    static UPDATE = 'face-update';
    static POST_UPDATE = 'face-post-update';
    constructor({ hair: hair, face: face, eyebrows: eyebrows, eyes: eyes, nose: nose, mouth: mouth, body: body }){
        this.data = {
            hair: hair,
            face: face,
            eyebrows: eyebrows,
            eyes: eyes,
            nose: nose,
            mouth: mouth,
            body: body
        };
    }
    static init(eventBus) {
        const input = document.getElementById('onboarding-face');
        const x = $b67f752dc3e83b21$export$2e2bcd8739ae039.parse(input.value);
        if (x) $b67f752dc3e83b21$export$2e2bcd8739ae039.singleton = new $b67f752dc3e83b21$export$2e2bcd8739ae039(x);
        else $b67f752dc3e83b21$export$2e2bcd8739ae039.singleton = new $b67f752dc3e83b21$export$2e2bcd8739ae039($b67f752dc3e83b21$export$2e2bcd8739ae039.changes());
        eventBus.on($b67f752dc3e83b21$export$2e2bcd8739ae039.constructor.name, $b67f752dc3e83b21$export$2e2bcd8739ae039.UPDATE, (changes, cb)=>{
            for (const [k, v] of Object.entries(changes))$b67f752dc3e83b21$export$2e2bcd8739ae039.singleton.data[k] = v;
            input.value = $b67f752dc3e83b21$export$2e2bcd8739ae039.singleton.toHash();
            if (cb) cb(input.value);
        });
    }
    static parse(input) {
        const x = /^h(\d)-f(\d)-b(\d)-e(\d)-n(\d)-m(\d)-o(\d)$/.exec(input);
        if (x) {
            const [hair, face, eyebrows, eyes, nose, mouth, body] = x.slice(1).map((v)=>+v);
            return {
                hair: hair,
                face: face,
                eyebrows: eyebrows,
                eyes: eyes,
                nose: nose,
                mouth: mouth,
                body: body
            };
        }
    }
    static get(part) {
        if (part) return $b67f752dc3e83b21$export$2e2bcd8739ae039.singleton.data[part];
        else return $b67f752dc3e83b21$export$2e2bcd8739ae039.singleton.data;
    }
    static changes() {
        const r = ()=>Math.floor(Math.random() * 4);
        const s = ()=>Math.floor(Math.random() * 2);
        return {
            hair: r(),
            face: r(),
            eyebrows: r(),
            eyes: r(),
            nose: r(),
            mouth: r(),
            body: s()
        };
    }
    toHash() {
        const { hair: hair, face: face, eyebrows: eyebrows, eyes: eyes, nose: nose, mouth: mouth, body: body } = this.data;
        return `h${hair}-f${face}-b${eyebrows}-e${eyes}-n${nose}-m${mouth}-o${body}`;
    }
}

});

parcelRegister("8Fiu8", function(module, exports) {

$parcel$export(module.exports, "default", () => $64f07dceb6be7081$export$2e2bcd8739ae039);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2022
 */ // JSDocs
// eslint-disable-next-line no-unused-vars
parcelRequire("fFqMn");
parcelRequire("bKDSB");
var $cFF3j = parcelRequire("cFF3j");

var $7yrld = parcelRequire("7yrld");
const $64f07dceb6be7081$var$DEBUG = false;
class $64f07dceb6be7081$export$2e2bcd8739ae039 {
    static WIDTH = 100;
    static HEIGHT = 150;
    static CENTER = $64f07dceb6be7081$export$2e2bcd8739ae039.WIDTH / 2;
    static TOP_SHIFT = 20;
    static TOP_SHIFT_EARS = 12;
    static TOP_SHIFT_NECK = 70;
    static TOP_SHIFT_EYEBROWS = 31;
    static TOP_SHIFT_EYES = 38;
    static TOP_SHIFT_NOSE = 50;
    static TOP_SHIFT_MOUTH = 65;
    /**
   * Draw a Portrait, according to given faceConfig
   * @param {CanvasRenderingContext2D} ctx
   * @param {FaceConfig} faceConfig
   * @param {number} ratio
   * @param {{ top:number, left:number }} position
   */ drawPortrait(ctx, faceConfig, ratio, position) {
        this.drawConfigWithBody(ctx, faceConfig, ratio, ()=>{
            this.drawNeck(ctx, faceConfig.face, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_NECK, position);
        // FaceShape.underwearTop.forEach(([s, p]) => {
        //   this.drawSymmetricShape(ctx, p, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_NECK + s, {
        //     fillStyle: 'white', //'rgba(255,255,255,0.5)',
        //     strokeStyle: 'black',
        //     lineWidth: .25 * ratio
        //   }, position)
        // })
        }, position);
    }
    /**
   * Draw a Portrait, according to given faceConfig
   * @param {CanvasRenderingContext2D} ctx
   * @param {FaceConfig} faceConfig
   * @param {number} ratio
   * @param {{ top:number, left:number, radius:number, shiftTop:number, shiftLeft:number }} position
   */ drawMedalPortrait(ctx, faceConfig, ratio, position, debug) {
        ctx.beginPath();
        const radius = position.radius || 1;
        const shiftTop = position.shiftTop || 1;
        const shiftLeft = position.shiftLeft || 1;
        ctx.arc(ratio * 60 + shiftLeft, ratio * 60 + shiftTop, ratio * radius * 55, 0, Math.PI * 2);
        ctx.fillStyle = 'silver';
        ctx.strokeStyle = 'black';
        ctx.lineWidth = ratio * 2;
        ctx.fill();
        ctx.stroke();
        ctx.clip();
        this.drawConfigWithBody(ctx, faceConfig, ratio, ()=>{
            this.drawBodyAndUnderwear(ctx, faceConfig.body, ratio, position, debug);
        }, position);
    }
    /**
   * Draw a Head, without , according to given faceConfig
   * @param {CanvasRenderingContext2D} ctx
   * @param {FaceConfig} faceConfig
   * @param {number} ratio
   * @param {()=>{}} body
   * @param {{ top:number, left:number }} position
   */ drawConfigWithBody(ctx, faceConfig, ratio, body, position = {
        left: 0,
        top: 0
    }) {
        this.drawBackHair(ctx, faceConfig.hair, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT, position);
        this.drawEars(ctx, faceConfig.face, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_EARS, position);
        if (body && typeof body === 'function') body();
        this.drawFaceContour(ctx, faceConfig.face, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT, position);
        this.drawEyebrows(ctx, faceConfig.eyebrows, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_EYEBROWS, position);
        this.drawEyes(ctx, faceConfig.eyes, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_EYES, position);
        this.drawNose(ctx, faceConfig.nose, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_NOSE, 0, position);
        this.drawMouth(ctx, faceConfig.mouth, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_MOUTH, 0, position);
        this.drawFrontHair(ctx, faceConfig.hair, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT, position);
    }
    /**
   * Draw a Chibi body, according to given faceConfig
   * @param {CanvasRenderingContext2D} ctx
   * @param {FaceConfig} faceConfig
   * @param {number} ratio
   * @param {{ top:number, left:number }} position
   */ drawChibiBody(ctx, bodyConfig, ratio, position = {
        left: 0,
        top: 0
    }, debug) {
        this.drawConfigWithBody(ctx, bodyConfig, ratio, ()=>{
            const style = {
                fillStyle: 'silver',
                strokeStyle: 'black',
                lineWidth: 1
            };
            const bodyShape = [
                [
                    0,
                    0
                ],
                [
                    4,
                    0
                ],
                [
                    4,
                    15
                ],
                [
                    12,
                    17
                ],
                [
                    40,
                    12
                ],
                [
                    40,
                    17
                ],
                [
                    12,
                    22
                ],
                [
                    15,
                    50
                ]
            ];
            const legShape = !bodyConfig.canoe ? [
                [
                    0,
                    50
                ],
                [
                    10,
                    50
                ],
                [
                    10,
                    70
                ]
            ] : [
                [
                    0,
                    50
                ],
                [
                    60,
                    45
                ],
                [
                    80,
                    40
                ],
                [
                    75,
                    60
                ],
                [
                    60,
                    70
                ]
            ];
            this.drawSymmetricShape(ctx, legShape, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_NECK, style, position, debug);
            this.drawSymmetricShape(ctx, bodyShape, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_NECK, style, position, debug);
        }, position);
    }
    /**
   * Draw a FullSize body, according to given faceConfig
   * @param {CanvasRenderingContext2D} ctx
   * @param {FaceConfig} faceConfig
   * @param {number} ratio
   * @param {{ top:number, left:number }} position
   */ drawFullSizeBody(ctx, bodyConfig, ratio, position = {
        left: 0,
        top: 0
    }, debug) {
        this.drawConfigWithBody(ctx, bodyConfig, ratio, ()=>{
            this.drawBodyAndUnderwear(ctx, bodyConfig.body, ratio, position, debug);
        }, position);
    /*
    if< (DEBUG || debug) {
      const SHIFT = 25
        , INTERVAL = 25
        , UNSHIFT = 90
      for (let i = 0; i < 50; i++) {
        ctx.strokeStyle = i % 2 === 0 ? 'silver' : 'gray'
        ctx.beginPath()
        ctx.setLineDash([5, 15])
        const noratio = i * INTERVAL + SHIFT
        const vertical = ratio * noratio
        ctx.moveTo(0, vertical)
        ctx.lineTo(100, vertical)
        ctx.stroke()
        ctx.font = '9px serif'
        ctx.fillText(noratio - UNSHIFT, 20, vertical - 5)
      }
    }
    */ }
    drawBodyOnly(ctx, type, ratio, position, debug) {
        (0, $7yrld.default).bodyShape[type].forEach(([s, p])=>{
            this.drawSymmetricShape(ctx, p, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_NECK + s, {
                fillStyle: 'white',
                strokeStyle: 'black',
                lineWidth: 0.25 * ratio
            }, position, debug);
        });
    }
    drawBodyAndUnderwear(ctx, type, ratio, position, debug) {
        (0, $7yrld.default).bodyShape[type].forEach(([s, p])=>{
            this.drawSymmetricShape(ctx, p, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_NECK + s, {
                fillStyle: 'white',
                strokeStyle: 'black',
                lineWidth: 0.25 * ratio
            }, position, debug);
        });
        if (type === 0) /*
      FaceShape.swimSuit.forEach(([s, p]) => {
        this.drawSymmetricShape(ctx, p, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_NECK + s, {
          fillStyle: 'gray', // 'rgba(255,255,255,0.5)',
          strokeStyle: 'black',
          lineWidth: 0.25 * ratio
        }, position, debug)
      })
      // */ //*
        (0, $7yrld.default).underwearDress.forEach(([s, p])=>{
            this.drawSymmetricShape(ctx, p, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_NECK + s, {
                fillStyle: 'silver',
                strokeStyle: 'black',
                lineWidth: 0.25 * ratio
            }, position, debug);
        });
        else (0, $7yrld.default).underwearBottom.forEach(([s, p])=>{
            this.drawSymmetricShape(ctx, p, ratio, $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_NECK + s, {
                fillStyle: 'silver',
                strokeStyle: 'black',
                lineWidth: 0.25 * ratio
            }, position, debug);
        });
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   */ clean(ctx, ratio) {
        ctx.clearRect(0, 0, ratio * $64f07dceb6be7081$export$2e2bcd8739ae039.WIDTH, ratio * $64f07dceb6be7081$export$2e2bcd8739ae039.HEIGHT);
    }
    cleanAll(ctx) {
        ctx.reset();
    // ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   * @param {number} marginTop
   */ drawShape(ctx, shape, ratio, marginTop, drift = 0, style = {}, position = {
        left: 0,
        top: 0
    }) {
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.strokeStyle = style.strokeStyle || 'black';
        ctx.fillStyle = style.fillStyle || 'white';
        ctx.lineWidth = (style.lineWidth || 0.25) * ratio;
        ctx.beginPath();
        const [x0, y0] = shape[0];
        ctx.moveTo(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + drift + x0) + position.left, ratio * (marginTop + y0) + position.top);
        shape.slice(1).forEach(([x, y])=>{
            ctx.lineTo(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + drift + x) + position.left, ratio * (marginTop + y) + position.top);
        });
        ctx.fill();
        ctx.stroke();
        if ($64f07dceb6be7081$var$DEBUG) {
            ctx.fillStyle = style.strokeStyle || 'blue';
            shape.forEach(([x, y])=>{
                ctx.fillRect(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + drift + x - 0.5) + position.left, ratio * (marginTop + y - 0.5) + position.top, ratio, ratio);
            });
        }
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number[][][]} shapes
   * @param {number} ratio
   * @param {number} marginTop
   * @param {number} drift
   * @param {*} style
   */ drawMultiShape(ctx, shapes, ratio, marginTop, drift, style = {}, position = {
        left: 0,
        top: 0
    }) {
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.fillStyle = style.fillStyle || 'black';
        ctx.strokeStyle = style.strokeStyle || 'black';
        ctx.lineWidth = (style.lineWidth || 0.25) * ratio;
        shapes.forEach((p)=>{
            ctx.beginPath();
            ctx.moveTo(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + drift + p[0][0]) + position.left, ratio * (marginTop + p[0][1]) + position.top);
            p.slice(1).forEach(([x, y])=>{
                ctx.lineTo(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + drift + x) + position.left, ratio * (marginTop + y) + position.top);
            });
            ctx.fill();
            ctx.stroke();
        });
        if ($64f07dceb6be7081$var$DEBUG) {
            ctx.fillStyle = style.strokeStyle || 'blue';
            shapes.forEach((p)=>{
                p.forEach(([x, y])=>{
                    ctx.fillRect(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + drift + x - 0.5) + position.left, ratio * (marginTop + y - 0.5) + position.top, ratio, ratio);
                });
            });
        }
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number[][]} shape
   * @param {number} ratio
   * @param {number} marginTop
   * @param {*} style
   */ drawSymmetricShape(ctx, shape, ratio, marginTop, style = {}, position = {
        left: 0,
        top: 0
    }, debug = false) {
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.strokeStyle = style.strokeStyle || 'black';
        ctx.fillStyle = style.fillStyle || 'black';
        ctx.lineWidth = (style.lineWidth || 0.25) * ratio;
        ctx.beginPath();
        ctx.moveTo(ratio * $64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + position.left, ratio * marginTop + position.top);
        const fullShape = shape.concat(shape.slice().reverse().map((0, $cFF3j.mirror)));
        fullShape.forEach(([x, y])=>{
            ctx.lineTo(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + x) + position.left, ratio * (marginTop + y) + position.top);
        });
        ctx.lineTo(ratio * $64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + position.left, ratio * marginTop + position.top);
        ctx.fill();
        ctx.stroke();
        if ($64f07dceb6be7081$var$DEBUG || debug) {
            ctx.fillStyle = 'cyan';
            fullShape.forEach(([x, y, ...r])=>{
                if (r.length) {
                    const f = ctx.fillStyle;
                    ctx.fillStyle = r[0];
                    const size = r.length > 1 ? r[1] : 2;
                    ctx.fillRect(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + x - size / 2) + position.left, ratio * (marginTop + y - size / 2) + position.top, ratio * size, ratio * size);
                    ctx.fillStyle = f;
                } else ctx.fillRect(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + x - 0.5) + position.left, ratio * (marginTop + y - 0.5) + position.top, ratio, ratio);
            });
        }
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   */ drawHairOnly(ctx, type, ratio, marginTop, position = {
        left: 0,
        top: 0
    }) {
        this.drawBackHair(ctx, type, ratio, marginTop, position);
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.fillStyle = 'rgba(200, 200, 200, 0.5)';
        ctx.lineWidth = 0.25 * ratio;
        ctx.beginPath();
        ctx.arc(ratio * $64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + position.left, ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER - 10) + position.top, ratio * 30, 0, 2 * Math.PI);
        ctx.fill();
        this.drawFrontHair(ctx, type, ratio, marginTop, position);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   * @param {number} marginTop
   * @param {{ top:number, left:number }} position
   */ drawBackHair(ctx, type, ratio, marginTop, position = {
        left: 0,
        top: 0
    }) {
        this.drawMultiShape(ctx, (0, $7yrld.default).backHair[type], ratio, marginTop, 0, {
            fillStyle: $64f07dceb6be7081$var$DEBUG ? 'cyan' : 'black',
            strokeStyle: $64f07dceb6be7081$var$DEBUG ? 'blue' : 'gray',
            lineWidth: 0.5
        }, position);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   */ drawFrontHair(ctx, type, ratio, marginTop, position = {
        left: 0,
        top: 0
    }) {
        this.drawMultiShape(ctx, (0, $7yrld.default).frontHair[type], ratio, marginTop, 0, {
            fillStyle: $64f07dceb6be7081$var$DEBUG ? 'pink' : 'black',
            strokeStyle: $64f07dceb6be7081$var$DEBUG ? 'red' : 'gray',
            lineWidth: 0.5
        }, position);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   */ drawNoHairFace(ctx, type, ratio, marginTop, withNeck = true, position = {
        left: 0,
        top: 0
    }) {
        this.drawEars(ctx, type, ratio, marginTop + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_EARS, position);
        if (withNeck) this.drawNeck(ctx, type, ratio, marginTop + $64f07dceb6be7081$export$2e2bcd8739ae039.TOP_SHIFT_NECK, position);
        this.drawFaceContour(ctx, type, ratio, marginTop, position);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   */ drawFaceContour(ctx, type, ratio, marginTop, position = {
        left: 0,
        top: 0
    }) {
        this.drawSymmetricShape(ctx, (0, $7yrld.default).faces[type], ratio, marginTop, {
            strokeStyle: 'black',
            fillStyle: $64f07dceb6be7081$var$DEBUG ? 'rgba(255, 255, 255, .1)' : 'white'
        }, position);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   */ drawNeck(ctx, type, ratio, marginTop, position = {
        left: 0,
        top: 0
    }) {
        this.drawSymmetricShape(ctx, (0, $7yrld.default).necks[type], ratio, marginTop, {
            strokeStyle: $64f07dceb6be7081$var$DEBUG ? 'green' : 'black',
            fillStyle: $64f07dceb6be7081$var$DEBUG ? 'rgba(255, 255, 255, .1)' : 'white',
            lineWidth: 0.25 * ratio
        }, position);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number[][]} shape
   * @param {number} ratio
   * @param {number} marginTop
   * @param {number} gap
   */ drawEars(ctx, type, ratio, marginTop, position = {
        left: 0,
        top: 0
    }) {
        this.drawShape(ctx, (0, $7yrld.default).ears[type], ratio, marginTop, 0, {}, position);
        this.drawShape(ctx, (0, $7yrld.default).ears[type].map((0, $cFF3j.mirror)), ratio, marginTop, 0, {}, position);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number[][]} shape
   * @param {number} ratio
   * @param {number} marginTop
   * @param {number} gap
   */ drawEyebrows(ctx, type, ratio, marginTop, position = {
        left: 0,
        top: 0
    }) {
        const gap = 10;
        const style = {
            strokeStyle: $64f07dceb6be7081$var$DEBUG ? 'green' : 'black',
            fillStyle: $64f07dceb6be7081$var$DEBUG ? 'rgba(0, 0, 0, .1)' : 'black'
        };
        this.drawShape(ctx, (0, $7yrld.default).eyebrows[type], ratio, marginTop, gap / 2, style, position);
        this.drawShape(ctx, (0, $7yrld.default).eyebrows[type].map((0, $cFF3j.mirror)), ratio, marginTop, -gap / 2, style, position);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   * @param {number} marginTop
   */ drawEyes(ctx, type, ratio, marginTop, position = {
        left: 0,
        top: 0
    }) {
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.strokeStyle = 'black';
        ctx.fillStyle = 'white';
        ctx.lineWidth = 0.25 * ratio;
        const eyeShape = (0, $7yrld.default).eyes[type];
        /**
     * Left eye
     */ if ('back' in eyeShape) {
            ctx.fillStyle = 'black';
            eyeShape.back.forEach((c)=>{
                ctx.beginPath();
                c.forEach(([x, y])=>{
                    ctx.lineTo(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + x) + position.left, ratio * (marginTop + y) + position.top);
                });
                ctx.stroke();
                ctx.fill();
            });
            ctx.fillStyle = 'white';
        }
        eyeShape.contour.forEach((c)=>{
            ctx.beginPath();
            c.forEach(([x, y])=>{
                ctx.lineTo(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + x) + position.left, ratio * (marginTop + y) + position.top);
            });
            ctx.stroke();
            ctx.fill();
        });
        eyeShape.iris.forEach(([color, x, y, radius, startAngle, endAngle])=>{
            ctx.beginPath();
            ctx.arc(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER + x) + position.left, ratio * (marginTop + y) + position.top, ratio * radius, startAngle, endAngle);
            ctx.fillStyle = color;
            ctx.fill();
        });
        /**
     * Right eye
     */ if ('back' in eyeShape) {
            ctx.fillStyle = 'black';
            eyeShape.back.forEach((c)=>{
                ctx.beginPath();
                c.forEach(([x, y])=>{
                    ctx.lineTo(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER - x) + position.left, ratio * (marginTop + y) + position.top);
                });
                ctx.stroke();
                ctx.fill();
            });
            ctx.fillStyle = 'white';
        }
        eyeShape.contour.forEach((c)=>{
            ctx.beginPath();
            c.forEach(([x, y])=>{
                ctx.lineTo(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER - x) + position.left, ratio * (marginTop + y) + position.top);
            });
            ctx.stroke();
            ctx.fill();
        });
        eyeShape.iris.forEach(([color, x, y, radius, startAngle, endAngle])=>{
            ctx.beginPath();
            ctx.arc(ratio * ($64f07dceb6be7081$export$2e2bcd8739ae039.CENTER - eyeShape.shift + x) + position.left, ratio * (marginTop + y) + position.top, ratio * radius, startAngle, endAngle);
            ctx.fillStyle = color;
            ctx.fill();
        });
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   * @param {number} marginTop
   */ drawNose(ctx, type, ratio, marginTop, drift, position = {
        left: 0,
        top: 0
    }) {
        const style = {
            strokeStyle: $64f07dceb6be7081$var$DEBUG ? 'green' : 'black',
            fillStyle: $64f07dceb6be7081$var$DEBUG ? 'rgba(0, 0, 0, .1)' : 'black'
        };
        this.drawShape(ctx, (0, $7yrld.default).noses[type], ratio, marginTop, drift, style, position);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   * @param {number} marginTop
   */ drawMouth(ctx, type, ratio, marginTop, drift = 0, position = {
        left: 0,
        top: 0
    }) {
        const style = {
            strokeStyle: $64f07dceb6be7081$var$DEBUG ? 'green' : 'white',
            fillStyle: $64f07dceb6be7081$var$DEBUG ? 'rgba(0, 0, 0, .1)' : 'gray'
        };
        this.drawMultiShape(ctx, (0, $7yrld.default).mouths[type], ratio, marginTop, drift, style, position);
    }
}

});
parcelRegister("bKDSB", function(module, exports) {

$parcel$export(module.exports, "mirror", () => (parcelRequire("cFF3j")).mirror);
$parcel$export(module.exports, "mult", () => (parcelRequire("cFF3j")).mult);
$parcel$export(module.exports, "shift", () => (parcelRequire("cFF3j")).shift);
$parcel$export(module.exports, "MapDrawer", () => (parcelRequire("70uJv")).default);
$parcel$export(module.exports, "TILE_SIZE", () => (parcelRequire("70uJv")).TILE_SIZE);
$parcel$export(module.exports, "Matrix", () => (parcelRequire("g3KFB")).default);
$parcel$export(module.exports, "Message", () => (parcelRequire("5JETu")).default);
$parcel$export(module.exports, "Rank", () => (parcelRequire("kV9Y4")).Rank);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2021
 */ 
var $cFF3j = parcelRequire("cFF3j");

var $caDHl = parcelRequire("caDHl");

var $70uJv = parcelRequire("70uJv");

var $g3KFB = parcelRequire("g3KFB");

var $d3a3g = parcelRequire("d3a3g");

var $44ckN = parcelRequire("44ckN");

var $1fyzA = parcelRequire("1fyzA");

var $5JETu = parcelRequire("5JETu");

var $kV9Y4 = parcelRequire("kV9Y4");
class $0235355e595b3108$export$2e2bcd8739ae039 {
    constructor(){
        Object.assign(this, {
            begin: 0,
            end: 0
        });
    }
    start() {
        this.begin = Date.now();
        return this;
    }
    stop() {
        this.end = Date.now();
        return this;
    }
    duration() {
        return this.end - this.begin;
    }
}

});
parcelRegister("cFF3j", function(module, exports) {

$parcel$export(module.exports, "mirror", () => $9399288cfc8133cc$export$205349702e9dbad8);
$parcel$export(module.exports, "shift", () => $9399288cfc8133cc$export$fba63a578e423eb);
$parcel$export(module.exports, "mult", () => $9399288cfc8133cc$export$30cdb7d48dedb58b);
$parcel$export(module.exports, "invert", () => $9399288cfc8133cc$export$6897c284b6f9f4dc);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2023
 */ const $9399288cfc8133cc$export$205349702e9dbad8 = ([x, y, ...r])=>[
        -x,
        y,
        ...r
    ];
const $9399288cfc8133cc$export$fba63a578e423eb = (a, b)=>([x, y, ...r])=>[
            x + a,
            y + b,
            ...r
        ];
const $9399288cfc8133cc$export$30cdb7d48dedb58b = (a, b)=>([x, y, ...r])=>[
            x * a,
            y * b,
            ...r
        ];
const $9399288cfc8133cc$export$6897c284b6f9f4dc = ([x, y, ...r])=>[
        y,
        x,
        ...r
    ];

});

parcelRegister("caDHl", function(module, exports) {
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2023
 */ // JSDocs !
// eslint-disable-next-line no-unused-vars
parcelRequire("d3a3g");
class $8dc536663e861fbe$export$cacd6541cfeeb6c1 {
    static N = [
        0,
        -1
    ];
    static NE = [
        1,
        -1
    ];
    static E = [
        1,
        0
    ];
    static SE = [
        1,
        1
    ];
    static S = [
        0,
        1
    ];
    static SW = [
        -1,
        1
    ];
    static W = [
        -1,
        0
    ];
    static NW = [
        -1,
        -1
    ];
}
const $8dc536663e861fbe$export$d10b1b2dcc0b4be = ({ i: i, j: j }, dir)=>{
    const [di, dj] = dir;
    return {
        i: i + di,
        j: j + dj
    };
};
class $8dc536663e861fbe$export$d96a8827a60d6b69 {
    /**
   * @param {Array.<{i,j}>} block
   */ constructor(block = []){
        this.block = block;
    }
    /**
   * Add a coord to current block
   * @param {{i:number, j:number}} coord
   */ add(coord) {
        this.block.push(coord);
    }
    /**
   * First coord of the block (from west to east)
   * @returns {{i:number, j:number}}
   */ first() {
        return this.block.at(0);
    }
    /**
   * The row num of the block (coordinate on north-south axis)
   * @returns {number}
   */ rowNum() {
        return this.block.at(0).j;
    }
    /**
   * The range of the block (coordinates on west-east axis)
   * @returns {[number, number]}
   */ range() {
        return [
            this.block.at(0).i,
            this.block.at(-1).i
        ];
    }
    /**
   * Does the given coordinates on west-east axis is part of the block ?
   * @param {number} i coordinate on west-east axis
   * @returns {boolean}
   */ contains(i) {
        return this.block.at(0).i <= i && i <= this.block.at(-1).i;
    }
    /**
   * Does the given coordinates on west-east axis follows most eastward coordinate of the block ?
   * @param {number} i
   * @returns {boolean}
   */ isPreviousColumnIndex(i) {
        return this.block.at(-1).i === i - 1;
    }
    /**
   * Does the given block is on the line following the line of this block ?
   * @param {Block} b
   * @returns {boolean}
   */ isPreviousRow(b) {
        return this.rowNum() === b.rowNum() - 1;
    }
    /**
   * Does the given block is contiguous of this block ?
   * @param {Block} b
   * @returns {boolean}
   */ isContiguous(b) {
        return this.isPreviousRow(b) && this.rangeOverLap(b);
    }
    /**
   * Does the given block and this block west-east axis ranges overlap ?
   * @param {Block} b
   * @returns {boolean}
   */ rangeOverLap(b) {
        const [tl, tr] = this.range();
        const [bl, br] = b.range();
        return tl <= bl && bl <= tr || tl <= br && br <= tr || bl <= tl && tl <= br || bl <= tr && tr <= br;
    }
    toString() {
        return `<${this.range()}>`;
    }
}
class $8dc536663e861fbe$export$2bc1fce0507690ac {
    /**
   * @param {Array.<Block>} line
   */ constructor(line = []){
        this.line = line;
    }
    empty() {
        return this.line.length === 0;
    }
    add(block) {
        this.line.push(block);
    }
    addAll(lineBlock) {
        this.line.push(...lineBlock.line);
    }
    first() {
        return this.line.at(0);
    }
    last() {
        return this.line.at(-1);
    }
    addToLast(coord) {
        this.last().add(coord);
    }
    blocks2landMasses() {
        return this.line.map((b)=>new $8dc536663e861fbe$export$f326c4e9789d5336([
                new $8dc536663e861fbe$export$2bc1fce0507690ac([
                    b
                ])
            ]));
    }
    forEach(f) {
        this.line.forEach(f);
    }
    hasAContiguousBlock(block) {
        return this.line.some((b)=>b.isContiguous(block));
    }
    rowNum() {
        return this.line.at(0).rowNum();
    }
    toString() {
        return `[${this.line.map((b)=>b.toString()).join(', ')}]`;
    }
}
class $8dc536663e861fbe$export$f326c4e9789d5336 {
    /**
   * @param {Array.<LineBlocks>} lines one lineBlocks per lines
   */ constructor(lines){
        this.lines = lines;
    }
    firstLine() {
        return this.lines.at(0);
    }
    prevToLastLine() {
        return this.lines.at(-2);
    }
    lastLine() {
        return this.lines.at(-1);
    }
    /**
   * @param {Block} b
   */ accept(b) {
        return this.lastLine().hasAContiguousBlock(b) || this.lines.length > 1 && this.prevToLastLine().hasAContiguousBlock(b);
    }
    add(block) {
        if (this.lastLine().rowNum() === block.rowNum()) this.lastLine().add(block);
        else this.lines.push(new $8dc536663e861fbe$export$2bc1fce0507690ac([
            block
        ]));
    }
    merge(other) {
        const tj = this.firstLine().rowNum();
        const oj = other.firstLine().rowNum();
        if (tj > oj) return other.merge(this);
        else {
            const start = oj - tj;
            for(let ln = start, last = this.lines.length; ln < last; ln += 1)if (typeof other.lines.at(ln - start) !== 'undefined') this.lines.at(ln).addAll(other.lines.at(ln - start));
            if (this.lastLine().rowNum() < other.lastLine().rowNum()) this.lines.push(other.lastLine());
        }
        return this;
    }
    has({ i: i, j: j }) {
        return this.lines.some((l)=>l.rowNum() === j && l.line.some((b)=>b.contains(i)));
    }
    contour() {
        const startingPoint = this.firstLine().first().first();
        const sameCoord = (a, b)=>a.i === b.i && a.j === b.j;
        const extract = ({ i: i, j: j }, d)=>[
                i,
                j,
                dir2border[`${d}`]
            ];
        const dir2border = {
            [`${$8dc536663e861fbe$export$cacd6541cfeeb6c1.E}`]: 'N',
            [`${$8dc536663e861fbe$export$cacd6541cfeeb6c1.N}`]: 'W',
            [`${$8dc536663e861fbe$export$cacd6541cfeeb6c1.W}`]: 'S',
            [`${$8dc536663e861fbe$export$cacd6541cfeeb6c1.S}`]: 'E'
        };
        let curDir = $8dc536663e861fbe$export$cacd6541cfeeb6c1.E;
        let curPoint = $8dc536663e861fbe$export$d10b1b2dcc0b4be(startingPoint, curDir);
        const res = [
            extract(startingPoint, curDir),
            extract(curPoint)
        ];
        while(!sameCoord(curPoint, startingPoint)){
            if (curDir === $8dc536663e861fbe$export$cacd6541cfeeb6c1.E) {
                if (this.has($8dc536663e861fbe$export$d10b1b2dcc0b4be(curPoint, $8dc536663e861fbe$export$cacd6541cfeeb6c1.N))) curDir = $8dc536663e861fbe$export$cacd6541cfeeb6c1.N;
                else if (this.has(curPoint)) curDir = $8dc536663e861fbe$export$cacd6541cfeeb6c1.E;
                else curDir = $8dc536663e861fbe$export$cacd6541cfeeb6c1.S;
            } else if (curDir === $8dc536663e861fbe$export$cacd6541cfeeb6c1.S) {
                if (this.has(curPoint)) curDir = $8dc536663e861fbe$export$cacd6541cfeeb6c1.E;
                else if (this.has($8dc536663e861fbe$export$d10b1b2dcc0b4be(curPoint, $8dc536663e861fbe$export$cacd6541cfeeb6c1.W))) curDir = $8dc536663e861fbe$export$cacd6541cfeeb6c1.S;
                else curDir = $8dc536663e861fbe$export$cacd6541cfeeb6c1.W;
            } else if (curDir === $8dc536663e861fbe$export$cacd6541cfeeb6c1.W) {
                if (this.has($8dc536663e861fbe$export$d10b1b2dcc0b4be(curPoint, $8dc536663e861fbe$export$cacd6541cfeeb6c1.W))) curDir = $8dc536663e861fbe$export$cacd6541cfeeb6c1.S;
                else if (this.has($8dc536663e861fbe$export$d10b1b2dcc0b4be(curPoint, $8dc536663e861fbe$export$cacd6541cfeeb6c1.NW))) curDir = $8dc536663e861fbe$export$cacd6541cfeeb6c1.W;
                else curDir = $8dc536663e861fbe$export$cacd6541cfeeb6c1.N;
            } else if (curDir === $8dc536663e861fbe$export$cacd6541cfeeb6c1.N) {
                if (this.has($8dc536663e861fbe$export$d10b1b2dcc0b4be(curPoint, $8dc536663e861fbe$export$cacd6541cfeeb6c1.NW))) curDir = $8dc536663e861fbe$export$cacd6541cfeeb6c1.W;
                else if (this.has($8dc536663e861fbe$export$d10b1b2dcc0b4be(curPoint, $8dc536663e861fbe$export$cacd6541cfeeb6c1.N))) curDir = $8dc536663e861fbe$export$cacd6541cfeeb6c1.N;
                else curDir = $8dc536663e861fbe$export$cacd6541cfeeb6c1.E;
            }
            curPoint = $8dc536663e861fbe$export$d10b1b2dcc0b4be(curPoint, curDir);
            res.at(-1)[2] = dir2border[`${curDir}`];
            if (!sameCoord(curPoint, startingPoint)) res.push(extract(curPoint));
        }
        return res;
    }
    toString() {
        const res = [];
        this.lines.forEach((lb)=>{
            res.push(`${lb.rowNum()}: ${lb.toString()}`);
        });
        return res.join('\n');
    }
}
const $8dc536663e861fbe$export$da21c73a18dd3deb = (island)=>{
    const { offset: { a: a, b: b }, matrix: { width: width, height: height } } = island;
    const res = [];
    for(let j = b, l = b + height; j < l; j++){
        const lineBlocks = new $8dc536663e861fbe$export$2bc1fce0507690ac();
        for(let i = a, m = a + width; i < m; i++)if (island.has(i, j)) {
            if (lineBlocks.empty() || !lineBlocks.last().isPreviousColumnIndex(i)) lineBlocks.add(new $8dc536663e861fbe$export$d96a8827a60d6b69([
                {
                    i: i,
                    j: j
                }
            ]));
            else lineBlocks.addToLast({
                i: i,
                j: j
            });
        }
        if (res.length === 0) res.push(...lineBlocks.blocks2landMasses());
        else lineBlocks.forEach((block)=>{
            const acceptors = res.filter((lm)=>lm.accept(block));
            if (acceptors.length === 0) res.push(new $8dc536663e861fbe$export$f326c4e9789d5336([
                new $8dc536663e861fbe$export$2bc1fce0507690ac([
                    block
                ])
            ]));
            else if (acceptors.length === 1) {
                const landmass = acceptors.pop();
                landmass.add(block);
            } else if (acceptors.length > 1) {
                // remove acceptors from res
                acceptors.forEach((lm)=>{
                    const idx = res.indexOf(lm);
                    res.splice(idx, 1);
                });
                // MERGE acceptors
                const merged = acceptors.reduce((p, c)=>{
                    return p.merge(c);
                });
                // add block to merged
                merged.add(block);
                // insert back merged acceptor into res
                res.push(merged);
            }
        });
    // console.log(`>res:\n${res.join('\n-\n')}\n--\n`)
    }
    return res;
};

});
parcelRegister("d3a3g", function(module, exports) {
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2021
 */ // eslint-disable-next-line no-unused-vars

var $g3KFB = parcelRequire("g3KFB");
class $98035a374e6e69eb$export$fd82ba9438df2737 {
    /**
   * A matrix with an offset
   *
   * @param {{a: number, b: number}} offset the relative offset of the matrix within the composite matrix
   * @param {Matrix} matrix the tiles
   * @param {undefined|string} id
   */ constructor(offset, matrix, id){
        this.offset = offset;
        this.matrix = matrix;
        this.id = id;
    }
    inside(i, j) {
        const { a: a, b: b } = this.offset;
        return i >= a && i < a + this.matrix.width && j >= b && j < b + this.matrix.height;
    }
    has(i, j) {
        if (this.inside(i, j)) {
            const { a: a, b: b } = this.offset;
            return this.matrix.has(i - a, j - b);
        }
    }
    get(i, j) {
        if (this.inside(i, j)) {
            const { a: a, b: b } = this.offset;
            return this.matrix.get(i - a, j - b);
        }
    }
    set(i, j, v) {
        if (this.inside(i, j)) {
            const { a: a, b: b } = this.offset;
            this.matrix.set(i - a, j - b, v);
            return true;
        }
    }
    delete(i, j) {
        if (this.inside(i, j)) {
            const { a: a, b: b } = this.offset;
            this.matrix.delete(i - a, j - b);
            return true;
        }
    }
    forEach(f) {
        const { a: a, b: b } = this.offset;
        this.matrix.forEach((i, j, v)=>f(i + a, j + b, v));
    }
}
class $98035a374e6e69eb$export$2e2bcd8739ae039 {
    constructor(width, height, subMatrix = []){
        this.reset(width, height);
        this.subMatrix = subMatrix;
    }
    static import(data) {
        const { width: width, height: height, subMatrix: subMatrix } = data;
        return new $98035a374e6e69eb$export$2e2bcd8739ae039(width, height, subMatrix.map(({ offset: offset, matrix: matrix, id: id })=>new $98035a374e6e69eb$export$fd82ba9438df2737(offset, (0, $g3KFB.default).copy(matrix), id)));
    }
    inside(i, j) {
        return i >= 0 && i < this.width && j >= 0 && j < this.height;
    }
    has(i, j) {
        for (const sub of this.subMatrix){
            const r = sub.has(i, j);
            if (typeof r !== 'undefined') return r;
        }
    }
    get(i, j) {
        for (const sub of this.subMatrix){
            const r = sub.get(i, j);
            if (typeof r !== 'undefined') return r;
        }
    }
    getSub(i, j) {
        return this.subMatrix.find((sub)=>sub.inside(i, j));
    }
    set(i, j, v) {
        for (const sub of this.subMatrix){
            const r = sub.set(i, j, v);
            if (typeof r !== 'undefined') return;
        }
        throw new Error(`composite-matrix.cannot.set.outside.submatrix(${i},${j})`);
    }
    delete(i, j) {
        for (const sub of this.subMatrix){
            const r = sub.delete(i, j);
            if (typeof r !== 'undefined') return;
        }
        throw new Error(`composite-matrix.cannot.delete.outside.submatrix(${i},${j})`);
    }
    forEach(f, iOffset = 0, width = this.width, jOffset = 0, height = this.height) {
        for(let i = iOffset; i < iOffset + width; i++)for(let j = jOffset; j < jOffset + height; j++)f(i, j, this.get(i, j));
    }
    iterate(f) {
        return this.subMatrix.map(f);
    }
    clear() {
        this.subMatrix = [];
    }
    reset(width, height) {
        this.width = width;
        this.height = height;
        this.clear();
    }
    /**
   * @param {{x: number, y: number}} offset
   * @param {Matrix} matrix
   * @param {undefined|string} id
   */ addSub(offset, matrix, id) {
        this.subMatrix.push(new $98035a374e6e69eb$export$fd82ba9438df2737(offset, matrix, id));
    }
    addAll(subs) {
        // eslint-disable-next-line no-shadow
        subs.forEach(({ islandId: islandId, offset: /* name, */ offset, size: size, cells: cells })=>{
            const matrix = new (0, $g3KFB.default)(size.w, size.h);
            matrix.fill(cells);
            this.addSub(offset, matrix, islandId);
        });
    }
}

});
parcelRegister("g3KFB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb1120d8151b8e68$export$2e2bcd8739ae039);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2021
 */ class $bb1120d8151b8e68$export$2e2bcd8739ae039 {
    constructor(width, height){
        this.reset(width, height);
    }
    static copy({ width: width, height: height, matrix: matrix }) {
        const res = new $bb1120d8151b8e68$export$2e2bcd8739ae039(width, height);
        res.fill(matrix);
        return res;
    }
    inside(i, j) {
        return i >= 0 && i < this.width && j >= 0 && j < this.height;
    }
    has(i, j) {
        return typeof this.matrix[j][i] !== 'undefined' && this.matrix[j][i] !== null;
    }
    get(i, j) {
        return this.matrix[j][i];
    }
    set(i, j, v) {
        if (typeof v === 'undefined' || v === null) throw new Error('matrix.set.value.cannot.be.undefined.or.null');
        this.matrix[j][i] = v;
    // console.log('Matrix.set', i, j, this.matrix[j][i])
    }
    delete(i, j) {
        this.matrix[j][i] = null;
    // console.log(this.matrix)
    }
    forEach(f, iOffset = 0, width = this.width, jOffset = 0, height = this.height) {
        for(let j = jOffset; j < jOffset + height; j++){
            const matrixRow = this.matrix[j];
            for(let i = iOffset; i < iOffset + width; i++)f(i, j, matrixRow[i]);
        }
    }
    clear() {
        for(let j = 0, l = this.matrix.length; j < l; j += 1)this.matrix[j] = new Array(+this.width);
    }
    reset(width, height) {
        this.width = width;
        this.height = height;
        this.matrix = new Array(+this.height);
        this.clear();
    }
    fill(cells) {
        for(let j = 0; j < this.height; j++){
            const matrixRow = this.matrix[j];
            const cellsRow = cells[j];
            for(let i = 0; i < this.width; i++)matrixRow[i] = cellsRow[i];
        }
    }
}

});



parcelRegister("70uJv", function(module, exports) {

$parcel$export(module.exports, "TILE_SIZE", () => $51a05f6e7673f496$export$cf9ad17145f68381);
$parcel$export(module.exports, "default", () => $51a05f6e7673f496$export$2e2bcd8739ae039);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2022
 */ 
var $cFF3j = parcelRequire("cFF3j");

var $44ckN = parcelRequire("44ckN");

var $g3KFB = parcelRequire("g3KFB");
const $51a05f6e7673f496$export$cf9ad17145f68381 = 64;
const $51a05f6e7673f496$export$7ffcdc709ba7e131 = (l)=>l === (0, $44ckN.LAND_LEVEL).SEA ? 'white' : '#EEE';
const $51a05f6e7673f496$export$6f3f9550dbd29898 = (l)=>l === (0, $44ckN.LAND_LEVEL).LOWLAND ? '#DDD' : l === (0, $44ckN.LAND_LEVEL).HILL ? '#CCC' : '#BBB';
class $51a05f6e7673f496$export$2e2bcd8739ae039 {
    /**
   *
   * @param {CanvasRenderingContext2D} canvas
   * @param {Matrix} tiles
   */ drawTiles(ctx, tiles) {
        (0, $g3KFB.default).copy(tiles).forEach((i, j, v)=>{
            const { l: l, t: t, b: b } = v;
            if (t === (0, $44ckN.LAND_TYPE).WATER) this.drawWater(ctx, i, j, $51a05f6e7673f496$export$7ffcdc709ba7e131(l));
            else this.drawLand(ctx, i, j, l, t, b);
        });
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} i
   * @param {number} j
   * @param {string} bgColor
   */ drawWater(ctx, i, j, bgColor) {
        const sub = Math.floor($51a05f6e7673f496$export$cf9ad17145f68381 / 8);
        ctx.fillStyle = bgColor;
        ctx.fillRect($51a05f6e7673f496$export$cf9ad17145f68381 * i, $51a05f6e7673f496$export$cf9ad17145f68381 * j, $51a05f6e7673f496$export$cf9ad17145f68381, $51a05f6e7673f496$export$cf9ad17145f68381);
        ctx.strokeStyle = 'black';
        const path = [
            [
                1,
                0.5
            ],
            [
                2,
                0,
                [
                    0.5,
                    0
                ],
                [
                    -0.5,
                    0
                ]
            ],
            [
                3,
                0.5,
                [
                    0.5,
                    0
                ],
                [
                    -0.5,
                    0
                ]
            ],
            [
                4,
                0,
                [
                    0.5,
                    0
                ],
                [
                    -0.5,
                    0
                ]
            ],
            [
                5,
                0.5,
                [
                    0.5,
                    0
                ],
                [
                    -0.5,
                    0
                ]
            ]
        ];
        this.drawCurves(ctx, sub, i, j, path.map((0, $cFF3j.shift)(0, 0.5)));
        ctx.stroke();
        this.drawCurves(ctx, sub, i, j, path.map((0, $cFF3j.shift)(3, 2.5)));
        ctx.stroke();
        this.drawCurves(ctx, sub, i, j, path.map((0, $cFF3j.shift)(0, 4.5)));
        ctx.stroke();
        this.drawCurves(ctx, sub, i, j, path.map((0, $cFF3j.shift)(3, 6.5)));
        ctx.stroke();
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} i
   * @param {number} j
   * @param {string} typ
   * @param {{N: number, S: number, W: number, E: number}} bor
   * @param {string} bgColor
   */ drawLand(ctx, i, j, lvl, typ, bor) {
        const sub = Math.floor($51a05f6e7673f496$export$cf9ad17145f68381 / 16);
        ctx.fillStyle = $51a05f6e7673f496$export$6f3f9550dbd29898(lvl);
        ctx.fillRect($51a05f6e7673f496$export$cf9ad17145f68381 * i, $51a05f6e7673f496$export$cf9ad17145f68381 * j, $51a05f6e7673f496$export$cf9ad17145f68381, $51a05f6e7673f496$export$cf9ad17145f68381);
        if (bor && Object.keys(bor).length) for (const [k, l] of Object.entries(bor))this.drawWaterEdge(ctx, sub, i, j, k, l);
        if (lvl === (0, $44ckN.LAND_LEVEL).HILL) {
            ctx.strokeStyle = 'black';
            const path = [
                [
                    1,
                    5
                ],
                [
                    7,
                    5,
                    [
                        0,
                        -4
                    ],
                    [
                        0,
                        -4
                    ]
                ]
            ];
            this.drawCurves(ctx, sub, i, j, path.map((0, $cFF3j.shift)(4, 0)));
            ctx.stroke();
            this.drawCurves(ctx, sub, i, j, path.map((0, $cFF3j.shift)(0, 3)));
            ctx.stroke();
            this.drawCurves(ctx, sub, i, j, path.map((0, $cFF3j.shift)(8, 3)));
            ctx.stroke();
            this.drawCurves(ctx, sub, i, j, path.map((0, $cFF3j.shift)(4, 7)));
            ctx.stroke();
            this.drawCurves(ctx, sub, i, j, path.map((0, $cFF3j.shift)(0, 10)));
            ctx.stroke();
            this.drawCurves(ctx, sub, i, j, path.map((0, $cFF3j.shift)(8, 10)));
            ctx.stroke();
        }
        if (lvl === (0, $44ckN.LAND_LEVEL).MOUNTAIN) {
            ctx.strokeStyle = 'black';
            this.drawLines(ctx, sub, i, j, [
                [
                    2,
                    12
                ],
                [
                    4,
                    6
                ],
                [
                    6,
                    8
                ],
                [
                    8,
                    4
                ],
                [
                    10,
                    8
                ],
                [
                    12,
                    6
                ],
                [
                    14,
                    12
                ]
            ]);
            ctx.stroke();
        }
        if (typ === (0, $44ckN.LAND_TYPE).ROCK) [
            [
                2.5,
                0
            ],
            [
                7.5,
                0
            ],
            [
                0,
                3
            ],
            [
                5,
                3
            ],
            [
                10,
                3
            ],
            [
                2.5,
                6
            ],
            [
                7.5,
                6
            ],
            [
                0,
                9
            ],
            [
                5,
                9
            ],
            [
                10,
                9
            ],
            [
                2.5,
                12
            ],
            [
                7.5,
                12
            ]
        ].map((0, $cFF3j.shift)(0, -0.5)).forEach(([a, b])=>{
            this.drawRock(ctx, sub, i, j, a, b);
        });
        if (typ === (0, $44ckN.LAND_TYPE).GRASS) [
            [
                2.5,
                0
            ],
            [
                7.5,
                0
            ],
            [
                0,
                3
            ],
            [
                5,
                3
            ],
            [
                10,
                3
            ],
            [
                2.5,
                6
            ],
            [
                7.5,
                6
            ],
            [
                0,
                9
            ],
            [
                5,
                9
            ],
            [
                10,
                9
            ],
            [
                2.5,
                12
            ],
            [
                7.5,
                12
            ]
        ].map((0, $cFF3j.shift)(0, -0.5)).forEach(([a, b])=>{
            this.drawGrass(ctx, sub, i, j, a, b);
        });
        if (typ === (0, $44ckN.LAND_TYPE).FOREST) {
            const dt = ([a, b])=>{
                this.drawTree(ctx, sub, i, j, a, b);
            };
            const trees0 = [
                [
                    3,
                    0
                ],
                [
                    7,
                    0
                ],
                [
                    11,
                    0
                ]
            ];
            const trees1 = [
                [
                    1,
                    1
                ],
                [
                    5,
                    1
                ],
                [
                    9,
                    1
                ],
                [
                    13,
                    1
                ]
            ];
            const lines = [
                1,
                2,
                5,
                6,
                9,
                10,
                13
            ];
            lines.forEach((n, k)=>{
                if (k % 2 === 0) trees0.map((0, $cFF3j.shift)(0, n)).forEach(dt);
                else trees1.map((0, $cFF3j.shift)(0, n)).forEach(dt);
            });
        }
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} i
   * @param {number} j
   * @param {string} bgColor
   */ drawWaterEdge(ctx, sub, i, j, k, l) {
        const path = [
            [
                0,
                0
            ],
            [
                1,
                1
            ],
            [
                2,
                0
            ],
            [
                3,
                1
            ],
            [
                4,
                0
            ],
            [
                5,
                1
            ],
            [
                6,
                0
            ],
            [
                7,
                1
            ],
            [
                8,
                0
            ]
        ];
        ctx.strokeStyle = $51a05f6e7673f496$export$7ffcdc709ba7e131(l);
        ctx.fillStyle = $51a05f6e7673f496$export$7ffcdc709ba7e131(l);
        if (k === 'N') this.drawLines(ctx, sub * 2, i, j, path);
        if (k === 'S') this.drawLines(ctx, sub * 2, i, j, path.map((0, $cFF3j.mult)(1, -1)).map((0, $cFF3j.shift)(0, sub * 2)));
        if (k === 'W') this.drawLines(ctx, sub * 2, i, j, path.map((0, $cFF3j.invert)));
        if (k === 'E') this.drawLines(ctx, sub * 2, i, j, path.map((0, $cFF3j.mult)(1, -1)).map((0, $cFF3j.shift)(0, sub * 2)).map((0, $cFF3j.invert)));
        ctx.stroke();
        ctx.fill();
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} i
   * @param {number} j
   * @param {string} bgColor
   */ drawTree(ctx, sub, i, j, a, b) {
        const triangle = [
            [
                1,
                0
            ],
            [
                2,
                1
            ],
            [
                0,
                1
            ],
            [
                1,
                0
            ]
        ];
        ctx.fillStyle = 'black';
        ctx.lineWidth = 1;
        this.drawLines(ctx, sub, i, j, triangle.map((0, $cFF3j.shift)(a, b)));
        ctx.fill();
        this.drawLines(ctx, sub, i, j, triangle.map((0, $cFF3j.shift)(a, b + 0.5)));
        ctx.fill();
        ctx.strokeStyle = 'black';
        this.drawLines(ctx, sub, i, j, [
            [
                1,
                1.5
            ],
            [
                1,
                2
            ]
        ].map((0, $cFF3j.shift)(a, b)));
        ctx.stroke();
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} i
   * @param {number} j
   * @param {string} bgColor
   */ drawGrass(ctx, sub, i, j, a, b) {
        const path = [
            [
                2.5,
                3
            ],
            [
                2,
                2
            ],
            [
                3,
                2.5
            ],
            [
                3.5,
                1.5
            ],
            [
                4,
                2.5
            ],
            [
                5,
                2
            ],
            [
                4.5,
                3
            ]
        ];
        ctx.strokeStyle = 'darkgray';
        ctx.lineWidth = 1;
        this.drawLines(ctx, sub, i, j, path.map((0, $cFF3j.shift)(a, b)));
        ctx.stroke();
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} i
   * @param {number} j
   * @param {string} bgColor
   */ drawRock(ctx, sub, i, j, a, b) {
        const path = [
            [
                2.5,
                3
            ],
            [
                4.5,
                3,
                [
                    -0.5,
                    -1
                ],
                [
                    0.5,
                    -1
                ]
            ]
        ];
        ctx.strokeStyle = 'darkgray';
        ctx.lineWidth = 1;
        this.drawCurves(ctx, sub, i, j, path.map((0, $cFF3j.shift)(a, b)));
        ctx.stroke();
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} sub
   * @param {number} i
   * @param {number} j
   * @param {number[][]} path
   */ drawLines(ctx, sub, i, j, path) {
        ctx.beginPath();
        const clone = path.slice(0);
        const [a0, b0] = clone.shift();
        ctx.moveTo($51a05f6e7673f496$export$cf9ad17145f68381 * i + a0 * sub, $51a05f6e7673f496$export$cf9ad17145f68381 * j + b0 * sub);
        clone.forEach(([a, b])=>{
            ctx.lineTo($51a05f6e7673f496$export$cf9ad17145f68381 * i + a * sub, $51a05f6e7673f496$export$cf9ad17145f68381 * j + b * sub);
        });
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} sub
   * @param {number} i
   * @param {number} j
   * @param {number[][]} path
   */ drawCurves(ctx, sub, i, j, path) {
        ctx.beginPath();
        const clone = path.slice(0);
        let [a0, b0] = clone.shift();
        ctx.moveTo($51a05f6e7673f496$export$cf9ad17145f68381 * i + a0 * sub, $51a05f6e7673f496$export$cf9ad17145f68381 * j + b0 * sub);
        clone.forEach(([a, b, [_0x, _0y], [_1x, _1y]])=>{
            // ctx.fillStyle = 'green'
            // ctx.fillRect(tileSize * i + (a0 + _0x) * sub, tileSize * j + (b0 + _0y) * sub, 4, 4)
            // ctx.fillStyle = 'red'
            // ctx.fillRect(tileSize * i + (a + _1x) * sub, tileSize * j + (b + _1y) * sub, 4, 4)
            ctx.bezierCurveTo($51a05f6e7673f496$export$cf9ad17145f68381 * i + (a0 + _0x) * sub, $51a05f6e7673f496$export$cf9ad17145f68381 * j + (b0 + _0y) * sub, $51a05f6e7673f496$export$cf9ad17145f68381 * i + (a + _1x) * sub, $51a05f6e7673f496$export$cf9ad17145f68381 * j + (b + _1y) * sub, $51a05f6e7673f496$export$cf9ad17145f68381 * i + a * sub, $51a05f6e7673f496$export$cf9ad17145f68381 * j + b * sub);
            a0 = a;
            b0 = b;
        });
    }
}

});
parcelRegister("44ckN", function(module, exports) {

$parcel$export(module.exports, "LAND_LEVEL", () => $2f611a82e2b99ec7$export$1b41fb06dcc202b3);
$parcel$export(module.exports, "LAND_TYPE", () => $2f611a82e2b99ec7$export$bd6c6c8424f5f430);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2022
 */ class $2f611a82e2b99ec7$export$1b41fb06dcc202b3 {
    static SEA = -1;
    static LOWLAND = 0;
    static HILL = 1;
    static MOUNTAIN = 2;
}
class $2f611a82e2b99ec7$export$bd6c6c8424f5f430 {
    static WATER = 'w' // sea can only be water, lowland can be water => freshwater/lake
    ;
    static GRASS = 'g' // can only happen on lowland or hill
    ;
    static FOREST = 'f' // can only happen on lowland or hill
    ;
    static ROCK = 'r' // mountain level can only be rock
    ;
}

});


parcelRegister("1fyzA", function(module, exports) {

$parcel$export(module.exports, "MapCell", () => $0e92029d10c65516$export$5144edc66734b1c2);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2022
 */ 
var $44ckN = parcelRequire("44ckN");
const $0e92029d10c65516$var$LAND_TYPE_MAPPING = {
    [(0, $44ckN.LAND_TYPE).WATER]: 'water',
    [(0, $44ckN.LAND_TYPE).GRASS]: 'meadow',
    [(0, $44ckN.LAND_TYPE).ROCK]: 'rock',
    [(0, $44ckN.LAND_TYPE).FOREST]: 'forest'
};
class $0e92029d10c65516$export$5144edc66734b1c2 {
    constructor({ l: l, t: t, b: b }){
        Object.assign(this, {
            l: l,
            t: t,
            b: b
        });
    }
    get type() {
        return $0e92029d10c65516$var$LAND_TYPE_MAPPING[this.t];
    }
    isLand() {
        return this.t !== (0, $44ckN.LAND_TYPE).WATER;
    }
    isWithShore() {
        return this.isLandWithShore() || this.isWaterWithShore();
    }
    isLandWithShore() {
        return this.t !== (0, $44ckN.LAND_TYPE).WATER && this.b && Object.values(this.b).filter((x)=>typeof x === 'number').length > 0;
    }
    isWaterWithShore() {
        return this.t === (0, $44ckN.LAND_TYPE).WATER && this.b && Object.values(this.b).filter((x)=>typeof x === 'string').length > 0;
    }
    isWater() {
        return this.t === (0, $44ckN.LAND_TYPE).WATER;
    }
    isFreshWater() {
        return this.isWater() && this.l !== (0, $44ckN.LAND_LEVEL).SEA;
    }
    isSeaWater() {
        return this.isWater() && this.l === (0, $44ckN.LAND_LEVEL).SEA;
    }
}
class $0e92029d10c65516$export$f7dd6d8ca1d2ac5b extends $0e92029d10c65516$export$5144edc66734b1c2 {
    constructor({ i: i, j: j, l: l, t: t, b: b }){
        super({
            l: l,
            t: t,
            b: b
        });
        Object.assign(this, {
            i: i,
            j: j
        });
    }
}

});

parcelRegister("5JETu", function(module, exports) {

$parcel$export(module.exports, "default", () => $42d0e069f52ae571$export$2e2bcd8739ae039);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2022
 */ /**
 * Client -> Server messages
 * * Query: Ask for a data from the store, no changes done, answer as Info message
 * * Command: Ask to execute a command, may change data in store, send back an Info message
 * * Subscription: Subscribe/Unsubscribe to a set of data in store, to receive an Info message on sub and on every changes
 *
 * Server -> Client messages
 * * Info: An agglomerate of data from store, either from a Query or a Subscription
 * * Error: A message to tell an error happened on server
 */ class $42d0e069f52ae571$export$80edbf15fa61a4db {
    static Command = 'C';
    static Query = 'Q';
    static Subscription = 'S';
    static Info = 'I';
    static Error = 'E';
    static Extra = 'X';
}
class $42d0e069f52ae571$export$2e2bcd8739ae039 {
    constructor({ x: x, n: n, d: d }){
        Object.assign(this, {
            x: x,
            n: n,
            d: d
        });
    }
    static build(x, n, d = {}) {
        return new $42d0e069f52ae571$export$2e2bcd8739ae039({
            x: x,
            n: n,
            d: d
        });
    }
    static query(n, d = {}) {
        return $42d0e069f52ae571$export$2e2bcd8739ae039.build($42d0e069f52ae571$export$80edbf15fa61a4db.Query, n, d);
    }
    static command(n, d = {}) {
        return $42d0e069f52ae571$export$2e2bcd8739ae039.build($42d0e069f52ae571$export$80edbf15fa61a4db.Command, n, d);
    }
    static subscription(n, d = {}) {
        return $42d0e069f52ae571$export$2e2bcd8739ae039.build($42d0e069f52ae571$export$80edbf15fa61a4db.Subscription, n, d);
    }
    static info(n, d = {}) {
        return $42d0e069f52ae571$export$2e2bcd8739ae039.build($42d0e069f52ae571$export$80edbf15fa61a4db.Info, n, d);
    }
    static error(n, d = {}) {
        return $42d0e069f52ae571$export$2e2bcd8739ae039.build($42d0e069f52ae571$export$80edbf15fa61a4db.Error, n, d);
    }
    static extra(n, d = {}) {
        return $42d0e069f52ae571$export$2e2bcd8739ae039.build($42d0e069f52ae571$export$80edbf15fa61a4db.Extra, n, d);
    }
    static parse(msg) {
        const parsed = /^([QCSIEX])>([a-zA-Z0-9:_-]+)(\{.*\}$)/.exec(msg);
        if (parsed) return new $42d0e069f52ae571$export$2e2bcd8739ae039({
            x: parsed[1],
            n: parsed[2],
            d: JSON.parse(parsed[3])
        });
        else return undefined;
    }
    /**
   *
   * @param {Object.<string, (m,...r) => {}>} map
   * @param {(m,...r) => {}} out
   * @returns {(m,...r)=> {}}
   */ static mapper(map, out) {
        return (m, ...r)=>{
            if (m.x in map) return map[m.x](m, ...r);
            else out(m, ...r);
        };
    }
    isCommand() {
        return this.x === $42d0e069f52ae571$export$80edbf15fa61a4db.Command;
    }
    isQuery() {
        return this.x === $42d0e069f52ae571$export$80edbf15fa61a4db.Query;
    }
    isSubscription() {
        return this.x === $42d0e069f52ae571$export$80edbf15fa61a4db.Subscription;
    }
    isInfo() {
        return this.x === $42d0e069f52ae571$export$80edbf15fa61a4db.Info;
    }
    isError() {
        return this.x === $42d0e069f52ae571$export$80edbf15fa61a4db.Error;
    }
    isExtra() {
        return this.x === $42d0e069f52ae571$export$80edbf15fa61a4db.Extra;
    }
    get name() {
        return this.n;
    }
    get data() {
        return this.d;
    }
    toString() {
        return `${this.x}>${this.n}${JSON.stringify(typeof this.d === 'object' ? this.d : {})}`;
    }
    toHideDataString() {
        return `${this.x}>${this.n}{...}`;
    }
}

});

parcelRegister("kV9Y4", function(module, exports) {

$parcel$export(module.exports, "Rank", () => $f3b0dce8b0f1d89b$export$c36edca8f8f0427a);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2025
 */ class $f3b0dce8b0f1d89b$export$c36edca8f8f0427a {
    static Owner = 'Owner';
    static Officer = 'Officer';
    static Mate = 'Mate';
    static Crew = 'Crew';
    static Passenger = 'Passenger';
    static Comparator = {
        [$f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Owner]: new $f3b0dce8b0f1d89b$export$c36edca8f8f0427a($f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Owner, 4),
        [$f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Officer]: new $f3b0dce8b0f1d89b$export$c36edca8f8f0427a($f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Officer, 3),
        [$f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Mate]: new $f3b0dce8b0f1d89b$export$c36edca8f8f0427a($f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Mate, 2),
        [$f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Crew]: new $f3b0dce8b0f1d89b$export$c36edca8f8f0427a($f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Crew, 1),
        [$f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Passenger]: new $f3b0dce8b0f1d89b$export$c36edca8f8f0427a($f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Passenger, 0)
    };
    static checkRank(x) {
        return x in $f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Comparator;
    }
    static listInOrder(byRank = $f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Owner, reverse = false) {
        if (!$f3b0dce8b0f1d89b$export$c36edca8f8f0427a.checkRank(byRank)) return [];
        return Object.values($f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Comparator).sort((a, b)=>(reverse ? -1 : 1) * a.compare(b)).filter((a)=>a.lte(byRank)).map((a)=>a.rank);
    }
    static getRank(x) {
        return $f3b0dce8b0f1d89b$export$c36edca8f8f0427a.Comparator[x];
    }
    constructor(rank, order){
        this.rank = rank;
        this.order = order;
    }
    compare(b) {
        if (!(b instanceof $f3b0dce8b0f1d89b$export$c36edca8f8f0427a)) return undefined;
        return this.order - b.order;
    }
    operator(b, f = (x)=>x === 0) {
        if (typeof b === 'string' && $f3b0dce8b0f1d89b$export$c36edca8f8f0427a.checkRank(b)) b = $f3b0dce8b0f1d89b$export$c36edca8f8f0427a.getRank(b);
        return f(this.compare(b));
    }
    eq(b) {
        return this.operator(b);
    }
    lt(b) {
        return this.operator(b, (x)=>x < 0);
    }
    lte(b) {
        return this.operator(b, (x)=>x <= 0);
    }
    gt(b) {
        return this.operator(b, (x)=>x > 0);
    }
    gte(b) {
        return this.operator(b, (x)=>x >= 0);
    }
    in(...p) {
        return p.some((b)=>this.operator(b));
    }
}

});


parcelRegister("7yrld", function(module, exports) {

$parcel$export(module.exports, "default", () => $5800eac20157ce7c$export$2e2bcd8739ae039);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2022
 */ parcelRequire("bKDSB");
var $cFF3j = parcelRequire("cFF3j");
class $5800eac20157ce7c$export$2e2bcd8739ae039 {
    /**
   * Face contour definition
   */ static faces = {
        0: [
            [
                5,
                0
            ],
            [
                15,
                2
            ],
            [
                20,
                5
            ],
            [
                25,
                10
            ],
            [
                30,
                25
            ],
            [
                30,
                45
            ],
            [
                27,
                55
            ],
            [
                22,
                65
            ],
            [
                18,
                70
            ],
            [
                12,
                75
            ],
            [
                5,
                79
            ],
            [
                2,
                80
            ],
            [
                0,
                80
            ]
        ],
        1: [
            [
                5,
                0
            ],
            [
                15,
                2
            ],
            [
                20,
                5
            ],
            [
                25,
                10
            ],
            [
                30,
                25
            ],
            [
                30,
                45
            ],
            [
                25,
                64
            ],
            [
                22,
                69
            ],
            [
                10,
                76
            ],
            [
                4,
                81
            ],
            [
                0,
                81
            ]
        ],
        2: [
            [
                5,
                0
            ],
            [
                15,
                2
            ],
            [
                20,
                5
            ],
            [
                25,
                10
            ],
            [
                31,
                25
            ],
            [
                31,
                45
            ],
            [
                29,
                55
            ],
            [
                24,
                63
            ],
            [
                20,
                72
            ],
            [
                18,
                74
            ],
            [
                4,
                81
            ],
            [
                0,
                81
            ]
        ],
        3: [
            [
                5,
                0
            ],
            [
                15,
                2
            ],
            [
                20,
                5
            ],
            [
                25,
                10
            ],
            [
                32,
                25
            ],
            [
                32,
                45
            ],
            [
                27,
                67
            ],
            [
                25,
                72
            ],
            [
                12,
                77
            ],
            [
                10,
                81
            ],
            [
                5,
                83
            ],
            [
                0,
                82.5
            ]
        ]
    };
    // static ear0 = [[0, 3], [2, 0], [4, 0], [5, 1], [5, 10], [3, 15], [1, 15], [0, 14]]
    static ear0 = [
        [
            0,
            5
        ],
        [
            16,
            0
        ],
        [
            20,
            0
        ],
        [
            20,
            1
        ],
        [
            5,
            12
        ],
        [
            3,
            17
        ],
        [
            1,
            17
        ],
        [
            -1,
            16
        ]
    ];
    /**
   * Ears around face
   */ static ears = {
        0: $5800eac20157ce7c$export$2e2bcd8739ae039.ear0.map((0, $cFF3j.shift)(30, 20)),
        1: $5800eac20157ce7c$export$2e2bcd8739ae039.ear0.map((0, $cFF3j.shift)(31, 20)),
        2: $5800eac20157ce7c$export$2e2bcd8739ae039.ear0.map((0, $cFF3j.shift)(31, 20)),
        3: $5800eac20157ce7c$export$2e2bcd8739ae039.ear0.map((0, $cFF3j.shift)(32, 20))
    };
    static NECK_BOTTOM = 60;
    /**
   * Neck line and shoulder
   */ static necks = {
        0: [
            [
                0,
                0
            ],
            [
                9,
                0
            ],
            [
                10,
                15
            ],
            [
                11,
                18
            ],
            [
                13,
                19
            ],
            [
                17,
                20
            ],
            [
                35,
                24
            ],
            [
                42,
                25,
                'red',
                2
            ],
            [
                48,
                28
            ],
            [
                51,
                33
            ],
            [
                54,
                46
            ],
            [
                60,
                64
            ],
            [
                65,
                95
            ]
        ],
        1: [
            [
                0,
                0
            ],
            [
                11,
                0
            ],
            [
                12,
                15
            ],
            [
                13,
                18
            ],
            [
                16,
                20
            ],
            [
                50,
                25
            ],
            [
                50,
                $5800eac20157ce7c$export$2e2bcd8739ae039.NECK_BOTTOM
            ],
            [
                0,
                $5800eac20157ce7c$export$2e2bcd8739ae039.NECK_BOTTOM
            ]
        ],
        2: [
            [
                0,
                0
            ],
            [
                11,
                0
            ],
            [
                12,
                15
            ],
            [
                14,
                18
            ],
            [
                17,
                20
            ],
            [
                50,
                25
            ],
            [
                50,
                $5800eac20157ce7c$export$2e2bcd8739ae039.NECK_BOTTOM
            ],
            [
                0,
                $5800eac20157ce7c$export$2e2bcd8739ae039.NECK_BOTTOM
            ]
        ],
        3: [
            [
                0,
                0
            ],
            [
                14,
                0
            ],
            [
                15,
                15
            ],
            [
                16,
                18
            ],
            [
                19,
                20
            ],
            [
                50,
                25
            ],
            [
                50,
                $5800eac20157ce7c$export$2e2bcd8739ae039.NECK_BOTTOM
            ],
            [
                0,
                $5800eac20157ce7c$export$2e2bcd8739ae039.NECK_BOTTOM
            ]
        ]
    };
    /**
   * Right eyebrow
   */ static eyebrows = {
        0: [
            [
                2,
                2.5
            ],
            [
                2.5,
                1.5
            ],
            [
                3.5,
                1
            ],
            [
                5.5,
                0.5
            ],
            [
                10,
                0
            ],
            [
                15,
                0.5
            ],
            [
                20,
                2.5
            ],
            [
                15,
                1.5
            ],
            [
                10,
                1
            ],
            [
                4,
                1.5
            ],
            [
                2,
                2.5
            ]
        ],
        1: [
            [
                0,
                3
            ],
            [
                1,
                1
            ],
            [
                4,
                -0.5
            ],
            [
                10,
                -0.5
            ],
            [
                18,
                0
            ],
            [
                21,
                1
            ],
            [
                23,
                3
            ],
            [
                18,
                1.5
            ],
            [
                4,
                1.5
            ],
            [
                0,
                3
            ]
        ],
        2: [
            [
                0,
                2
            ],
            [
                0,
                0
            ],
            [
                19,
                0
            ],
            [
                22,
                3
            ],
            [
                16,
                2.5
            ],
            [
                4,
                2
            ],
            [
                0,
                2
            ]
        ],
        3: [
            [
                0,
                0
            ],
            [
                20,
                0
            ],
            [
                21,
                3
            ],
            [
                0,
                4
            ],
            [
                0,
                0
            ]
        ]
    };
    /**
   * Eyes contour and iris
   */ static eyes = {
        0: {
            contour: [
                [
                    [
                        4,
                        9
                    ],
                    [
                        4,
                        7.5
                    ],
                    [
                        6,
                        4.5
                    ],
                    [
                        9.5,
                        1
                    ],
                    [
                        13,
                        -0.5
                    ],
                    [
                        16,
                        -0.75
                    ],
                    [
                        19,
                        -0.5
                    ],
                    [
                        22.5,
                        1
                    ],
                    [
                        25,
                        3.5
                    ],
                    [
                        28.5,
                        2.5
                    ],
                    [
                        25,
                        3.5
                    ],
                    [
                        25,
                        5.5
                    ],
                    [
                        29,
                        5.5
                    ],
                    [
                        25,
                        5.5
                    ],
                    [
                        24,
                        7.5
                    ],
                    [
                        19,
                        9.5
                    ],
                    [
                        5,
                        9.5
                    ],
                    [
                        4,
                        9
                    ]
                ]
            ],
            back: [
                [
                    [
                        4,
                        9
                    ],
                    [
                        4,
                        7.5
                    ],
                    [
                        5.5,
                        4
                    ],
                    [
                        8.5,
                        0.5
                    ],
                    [
                        12.5,
                        -1.5
                    ],
                    [
                        16,
                        -2
                    ],
                    [
                        19.5,
                        -1.5
                    ],
                    [
                        23.5,
                        0.5
                    ],
                    [
                        25.5,
                        3
                    ],
                    [
                        28.5,
                        2.5
                    ],
                    [
                        25.5,
                        3
                    ],
                    [
                        25.5,
                        5
                    ],
                    [
                        29,
                        5.5
                    ],
                    [
                        25.5,
                        5.5
                    ],
                    [
                        24,
                        7.5
                    ],
                    [
                        19,
                        9.5
                    ],
                    [
                        5,
                        9.5
                    ],
                    [
                        4,
                        9
                    ]
                ]
            ],
            iris: [
                [
                    'gray',
                    14.5,
                    4.5,
                    5,
                    0,
                    2 * Math.PI
                ],
                [
                    'black',
                    14.5,
                    4.5,
                    2,
                    0,
                    2 * Math.PI
                ],
                [
                    'white',
                    11.5,
                    2,
                    1.5,
                    0,
                    2 * Math.PI
                ],
                [
                    'white',
                    17.5,
                    7,
                    1,
                    0,
                    2 * Math.PI
                ]
            ],
            shift: 29
        },
        1: {
            contour: [
                [
                    [
                        4,
                        7.5
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        6,
                        2.5
                    ],
                    [
                        8.5,
                        0.5
                    ],
                    [
                        12,
                        0
                    ],
                    [
                        18,
                        0
                    ],
                    [
                        22,
                        1
                    ],
                    [
                        24,
                        2
                    ],
                    [
                        26,
                        5
                    ],
                    [
                        28,
                        5
                    ],
                    [
                        26,
                        5
                    ],
                    [
                        24,
                        7.5
                    ],
                    [
                        19,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        4,
                        7.5
                    ]
                ]
            ],
            back: [
                [
                    [
                        4,
                        7.5
                    ],
                    [
                        4,
                        5.5
                    ],
                    [
                        5.5,
                        2
                    ],
                    [
                        8.5,
                        -0.5
                    ],
                    [
                        11.5,
                        -1
                    ],
                    [
                        15,
                        -1.5
                    ],
                    [
                        18,
                        -1
                    ],
                    [
                        22,
                        0.5
                    ],
                    [
                        24,
                        1.5
                    ],
                    [
                        26,
                        4.5
                    ],
                    [
                        28,
                        4.5
                    ],
                    [
                        26,
                        4.5
                    ],
                    [
                        24,
                        7.5
                    ],
                    [
                        19,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        4,
                        7.5
                    ]
                ]
            ],
            iris: [
                [
                    'gray',
                    14,
                    4.5,
                    4.5,
                    0,
                    2 * Math.PI
                ],
                [
                    'black',
                    14,
                    4.5,
                    2,
                    0,
                    2 * Math.PI
                ],
                [
                    'white',
                    11.5,
                    2.5,
                    1.5,
                    0,
                    2 * Math.PI
                ],
                [
                    'white',
                    17,
                    6.5,
                    1,
                    0,
                    2 * Math.PI
                ]
            ],
            shift: 28
        },
        2: {
            contour: [
                [
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        5
                    ],
                    [
                        6.5,
                        2
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        18,
                        0
                    ],
                    [
                        23,
                        1.5
                    ],
                    [
                        25,
                        4
                    ],
                    [
                        25,
                        7
                    ]
                ],
                [
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        5
                    ],
                    [
                        7,
                        2.5
                    ],
                    [
                        10,
                        1
                    ],
                    [
                        17,
                        1
                    ],
                    [
                        22,
                        2
                    ],
                    [
                        24,
                        4
                    ],
                    [
                        25,
                        7
                    ]
                ],
                [
                    [
                        7,
                        9
                    ],
                    [
                        20,
                        9
                    ],
                    [
                        23,
                        8
                    ]
                ]
            ],
            iris: [
                [
                    'gray',
                    14,
                    5,
                    4,
                    0,
                    2 * Math.PI
                ],
                [
                    'black',
                    14,
                    5,
                    1.75,
                    0,
                    2 * Math.PI
                ],
                [
                    'white',
                    12,
                    2.5,
                    1.25,
                    0,
                    2 * Math.PI
                ],
                [
                    'white',
                    16.5,
                    7,
                    0.5,
                    0,
                    2 * Math.PI
                ]
            ],
            shift: 28
        },
        3: {
            contour: [
                [
                    [
                        6,
                        6
                    ],
                    [
                        6,
                        5
                    ],
                    [
                        7.5,
                        1.5
                    ],
                    [
                        10.5,
                        0.5
                    ],
                    [
                        13,
                        0
                    ],
                    [
                        16,
                        0
                    ],
                    [
                        20.5,
                        0.5
                    ],
                    [
                        22.5,
                        1.5
                    ],
                    [
                        24.5,
                        5
                    ]
                ],
                [
                    [
                        6,
                        6
                    ],
                    [
                        6,
                        5
                    ],
                    [
                        8,
                        2
                    ],
                    [
                        11,
                        1
                    ],
                    [
                        15,
                        0.5
                    ],
                    [
                        19,
                        1
                    ],
                    [
                        22,
                        2
                    ],
                    [
                        24.5,
                        5
                    ]
                ],
                [
                    [
                        8,
                        7
                    ],
                    [
                        19,
                        7
                    ],
                    [
                        23,
                        6
                    ]
                ]
            ],
            iris: [
                [
                    'gray',
                    14,
                    4,
                    3,
                    0,
                    2 * Math.PI
                ],
                [
                    'black',
                    14,
                    4,
                    1.5,
                    0,
                    2 * Math.PI
                ],
                [
                    'white',
                    12.5,
                    2,
                    1,
                    0,
                    2 * Math.PI
                ],
                [
                    'white',
                    15,
                    5.5,
                    0.5,
                    0,
                    2 * Math.PI
                ]
            ],
            shift: 28
        }
    };
    /**
   * Noses
   */ static noses = {
        0: [
            [
                0,
                1
            ],
            [
                -1,
                3
            ],
            [
                -4,
                7
            ],
            [
                -3,
                8
            ],
            [
                0,
                9
            ],
            [
                -1,
                7
            ],
            [
                0,
                3
            ],
            [
                0,
                1
            ]
        ],
        1: [
            [
                0,
                0
            ],
            [
                -1.5,
                3.5
            ],
            [
                -5,
                7.5
            ],
            [
                -5,
                8
            ],
            [
                -4.5,
                9
            ],
            [
                0,
                10
            ],
            [
                -2,
                9
            ],
            [
                -2.5,
                8
            ],
            [
                -1,
                6
            ],
            [
                0,
                2
            ],
            [
                0,
                0
            ]
        ],
        2: [
            [
                -0.5,
                0
            ],
            [
                -2.5,
                3
            ],
            [
                -3,
                5.5
            ],
            [
                -5.5,
                7.5
            ],
            [
                -5,
                9
            ],
            [
                0,
                10
            ],
            [
                -2.5,
                9
            ],
            [
                -3,
                7.5
            ],
            [
                -1,
                6
            ],
            [
                -1,
                4
            ],
            [
                -0.5,
                2
            ],
            [
                -0.5,
                0
            ]
        ],
        3: [
            [
                -0.5,
                -2
            ],
            [
                -3.5,
                1
            ],
            [
                -4,
                4.5
            ],
            [
                -6,
                7
            ],
            [
                -5.5,
                9
            ],
            [
                0.5,
                10
            ],
            [
                -3,
                8.5
            ],
            [
                -3.5,
                7
            ],
            [
                -1.5,
                5.5
            ],
            [
                -1.5,
                2
            ],
            [
                -0.5,
                0
            ],
            [
                -0.5,
                -2
            ]
        ]
    };
    static halfUpperLip0 = [
        [
            0,
            0
        ],
        [
            3,
            -0.5
        ],
        [
            6,
            0.75
        ],
        [
            8,
            1
        ],
        [
            6,
            2
        ],
        [
            3,
            1.5
        ],
        [
            0,
            2
        ]
    ];
    static halfLowerLip0 = [
        [
            0,
            2
        ],
        [
            3,
            1.5
        ],
        [
            6,
            2
        ],
        [
            4,
            3.5
        ],
        [
            0,
            4
        ]
    ];
    static halfUpperLip1 = [
        [
            0,
            0
        ],
        [
            3.5,
            -0.25
        ],
        [
            7,
            0.75
        ],
        [
            10,
            1
        ],
        [
            8,
            1.75
        ],
        [
            0,
            1.75
        ]
    ];
    static halfLowerLip1 = [
        [
            0,
            1.25
        ],
        [
            3.5,
            1.25
        ],
        [
            9,
            1.75
        ],
        [
            4,
            2.5
        ],
        [
            0,
            2.75
        ]
    ];
    static halfUpperLip2 = [
        [
            0,
            0
        ],
        [
            4,
            0
        ],
        [
            11,
            1.5
        ],
        [
            0,
            1.5
        ]
    ];
    static halfLowerLip2 = [
        [
            0,
            1.5
        ],
        [
            0.5,
            1.5
        ],
        [
            9,
            1.5
        ],
        [
            4.5,
            2.5
        ],
        [
            0.5,
            2.5
        ],
        [
            0,
            2.5
        ]
    ];
    /**
   * Mouths
   */ static mouths = {
        0: [
            $5800eac20157ce7c$export$2e2bcd8739ae039.halfLowerLip0.concat($5800eac20157ce7c$export$2e2bcd8739ae039.halfLowerLip0.map((0, $cFF3j.mirror)).slice().reverse()),
            $5800eac20157ce7c$export$2e2bcd8739ae039.halfUpperLip0.concat($5800eac20157ce7c$export$2e2bcd8739ae039.halfUpperLip0.map((0, $cFF3j.mirror)).slice().reverse())
        ],
        1: [
            $5800eac20157ce7c$export$2e2bcd8739ae039.halfUpperLip1.concat($5800eac20157ce7c$export$2e2bcd8739ae039.halfUpperLip1.map((0, $cFF3j.mirror)).slice().reverse()),
            $5800eac20157ce7c$export$2e2bcd8739ae039.halfLowerLip0.concat($5800eac20157ce7c$export$2e2bcd8739ae039.halfLowerLip0.map((0, $cFF3j.mirror)).slice().reverse()).map((0, $cFF3j.shift)(0, -0.25))
        ],
        2: [
            $5800eac20157ce7c$export$2e2bcd8739ae039.halfUpperLip1.concat($5800eac20157ce7c$export$2e2bcd8739ae039.halfUpperLip1.map((0, $cFF3j.mirror)).slice().reverse()),
            $5800eac20157ce7c$export$2e2bcd8739ae039.halfLowerLip1.concat($5800eac20157ce7c$export$2e2bcd8739ae039.halfLowerLip1.map((0, $cFF3j.mirror)).slice().reverse())
        ],
        3: [
            $5800eac20157ce7c$export$2e2bcd8739ae039.halfUpperLip2.concat($5800eac20157ce7c$export$2e2bcd8739ae039.halfUpperLip2.map((0, $cFF3j.mirror)).slice().reverse()),
            $5800eac20157ce7c$export$2e2bcd8739ae039.halfLowerLip2.concat($5800eac20157ce7c$export$2e2bcd8739ae039.halfLowerLip2.map((0, $cFF3j.mirror)).slice().reverse())
        ]
    };
    /**
   * Reusable back hair
   */ static halfHair0 = [
        [
            0,
            0
        ],
        [
            -5,
            -6
        ],
        [
            -15,
            -4
        ],
        [
            -20,
            -1
        ],
        [
            -32,
            10
        ],
        [
            -33,
            15
        ],
        [
            -37,
            30
        ],
        [
            -33,
            25
        ],
        [
            -35,
            40
        ],
        [
            -40,
            55
        ],
        [
            -35,
            50
        ],
        [
            -30,
            60
        ],
        [
            -30,
            75
        ],
        [
            -25,
            70
        ],
        [
            -20,
            77
        ],
        [
            -15,
            72
        ],
        [
            -10,
            79
        ],
        [
            -5,
            75
        ],
        [
            0,
            80
        ]
    ];
    static halfHair1 = [
        [
            0,
            0
        ],
        [
            -5,
            -6
        ],
        [
            -15,
            -4
        ],
        [
            -20,
            -1
        ],
        [
            -32,
            10
        ],
        [
            -33,
            15
        ],
        [
            -37,
            30
        ],
        [
            -33,
            25
        ],
        [
            -35,
            40
        ],
        [
            -40,
            55
        ],
        [
            -35,
            50
        ],
        [
            -25,
            65
        ],
        [
            -20,
            72
        ],
        [
            -15,
            76
        ],
        [
            -10,
            79
        ],
        [
            -5,
            75
        ],
        [
            0,
            80
        ]
    ];
    static halfHair2 = [
        [
            0,
            0
        ],
        [
            -5,
            -6
        ],
        [
            -15,
            -4
        ],
        [
            -20,
            -1
        ],
        [
            -32,
            10
        ],
        [
            -33,
            15
        ],
        [
            -37,
            30
        ],
        [
            -33,
            25
        ],
        [
            -35,
            40
        ],
        [
            -40,
            55
        ],
        [
            -35,
            50
        ],
        [
            -40,
            105
        ],
        [
            -25,
            108
        ],
        [
            -20,
            107
        ],
        [
            -15,
            108
        ],
        [
            -10,
            109
        ],
        [
            -5,
            108
        ],
        [
            0,
            110
        ]
    ];
    /**
   * Hair on the back layer
   */ static backHair = {
        0: [
            $5800eac20157ce7c$export$2e2bcd8739ae039.halfHair0.concat($5800eac20157ce7c$export$2e2bcd8739ae039.halfHair1.map((0, $cFF3j.mirror)).slice().reverse()),
            [
                [
                    -20,
                    70
                ],
                [
                    -20,
                    80
                ],
                [
                    -15,
                    85
                ],
                [
                    -10,
                    72
                ]
            ],
            [
                [
                    -26,
                    63
                ],
                [
                    -25,
                    80
                ],
                [
                    -20,
                    75
                ],
                [
                    -18,
                    68
                ]
            ]
        ],
        1: [
            $5800eac20157ce7c$export$2e2bcd8739ae039.halfHair1.concat($5800eac20157ce7c$export$2e2bcd8739ae039.halfHair1.map((0, $cFF3j.mirror)).slice().reverse())
        ],
        2: [
            $5800eac20157ce7c$export$2e2bcd8739ae039.halfHair0.concat($5800eac20157ce7c$export$2e2bcd8739ae039.halfHair0.map((0, $cFF3j.mirror)).slice().reverse())
        ],
        3: [
            $5800eac20157ce7c$export$2e2bcd8739ae039.halfHair2.concat($5800eac20157ce7c$export$2e2bcd8739ae039.halfHair2.map((0, $cFF3j.mirror)).slice().reverse())
        ]
    };
    /**
   * Reusable front hair
   */ static topBang = [
        [
            0,
            0
        ],
        [
            -2,
            -5
        ],
        [
            0,
            -8
        ],
        [
            3,
            -7
        ],
        [
            1,
            -5
        ]
    ];
    static bigBang = [
        [
            0,
            3
        ],
        [
            7,
            2
        ],
        [
            17,
            10
        ],
        [
            22,
            20
        ],
        [
            17,
            16
        ],
        [
            14,
            15
        ],
        [
            17,
            20
        ],
        [
            17,
            23
        ],
        [
            14,
            20
        ],
        [
            8,
            17
        ],
        [
            5,
            24
        ],
        [
            -2,
            30
        ],
        [
            -1,
            25
        ],
        [
            -1,
            20
        ],
        [
            -6,
            25
        ],
        [
            -12,
            28
        ],
        [
            -10,
            25
        ],
        [
            -8,
            20
        ],
        [
            -18,
            26
        ],
        [
            -22,
            27
        ],
        [
            -19,
            23
        ],
        [
            -18,
            20
        ],
        [
            -26,
            22
        ],
        [
            -20,
            12
        ],
        [
            -7,
            2
        ],
        [
            0,
            3
        ]
    ];
    static leftPony = [
        [
            -35,
            50
        ],
        [
            -45,
            55
        ],
        [
            -48,
            70
        ],
        [
            -45,
            65
        ],
        [
            -45,
            80
        ],
        [
            -40,
            70
        ],
        [
            -35,
            75
        ],
        [
            -38,
            60
        ]
    ];
    static leftKnot = [
        [
            -35,
            50
        ],
        [
            -39,
            49
        ],
        [
            -39,
            52
        ],
        [
            -35,
            52
        ]
    ];
    static leftBang0 = [
        [
            0,
            0
        ],
        [
            -5,
            -6
        ],
        [
            -15,
            -4
        ],
        [
            -20,
            -1
        ],
        [
            -32,
            10
        ],
        [
            -33,
            15
        ],
        [
            -38,
            32
        ],
        [
            -33,
            25
        ],
        [
            0,
            3
        ]
    ];
    static leftBang1 = [
        [
            0,
            3
        ],
        [
            -10,
            8
        ],
        [
            -15,
            13
        ],
        [
            -15,
            23
        ],
        [
            -10,
            13
        ]
    ];
    static leftBang2 = [
        [
            -20,
            7
        ],
        [
            -30,
            35
        ],
        [
            -30,
            55
        ],
        [
            -34,
            37
        ],
        [
            -40,
            40
        ],
        [
            -35,
            28
        ],
        [
            -30,
            15
        ]
    ];
    /**
   * Hair on the front layer
   */ static frontHair = {
        0: [
            $5800eac20157ce7c$export$2e2bcd8739ae039.topBang,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang2,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang2.map((0, $cFF3j.mirror)),
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang0,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang0.map((0, $cFF3j.mirror)),
            $5800eac20157ce7c$export$2e2bcd8739ae039.bigBang.map((0, $cFF3j.mult)(1.35, 1.2)).map((0, $cFF3j.shift)(2, 0)),
            [
                [
                    -20,
                    75
                ],
                [
                    -20,
                    85
                ],
                [
                    -25,
                    90
                ],
                [
                    -26,
                    80
                ],
                [
                    -20,
                    75
                ]
            ],
            [
                [
                    -20,
                    80
                ],
                [
                    -20,
                    90
                ],
                [
                    -15,
                    95
                ],
                [
                    -14,
                    85
                ],
                [
                    -20,
                    80
                ]
            ],
            [
                [
                    -20,
                    85
                ],
                [
                    -20,
                    95
                ],
                [
                    -25,
                    97
                ],
                [
                    -26,
                    90
                ],
                [
                    -20,
                    85
                ]
            ],
            [
                [
                    -20,
                    90
                ],
                [
                    -20,
                    95
                ],
                [
                    -17,
                    100
                ],
                [
                    -14,
                    95
                ],
                [
                    -20,
                    90
                ]
            ],
            [
                [
                    -24,
                    99
                ],
                [
                    -15,
                    99
                ],
                [
                    -14,
                    105
                ],
                [
                    -15,
                    110
                ],
                [
                    -17,
                    108
                ],
                [
                    -18,
                    112
                ],
                [
                    -20,
                    115
                ],
                [
                    -22,
                    111
                ],
                [
                    -22,
                    108
                ],
                [
                    -24,
                    112
                ],
                [
                    -25,
                    105
                ],
                [
                    -27,
                    106
                ],
                [
                    -24,
                    99
                ]
            ],
            [
                [
                    -25,
                    95
                ],
                [
                    -15,
                    95
                ],
                [
                    -14,
                    97
                ],
                [
                    -15,
                    99
                ],
                [
                    -24,
                    99
                ],
                [
                    -26,
                    97
                ]
            ]
        ],
        1: [
            $5800eac20157ce7c$export$2e2bcd8739ae039.topBang,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang2,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang2.map((0, $cFF3j.mirror)),
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang0,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang0.map((0, $cFF3j.mirror)),
            $5800eac20157ce7c$export$2e2bcd8739ae039.bigBang,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftPony,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftPony.map((0, $cFF3j.mirror)),
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftKnot,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftKnot.map((0, $cFF3j.mirror))
        ],
        2: [
            $5800eac20157ce7c$export$2e2bcd8739ae039.topBang,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang2,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang2.map((0, $cFF3j.mirror)),
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang0,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang0.map((0, $cFF3j.mirror)),
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang1,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang1.map((0, $cFF3j.mirror)),
            [
                [
                    0,
                    3
                ],
                [
                    5,
                    13
                ],
                [
                    5,
                    18
                ],
                [
                    -2,
                    23
                ],
                [
                    0,
                    18
                ]
            ]
        ],
        3: [
            $5800eac20157ce7c$export$2e2bcd8739ae039.topBang,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang2,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang2.map((0, $cFF3j.mirror)),
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang0,
            $5800eac20157ce7c$export$2e2bcd8739ae039.leftBang0.map((0, $cFF3j.mirror))
        ]
    };
    static bodyShape = [
        [
            [
                0,
                [
                    [
                        0,
                        0
                    ],
                    [
                        9,
                        0
                    ],
                    [
                        10,
                        15
                    ],
                    [
                        11,
                        18
                    ],
                    [
                        13,
                        19
                    ],
                    [
                        17,
                        20
                    ],
                    [
                        35,
                        24
                    ],
                    [
                        42,
                        25,
                        'purple',
                        2
                    ],
                    [
                        48,
                        28
                    ],
                    [
                        51,
                        33
                    ],
                    [
                        54,
                        46
                    ],
                    [
                        60,
                        64
                    ],
                    [
                        65,
                        95
                    ],
                    [
                        65,
                        105,
                        'purple',
                        2
                    ],
                    [
                        68,
                        120
                    ],
                    [
                        66,
                        170
                    ],
                    [
                        62,
                        185,
                        'purple',
                        2
                    ],
                    [
                        56,
                        192
                    ],
                    [
                        51,
                        189
                    ],
                    [
                        53,
                        180
                    ],
                    [
                        54,
                        177
                    ],
                    [
                        53,
                        179
                    ],
                    [
                        51,
                        177
                    ],
                    [
                        57,
                        170
                    ],
                    [
                        58,
                        165,
                        'purple',
                        2
                    ],
                    [
                        58,
                        160
                    ],
                    [
                        51,
                        120
                    ],
                    [
                        52,
                        107,
                        'purple',
                        2
                    ],
                    [
                        51,
                        100
                    ],
                    [
                        47,
                        90
                    ],
                    [
                        42,
                        74
                    ],
                    [
                        39,
                        58
                    ],
                    [
                        36,
                        50
                    ],
                    [
                        35,
                        45
                    ],
                    [
                        36,
                        50,
                        'purple',
                        2
                    ],
                    [
                        37,
                        62
                    ],
                    [
                        37,
                        70
                    ],
                    [
                        35,
                        78
                    ],
                    [
                        32,
                        84
                    ],
                    [
                        29,
                        90,
                        'purple',
                        2
                    ],
                    [
                        26,
                        100
                    ],
                    [
                        26,
                        110
                    ],
                    [
                        27,
                        115
                    ],
                    [
                        30,
                        120
                    ],
                    [
                        33,
                        125
                    ],
                    [
                        36,
                        133,
                        'purple',
                        2
                    ],
                    [
                        40,
                        152
                    ],
                    [
                        42,
                        170
                    ],
                    [
                        45,
                        190
                    ],
                    [
                        48,
                        230
                    ],
                    [
                        47,
                        250
                    ],
                    [
                        45,
                        265
                    ],
                    [
                        45,
                        270
                    ],
                    [
                        44,
                        276,
                        'purple',
                        2
                    ],
                    [
                        47,
                        295
                    ],
                    [
                        48,
                        310
                    ],
                    [
                        48,
                        325
                    ],
                    [
                        47,
                        345
                    ],
                    [
                        47,
                        365
                    ],
                    [
                        48,
                        368
                    ],
                    [
                        48,
                        372
                    ],
                    [
                        58,
                        384,
                        'purple',
                        2
                    ],
                    [
                        58,
                        388
                    ],
                    [
                        53,
                        390
                    ],
                    [
                        36,
                        390
                    ],
                    [
                        31,
                        389
                    ],
                    [
                        31,
                        384
                    ],
                    [
                        36,
                        372,
                        'purple',
                        2
                    ],
                    [
                        35,
                        370
                    ],
                    [
                        35,
                        368
                    ],
                    [
                        36,
                        365
                    ],
                    [
                        33,
                        345
                    ],
                    [
                        30,
                        335
                    ],
                    [
                        26,
                        320
                    ],
                    [
                        24,
                        300
                    ],
                    [
                        23,
                        278
                    ],
                    [
                        21,
                        270,
                        'purple',
                        2
                    ],
                    [
                        20,
                        267
                    ],
                    [
                        13,
                        240
                    ],
                    [
                        3,
                        195
                    ],
                    [
                        1,
                        173
                    ]
                ]
            ]
        ],
        [
            [
                0,
                [
                    [
                        0,
                        0
                    ],
                    [
                        14,
                        0
                    ],
                    [
                        12,
                        12
                    ],
                    [
                        14,
                        18
                    ],
                    [
                        21,
                        19
                    ],
                    [
                        25,
                        20
                    ],
                    [
                        35,
                        24
                    ],
                    [
                        40,
                        23
                    ],
                    [
                        45,
                        24,
                        'red',
                        2
                    ],
                    [
                        52,
                        28
                    ],
                    [
                        57,
                        33
                    ],
                    [
                        58,
                        39
                    ],
                    [
                        58,
                        48
                    ],
                    [
                        59,
                        52
                    ],
                    [
                        64,
                        64
                    ],
                    [
                        68,
                        95
                    ],
                    [
                        66,
                        105,
                        'red',
                        2
                    ],
                    [
                        69,
                        120
                    ],
                    [
                        69,
                        150
                    ],
                    [
                        66,
                        170
                    ],
                    [
                        62,
                        185,
                        'red',
                        2
                    ],
                    [
                        56,
                        195
                    ],
                    [
                        49,
                        192
                    ],
                    [
                        48,
                        190
                    ],
                    [
                        52,
                        180
                    ],
                    [
                        51,
                        182
                    ],
                    [
                        49,
                        180
                    ],
                    [
                        57,
                        170
                    ],
                    [
                        57,
                        165,
                        'red',
                        2
                    ],
                    [
                        55,
                        150
                    ],
                    [
                        52,
                        140
                    ],
                    [
                        50,
                        120
                    ],
                    [
                        52,
                        107,
                        'red',
                        2
                    ],
                    [
                        50,
                        100
                    ],
                    [
                        45,
                        90
                    ],
                    [
                        40,
                        74
                    ],
                    [
                        38,
                        58
                    ],
                    [
                        36,
                        50
                    ],
                    [
                        36,
                        50,
                        'red',
                        2
                    ],
                    [
                        38,
                        58
                    ],
                    [
                        39,
                        68
                    ],
                    [
                        37,
                        78
                    ],
                    [
                        35,
                        85
                    ],
                    [
                        32,
                        92,
                        'red',
                        2
                    ],
                    [
                        31,
                        102
                    ],
                    [
                        30,
                        108
                    ],
                    [
                        30,
                        115
                    ],
                    [
                        31,
                        120
                    ],
                    [
                        33,
                        125
                    ],
                    [
                        36,
                        133,
                        'red',
                        2
                    ],
                    [
                        41,
                        152
                    ],
                    [
                        41,
                        170
                    ],
                    [
                        46,
                        190
                    ],
                    [
                        49,
                        230
                    ],
                    [
                        48,
                        250
                    ],
                    [
                        46,
                        265
                    ],
                    [
                        46,
                        272
                    ],
                    [
                        45,
                        278,
                        'red',
                        2
                    ],
                    [
                        49,
                        295
                    ],
                    [
                        51,
                        310
                    ],
                    [
                        50,
                        325
                    ],
                    [
                        47,
                        350
                    ],
                    [
                        47,
                        370
                    ],
                    [
                        48,
                        373
                    ],
                    [
                        48,
                        377
                    ],
                    [
                        58,
                        389,
                        'red',
                        2
                    ],
                    [
                        58,
                        393
                    ],
                    [
                        53,
                        395
                    ],
                    [
                        36,
                        395
                    ],
                    [
                        31,
                        394
                    ],
                    [
                        31,
                        389
                    ],
                    [
                        36,
                        377,
                        'red',
                        2
                    ],
                    [
                        35,
                        370
                    ],
                    [
                        35,
                        373
                    ],
                    [
                        36,
                        365
                    ],
                    [
                        32,
                        345
                    ],
                    [
                        29,
                        335
                    ],
                    [
                        25,
                        320
                    ],
                    [
                        23,
                        300
                    ],
                    [
                        23,
                        280
                    ],
                    [
                        21,
                        274,
                        'red',
                        2
                    ],
                    [
                        20,
                        267
                    ],
                    [
                        13,
                        240
                    ],
                    [
                        3,
                        195
                    ],
                    [
                        1,
                        173
                    ]
                ]
            ]
        ]
    ];
    static underwearTop = [
        [
            42,
            [
                [
                    20,
                    0
                ],
                [
                    21,
                    -22
                ],
                [
                    25,
                    -21
                ],
                [
                    25,
                    0
                ]
            ]
        ],
        [
            40,
            [
                [
                    25,
                    0
                ],
                [
                    32,
                    10
                ],
                [
                    35,
                    20
                ],
                [
                    36,
                    26
                ],
                [
                    37,
                    28
                ],
                [
                    38,
                    28
                ],
                [
                    36,
                    37
                ],
                [
                    32,
                    45
                ],
                [
                    29,
                    60
                ],
                [
                    30,
                    70
                ]
            ]
        ]
    ];
    static underwearDress = [
        [
            42,
            [
                [
                    20,
                    0
                ],
                [
                    21,
                    -22
                ],
                [
                    25,
                    -21
                ],
                [
                    25,
                    0
                ]
            ]
        ],
        [
            110,
            [
                [
                    28,
                    0,
                    'fuchsia',
                    2
                ],
                [
                    29,
                    5
                ],
                [
                    34,
                    15
                ],
                [
                    36,
                    20
                ],
                [
                    40,
                    35
                ],
                [
                    42,
                    45,
                    'fuchsia',
                    2
                ],
                [
                    44,
                    59
                ],
                [
                    46,
                    80
                ],
                [
                    48,
                    87
                ],
                [
                    50,
                    97
                ],
                [
                    51,
                    100
                ],
                [
                    42,
                    102,
                    'fuchsia',
                    2
                ],
                [
                    36,
                    105
                ],
                [
                    26,
                    108
                ],
                [
                    10,
                    110
                ]
            ]
        ],
        [
            40,
            [
                [
                    25,
                    -2,
                    'fuchsia',
                    2
                ],
                [
                    32,
                    10
                ],
                [
                    35,
                    20
                ],
                [
                    36,
                    26
                ],
                [
                    37,
                    28
                ],
                [
                    37,
                    28
                ],
                [
                    35,
                    38
                ],
                [
                    32,
                    45
                ],
                [
                    29,
                    54,
                    'fuchsia',
                    2
                ],
                [
                    27,
                    62
                ],
                [
                    27,
                    72
                ],
                [
                    29,
                    75
                ]
            ]
        ]
    ];
    static underwearBottom = [
        [
            150,
            [
                [
                    5,
                    0
                ],
                [
                    20,
                    -3
                ],
                [
                    38,
                    -10
                ],
                [
                    39,
                    -6
                ],
                [
                    15,
                    3
                ],
                [
                    13,
                    10
                ],
                [
                    3,
                    25
                ]
            ]
        ],
        [
            148,
            [
                [
                    4,
                    0
                ],
                [
                    15,
                    -1
                ],
                [
                    20,
                    55
                ],
                [
                    0,
                    57
                ]
            ]
        ]
    ];
    static swimSuit = [
        [
            70,
            [
                [
                    1,
                    0
                ],
                [
                    8,
                    -15
                ],
                [
                    15,
                    -25
                ],
                [
                    19,
                    -30
                ],
                [
                    18,
                    -40
                ],
                [
                    13,
                    -52
                ],
                [
                    15,
                    -52
                ],
                [
                    20,
                    -40
                ],
                [
                    25,
                    -30
                ],
                [
                    29,
                    -25
                ],
                [
                    34,
                    -15
                ],
                [
                    37,
                    -2
                ],
                [
                    35,
                    7
                ],
                [
                    32,
                    13
                ],
                [
                    30,
                    22
                ],
                [
                    27,
                    32
                ],
                [
                    27,
                    38
                ],
                [
                    28,
                    45
                ],
                [
                    31,
                    50
                ],
                [
                    34,
                    55
                ],
                [
                    36,
                    60
                ],
                [
                    28,
                    70
                ],
                [
                    16,
                    80
                ],
                [
                    9,
                    90
                ],
                [
                    5,
                    100
                ],
                [
                    4,
                    102
                ],
                [
                    2,
                    104
                ]
            ]
        ],
        [
            70,
            [
                [
                    1,
                    0
                ],
                [
                    1,
                    2
                ],
                [
                    6,
                    7
                ],
                [
                    10,
                    9
                ],
                [
                    25,
                    11
                ],
                [
                    32,
                    13
                ],
                [
                    32,
                    14
                ],
                [
                    25,
                    12
                ],
                [
                    10,
                    10
                ],
                [
                    6,
                    8
                ],
                [
                    1,
                    3
                ]
            ]
        ]
    ];
}

});


parcelRegister("bCXGN", function(module, exports) {

$parcel$export(module.exports, "PopOverEvents", () => $87718b5b103f71ba$export$159e33605e0d5528);
$parcel$export(module.exports, "default", () => $87718b5b103f71ba$export$2e2bcd8739ae039);
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2023
 */ parcelRequire("1ND9v");
var $6WiAp = parcelRequire("6WiAp");
class $87718b5b103f71ba$export$159e33605e0d5528 {
    static MODAL_OPEN = 'ui>popover-open';
    static MODAL_REPLACE = 'ui>popover-replace';
    static MODAL_CLOSE = 'ui>popover-close';
}
class $87718b5b103f71ba$export$7b720866ac65f21d extends (0, $6WiAp.default) {
    constructor(opt){
        super(Object.assign(opt, {
            html: '<div id="loading">Loading...</div>'
        }));
    }
}
class $87718b5b103f71ba$export$52499e2c5ea4b095 extends (0, $6WiAp.default) {
    constructor(opt){
        super(Object.assign({}, opt, {
            html: ()=>`<div id="message" class="popover">
  <p>${this.message}</p>
  <button id="close">${this.context.modal.close}</button>
</div>
`
        }));
        this.message = opt?.message || '';
        this.actions = opt?.actions;
    }
    init() {
        this.addEvtById('close', 'click', ()=>{
            this.emit(this.actions.close);
        });
    }
}
class $87718b5b103f71ba$export$af36bcbfcb772287 extends (0, $6WiAp.default) {
    constructor(opt){
        super(Object.assign({}, opt));
        this.actions = opt.actions;
        this.count = opt.count;
        this.ComponentClass = opt.ComponentClass;
        this.param = opt.param;
        this.level = opt.level;
    }
    init() {
        const { eventBus: eventBus, context: context, box: box } = this;
        this.addChildren(new this.ComponentClass({
            eventBus: eventBus,
            context: context,
            box: box,
            ...this.param,
            actions: this.actions
        }));
        const layerBox = this.prepareBox();
        layerBox.style.zIndex = 500 + this.level * 10;
        layerBox.classList.add('layer-top');
        const childBox = layerBox.firstChild;
        childBox.style.zIndex = 500 + this.level * 10 + 1;
        this.addEvtById(this.box, 'click', (evt)=>{
            if (evt.target.id === this.box) this.emit(this.actions.close);
        });
    }
    setTop() {
        this.prepareBox().classList.add('layer-top');
    }
    unsetTop() {
        this.prepareBox().classList.remove('layer-top');
    }
    replaceChild(ComponentClass, param) {
        this.logger?.log(this.name, '.replaceChild:', ComponentClass, param);
        const { eventBus: eventBus, context: context, box: box } = this;
        this.removeChildren();
        this.addChildren(new ComponentClass({
            eventBus: eventBus,
            context: context,
            box: box,
            ...param,
            actions: this.actions
        }));
        const childBox = this.prepareBox().firstChild;
        childBox.style.zIndex = 500 + this.level * 10 + 1;
    }
}
class $87718b5b103f71ba$export$2e2bcd8739ae039 extends (0, $6WiAp.default) {
    constructor(opt){
        super(Object.assign({}, opt));
        this.actions = opt?.actions || {
            close: $87718b5b103f71ba$export$159e33605e0d5528.MODAL_CLOSE,
            open: $87718b5b103f71ba$export$159e33605e0d5528.MODAL_OPEN,
            replace: $87718b5b103f71ba$export$159e33605e0d5528.MODAL_REPLACE
        };
        this.layerStack = [];
        this.count = 0;
    }
    init() {
        this.on(this.actions.close, (all = false)=>{
            this.onClose(all);
        });
        this.on(this.actions.open, (ComponentClass = $87718b5b103f71ba$export$7b720866ac65f21d, param = {})=>{
            this.onOpen(ComponentClass, param);
        });
        this.on(this.actions.replace, (ComponentClass = $87718b5b103f71ba$export$7b720866ac65f21d, param = {})=>{
            if (this.layerStack.length > 1) {
                ({ ComponentClass: ComponentClass, param: param } = this.prepareComponentChild(ComponentClass, param));
                this.layerStack.at(-1).replaceChild(ComponentClass, param);
            } else this.onOpen(ComponentClass, param);
        });
    }
    onOpen(ComponentClass, param) {
        ({ ComponentClass: ComponentClass, param: param } = this.prepareComponentChild(ComponentClass, param));
        this.prepareBox().style.display = 'block';
        this.addLayer(ComponentClass, param);
    }
    prepareComponentChild(ComponentClass, param) {
        if (typeof ComponentClass === 'string') {
            param = {
                message: ComponentClass,
                ...param
            };
            ComponentClass = $87718b5b103f71ba$export$52499e2c5ea4b095;
        }
        return {
            ComponentClass: ComponentClass,
            param: param
        };
    }
    onClose(all) {
        if (all) {
            this.empty();
            this.removeChildren();
            this.layerStack = [];
            this.prepareBox().style.display = 'none';
        } else if (this.layerStack.length > 0) {
            this.removeLayer();
            if (this.layerStack.length === 0) {
                this.empty();
                this.prepareBox().style.display = 'none';
            }
        }
    }
    addLayer(ComponentClass, param) {
        if (this.layerStack.length > 0) this.layerStack.at(-1).unsetTop();
        const newLayerBox = this.fragmentFromHtml(`<div id="popover-layer-${this.count}" class="layer"></div>`);
        this.prepareBox().appendChild(newLayerBox.firstChild);
        const { eventBus: eventBus, context: context } = this;
        const layer = new $87718b5b103f71ba$export$af36bcbfcb772287({
            eventBus: eventBus,
            context: context,
            box: `popover-layer-${this.count}`,
            ComponentClass: ComponentClass,
            param: param,
            count: this.count++,
            level: this.layerStack.length,
            actions: this.actions
        });
        this.layerStack.push(layer);
        this.addChildren(layer);
    }
    removeLayer() {
        const last = this.layerStack.pop();
        this.removeChildren(last);
        this.prepareBox().removeChild(last.prepareBox());
        if (this.layerStack.length > 0) this.layerStack.at(-1).setTop();
    }
}

});

/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */ parcelRequire("1ND9v");
var $6WiAp = parcelRequire("6WiAp");
var $1ND9v = parcelRequire("1ND9v");
var $cRMCj = parcelRequire("cRMCj");
var $iLAKo = parcelRequire("iLAKo");

var $iqDbY = parcelRequire("iqDbY");

var $2SPoJ = parcelRequire("2SPoJ");
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */ class $781ef74ef01a0874$export$2e2bcd8739ae039 {
    static Default = '';
    static Root = '/';
    static FaceSplit = (s)=>/\/face\/(?<zoom>.*?)\/(?<part>.*?)\//.exec(s)?.groups;
    static Face = (zoom = ':zoom', part = '')=>`/face/${zoom}/${part}`;
    static Portrait = 'portrait';
    static Full = 'full';
    static Head = 'head';
    static Eyes = 'eyes';
    static NoseMouth = 'nose-mouth';
    static Hair = 'hair';
    static Body = 'body';
    static Name = ()=>'/name/';
    static Register = ()=>'/register/';
}


/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */ parcelRequire("1ND9v");
var $6WiAp = parcelRequire("6WiAp");
var $iLAKo = parcelRequire("iLAKo");

var $fFqMn = parcelRequire("fFqMn");

var $8Fiu8 = parcelRequire("8Fiu8");
var $0ebaaf4a40f9b86f$exports = {};
$0ebaaf4a40f9b86f$exports = "#onboarding{grid-template-rows:350px 4rem 1fr 3rem;height:100%;display:grid}#onboarding-header{text-align:left;grid-template-columns:340px 1fr;display:grid}#onboarding-header>div>button{font-size:2rem}#onboarding-choose-part{background-color:#57483a;grid-template-columns:repeat(5,1fr);display:grid}#onboarding-choose-part>canvas{margin:auto;padding:.1rem}#onboarding-choose-part>canvas.selected{border:1px dashed gray}.part-choice.square{grid-template-rows:repeat(2,1fr);grid-template-columns:repeat(2,1fr);margin-top:2rem;display:grid}.part-choice.two-cols{grid-template-columns:repeat(2,1fr);margin-top:2rem;display:grid}.part-choice.four-cols{grid-template-columns:repeat(4,1fr);margin-top:2rem;display:grid}.part-choice>canvas,.part-choice>canvas{margin:.5rem auto;padding:.5rem}.part-choice>canvas.selected{border:1px dashed gray}#onboarding-footer{text-align:right;background-color:#57483a}#onboarding-footer>*{margin:.5rem 2rem;font-size:1.5rem}@media (height<=750px) and (orientation:portrait){#onboarding{grid-template-rows:250px 4rem calc(45vh - 4rem) 3rem}canvas#onboarding-portrait{transform:scale(.75)translateY(-60px)}.part-choice{transform-origin:top;margin-top:1rem;transform:scale(.75)translateY(-20px)}}@media (height>=750px) and (height<=850px) and (orientation:portrait){#onboarding{grid-template-rows:280px 4rem calc(45vh - 4rem) 3rem}canvas#onboarding-portrait{transform:scale(.8)translateY(-40px)}.part-choice{transform-origin:top;margin-top:1rem;transform:scale(.8)translateY(-20px)}}";



/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */ parcelRequire("1ND9v");
var $6WiAp = parcelRequire("6WiAp");
var $iLAKo = parcelRequire("iLAKo");

var $fFqMn = parcelRequire("fFqMn");

var $8Fiu8 = parcelRequire("8Fiu8");

class $fd3ae2eb184241db$export$2e2bcd8739ae039 extends (0, $6WiAp.default) {
    constructor(opt){
        super({
            ...opt
        });
        this.faceDrawer = new (0, $8Fiu8.default)();
    }
    init(params) {
        this.zoom = params.zoom;
        this.printPortrait();
        this.on((0, $iLAKo.default).LAND, (params)=>{
            this.zoom = params.zoom;
            if ('zoom' in params) this.printPortrait();
        });
        this.on((0, $fFqMn.default).UPDATE, ()=>{
            this.printPortrait();
        });
    }
    printPortrait() {
        const config = (0, $fFqMn.default).get();
        const zoom = this.zoom || 'portrait';
        const fullFace = this.prepareBox();
        const ctx = fullFace.getContext('2d');
        this.faceDrawer.cleanAll(ctx);
        if (zoom === (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Full) {
            const ratio = 0.7;
            this.faceDrawer.drawFullSizeBody(ctx, config, ratio, {
                top: -5,
                left: 140
            });
        }
        if (zoom === (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Portrait) {
            const ratio = 2;
            this.faceDrawer.drawMedalPortrait(ctx, config, ratio, {
                top: 20,
                left: 70,
                shiftTop: 50,
                shiftLeft: 50,
                radius: 1.4
            });
        }
    }
}


/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */ parcelRequire("1ND9v");
var $6WiAp = parcelRequire("6WiAp");
var $iLAKo = parcelRequire("iLAKo");
class $35eccece47aaa9f5$export$2e2bcd8739ae039 extends (0, $6WiAp.default) {
    constructor(opt){
        super({
            ...opt,
            html: ()=>(this.back ? `<button id="onboarding-return">${this.context.onboarding.return}</button>` : '') + (this.next ? `<button id="onboarding-confirm">${this.context.onboarding.continue}</button>` : '') + (this.submit ? `<button id="onboarding-submit">${this.context.onboarding.submit}</button>` : '')
        });
        this.back = opt.back;
        this.submit = opt.submit;
        this.next = opt.next;
    }
    init() {
        if (this.back) this.addEvtById('onboarding-return', 'click', ()=>this.back());
        if (this.next) this.addEvtById('onboarding-confirm', 'click', ()=>this.next());
        if (this.submit) this.addEvtById('onboarding-submit', 'click', ()=>this.submit());
        this.on((0, $iLAKo.default).LAND, (params)=>{
            this.config = params.config;
        });
    }
}


/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */ class $2dc6156a1fff4bd3$export$2e2bcd8739ae039 {
    static UPDATE_DATA = 'update-data';
    constructor(eventBus, url){
        this.eventBus = eventBus;
        this.url = url;
    }
    listen() {
        this.eventBus.on(this.constructor.name, $2dc6156a1fff4bd3$export$2e2bcd8739ae039.UPDATE_DATA, (data, cb)=>this.updateData(data, cb));
    }
    async updateData(data, cb) {
        const updateUrl = this.url + '/onboarding/update';
        // console.log(updateUrl, data)
        const rawResponse = await fetch(updateUrl, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (rawResponse.ok) {
            if (cb) cb();
        }
    }
}


class $a31e8f1fd23b5c35$export$2e2bcd8739ae039 extends (0, $6WiAp.HostComponent) {
    constructor(opt){
        super({
            ...opt,
            css: [
                $0ebaaf4a40f9b86f$exports
            ],
            html: ({ zoom: zoom })=>`<div id="onboarding">
        <div id="onboarding-header">
          <canvas id="onboarding-portrait" width="340" height="340"></canvas>
          <div>
            <button id="onboarding-change-face" title="${this.context.onboarding.facerandom}">&#x27F2</button>
            <button id="onboarding-full-size" type="checkbox" title="${this.context.onboarding.fullsize}">${zoom === 'portrait' ? '&#x1F9CD' : '&#x1F464'}</button>
          </div>
        </div>
        <div id="onboarding-choose-part">
          <canvas id="onboarding-appearance-contour" width="48" height="48"></canvas>
          <canvas id="onboarding-appearance-eye" width="48" height="48"></canvas>
          <canvas id="onboarding-appearance-nose-mouth" width="48" height="48"></canvas>
          <canvas id="onboarding-appearance-hair" width="48" height="48"></canvas>
          <canvas id="onboarding-appearance-body" width="48" height="48"></canvas>
        </div>
        <div id="onboarding-part-sub"></div>
        <div id="onboarding-footer"></div>
      </div>`
        });
        this.faceDrawer = new (0, $8Fiu8.default)();
    }
    init(params, path) {
        this.zoom = params.zoom;
        const { eventBus: eventBus, context: context } = this;
        this.addChildren(params, path, new (0, $fd3ae2eb184241db$export$2e2bcd8739ae039)({
            eventBus: eventBus,
            context: context,
            box: 'onboarding-portrait'
        }), new (0, $35eccece47aaa9f5$export$2e2bcd8739ae039)({
            eventBus: eventBus,
            context: context,
            box: 'onboarding-footer',
            next: (config)=>{
                this.emit((0, $iLAKo.default).GO, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Name());
            }
        }));
        this.initConfig(params, path);
        this.initCanvasButton();
        this.on((0, $iLAKo.default).LAND, (params, path)=>{
            this.initConfig(params, path, ()=>{
                this.gId('onboarding-full-size').innerHTML = this.zoom === 'portrait' ? '&#x1F9CD' : '&#x1F464';
                this.initCanvasButton();
            });
        });
        this.addEvtById('onboarding-change-face', 'click', ()=>{
            this.emit((0, $fFqMn.default).UPDATE, (0, $fFqMn.default).changes(), (faceConfig)=>this.emit((0, $2dc6156a1fff4bd3$export$2e2bcd8739ae039).UPDATE_DATA, {
                    faceConfig: faceConfig
                }));
        });
        this.addEvtById('onboarding-full-size', 'click', ()=>{
            this.emit((0, $iLAKo.default).GO, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Face(this.zoom === 'portrait' ? (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Full : (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Portrait, this.part));
        });
    }
    initConfig(params, path, cb = ()=>{}) {
        const splitPath = (0, $781ef74ef01a0874$export$2e2bcd8739ae039).FaceSplit(path);
        if (splitPath) {
            const { part: part } = splitPath;
            this.config = (0, $fFqMn.default).get();
            this.zoom = params.zoom;
            this.part = part;
            cb();
        }
    }
    initCanvasButton() {
        const contourBtn = this.gId('onboarding-appearance-contour');
        this.faceDrawer.drawNoHairFace(contourBtn.getContext('2d'), 1, 0.5, 0);
        contourBtn.addEventListener('click', ()=>{
            this.emit((0, $iLAKo.default).GO, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Face(this.zoom, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Head));
        });
        if (this.part === (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Head) contourBtn.classList.add('selected');
        else contourBtn.classList.remove('selected');
        const eyeBtn = this.gId('onboarding-appearance-eye');
        const eyeCTx = eyeBtn.getContext('2d');
        this.faceDrawer.drawEyes(eyeCTx, 1, 0.8, 5, {
            left: -15,
            top: 20
        });
        this.faceDrawer.drawEyebrows(eyeCTx, 1, 0.8, 5, {
            left: -15,
            top: 10
        });
        eyeBtn.addEventListener('click', ()=>{
            this.emit((0, $iLAKo.default).GO, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Face(this.zoom, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Eyes));
        });
        if (this.part === (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Eyes) eyeBtn.classList.add('selected');
        else eyeBtn.classList.remove('selected');
        const noseMouthBtn = this.gId('onboarding-appearance-nose-mouth');
        const noseMouthCtx = noseMouthBtn.getContext('2d');
        this.faceDrawer.drawNose(noseMouthCtx, 1, 1, 15, -25);
        this.faceDrawer.drawMouth(noseMouthCtx, 1, 1, 35, -25);
        noseMouthBtn.addEventListener('click', ()=>{
            this.emit((0, $iLAKo.default).GO, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Face(this.zoom, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).NoseMouth));
        });
        if (this.part === (0, $781ef74ef01a0874$export$2e2bcd8739ae039).NoseMouth) noseMouthBtn.classList.add('selected');
        else noseMouthBtn.classList.remove('selected');
        const hairBtn = this.gId('onboarding-appearance-hair');
        this.faceDrawer.drawHairOnly(hairBtn.getContext('2d'), 2, 0.5, 10, {
            left: -1,
            top: 0
        });
        hairBtn.addEventListener('click', ()=>{
            this.emit((0, $iLAKo.default).GO, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Face(this.zoom, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Hair));
        });
        if (this.part === (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Hair) hairBtn.classList.add('selected');
        else hairBtn.classList.remove('selected');
        const bodyBtn = this.gId('onboarding-appearance-body');
        this.faceDrawer.drawBodyOnly(bodyBtn.getContext('2d'), 1, 0.1, {
            left: 18,
            top: -5
        });
        bodyBtn.addEventListener('click', ()=>{
            this.emit((0, $iLAKo.default).GO, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Face(this.zoom, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Body));
        });
        if (this.part === (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Body) bodyBtn.classList.add('selected');
        else bodyBtn.classList.remove('selected');
    }
}


/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */ parcelRequire("1ND9v");
var $6WiAp = parcelRequire("6WiAp");

var $8Fiu8 = parcelRequire("8Fiu8");
/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */ parcelRequire("1ND9v");
var $6WiAp = parcelRequire("6WiAp");

var $fFqMn = parcelRequire("fFqMn");

class $2500fe0ca559986d$export$2e2bcd8739ae039 extends (0, $6WiAp.default) {
    constructor(opt){
        super(opt);
        this.num = opt.num;
        this.draw = opt.draw;
        this.width = opt.width;
        this.height = opt.height;
        this.shape = opt.shape;
    }
    init(params, path) {
        const config = (0, $fFqMn.default).get();
        const allCnv = [];
        const partChoiceContour = this.prepareBox();
        for(let i = 0; i < this.num; i++){
            const cnv = this.fragmentFromHtml(`<canvas ${config[this.shape] === +i ? 'class="selected"' : ''}width="${this.width}" height="${this.height}"></canvas>`).firstChild;
            allCnv.push(cnv);
            this.draw(cnv.getContext('2d'), i);
            partChoiceContour.appendChild(cnv);
            cnv.addEventListener('click', (e)=>{
                e.preventDefault();
                this.emit((0, $fFqMn.default).UPDATE, {
                    [this.shape]: i
                }, (faceConfig)=>this.emit((0, $2dc6156a1fff4bd3$export$2e2bcd8739ae039).UPDATE_DATA, {
                        faceConfig: faceConfig
                    }));
            });
        }
        this.on((0, $fFqMn.default).UPDATE, (changes)=>{
            allCnv.forEach((c, i)=>{
                if ((0, $fFqMn.default).get(this.shape) === +i) c.classList.add('selected');
                else c.classList.remove('selected');
            });
        });
    }
}


class $6ad9e7aecb3005bf$export$2e2bcd8739ae039 extends (0, $6WiAp.default) {
    constructor(opt){
        super({
            ...opt,
            html: ()=>'<div id="part-choice-body" class="part-choice two-cols"></div>'
        });
    }
    init(params, path) {
        const { eventBus: eventBus, context: context } = this;
        const faceDrawer = new (0, $8Fiu8.default)();
        this.addChildren(params, path, new (0, $2500fe0ca559986d$export$2e2bcd8739ae039)({
            eventBus: eventBus,
            context: context,
            box: 'part-choice-body',
            num: 2,
            draw (cnv, i) {
                faceDrawer.drawBodyAndUnderwear(cnv, i, 0.6, {
                    left: 30,
                    top: -55
                });
            },
            shape: 'body',
            width: 120,
            height: 240
        }));
    }
}


/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */ parcelRequire("1ND9v");
var $6WiAp = parcelRequire("6WiAp");

var $8Fiu8 = parcelRequire("8Fiu8");

class $352ec128b229fd6d$export$2e2bcd8739ae039 extends (0, $6WiAp.default) {
    constructor(opt){
        super({
            ...opt,
            html: ()=>'<div id="part-choice-contour" class="part-choice square"></div>'
        });
    }
    init(params, path) {
        const { eventBus: eventBus, context: context } = this;
        const faceDrawer = new (0, $8Fiu8.default)();
        this.addChildren(params, path, new (0, $2500fe0ca559986d$export$2e2bcd8739ae039)({
            eventBus: eventBus,
            context: context,
            box: 'part-choice-contour',
            num: 4,
            draw (ctx, i) {
                faceDrawer.drawNoHairFace(ctx, i, 0.9, 5);
            },
            shape: 'face',
            width: 90,
            height: 90
        }));
    }
}


/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */ parcelRequire("1ND9v");
var $6WiAp = parcelRequire("6WiAp");

var $8Fiu8 = parcelRequire("8Fiu8");

class $f4666a56d944e575$export$2e2bcd8739ae039 extends (0, $6WiAp.default) {
    constructor(opt){
        super({
            ...opt,
            html: ()=>`<div id="part-choice-eyebrows" class="part-choice four-cols"></div>
      <div id="part-choice-eyes" class="part-choice four-cols"></div>`
        });
    }
    init(params, path) {
        const { eventBus: eventBus, context: context } = this;
        const faceDrawer = new (0, $8Fiu8.default)();
        this.addChildren(params, path, new (0, $2500fe0ca559986d$export$2e2bcd8739ae039)({
            name: 'FacePartSelector:eyebrows',
            eventBus: eventBus,
            context: context,
            box: 'part-choice-eyebrows',
            num: 4,
            draw (ctx, i) {
                faceDrawer.drawEyebrows(ctx, i, 1, 5, {
                    left: -20,
                    top: 10
                });
            },
            shape: 'eyebrows',
            width: 60,
            height: 30
        }), new (0, $2500fe0ca559986d$export$2e2bcd8739ae039)({
            name: 'FacePartSelector:eyes',
            eventBus: eventBus,
            context: context,
            box: 'part-choice-eyes',
            num: 4,
            draw (ctx, i) {
                faceDrawer.drawEyes(ctx, i, 1, 5, {
                    left: -20,
                    top: 10
                });
            },
            shape: 'eyes',
            width: 60,
            height: 40
        }));
    }
}


/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */ parcelRequire("1ND9v");
var $6WiAp = parcelRequire("6WiAp");

var $8Fiu8 = parcelRequire("8Fiu8");

class $8cef264d50de8981$export$2e2bcd8739ae039 extends (0, $6WiAp.default) {
    constructor(opt){
        super({
            ...opt,
            html: ()=>'<div id="part-choice-hair" class="part-choice square"></div>'
        });
    }
    init(params, path) {
        const { eventBus: eventBus, context: context } = this;
        const faceDrawer = new (0, $8Fiu8.default)();
        this.addChildren(params, path, new (0, $2500fe0ca559986d$export$2e2bcd8739ae039)({
            eventBus: eventBus,
            context: context,
            box: 'part-choice-hair',
            num: 4,
            draw (ctx, i) {
                faceDrawer.drawHairOnly(ctx, i, 0.7, 15, {
                    left: 10,
                    top: 0
                });
            },
            shape: 'hair',
            width: 90,
            height: 90
        }));
    }
}


/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */ parcelRequire("1ND9v");
var $6WiAp = parcelRequire("6WiAp");

var $8Fiu8 = parcelRequire("8Fiu8");

class $febee6fab5582b45$export$2e2bcd8739ae039 extends (0, $6WiAp.default) {
    constructor(opt){
        super({
            ...opt,
            html: ()=>`<div id="part-choice-nose" class="part-choice four-cols"></div>
      <div id="part-choice-mouth" class="part-choice four-cols"></div>`
        });
    }
    init(params, path) {
        const { eventBus: eventBus, context: context } = this;
        const faceDrawer = new (0, $8Fiu8.default)();
        this.addChildren(params, path, new (0, $2500fe0ca559986d$export$2e2bcd8739ae039)({
            name: 'FacePartSelector:nose',
            eventBus: eventBus,
            context: context,
            box: 'part-choice-nose',
            num: 4,
            draw (ctx, i) {
                faceDrawer.drawNose(ctx, i, 2, 5, -35);
            },
            shape: 'nose',
            width: 60,
            height: 40
        }), new (0, $2500fe0ca559986d$export$2e2bcd8739ae039)({
            name: 'FacePartSelector:mouth',
            eventBus: eventBus,
            context: context,
            box: 'part-choice-mouth',
            num: 4,
            draw (ctx, i) {
                faceDrawer.drawMouth(ctx, i, 2, 5, -35);
            },
            shape: 'mouth',
            width: 60,
            height: 30
        }));
    }
}


parcelRequire("1ND9v");
var $6WiAp = parcelRequire("6WiAp");
var $iLAKo = parcelRequire("iLAKo");

var $8Fiu8 = parcelRequire("8Fiu8");


var $7a6386a2737c2878$exports = {};
$7a6386a2737c2878$exports = "#onboarding{grid-template-rows:350px 1fr 3rem;height:100%;display:grid}#onboarding-header{text-align:center}#onboarding-body>form{grid-template-rows:1fr;display:grid}#onboarding-body>form>label{margin:1rem 1rem 0}#onboarding-body>form>input{margin:0 1rem;font-size:1rem}#onboarding-body>form>textarea{height:6rem;margin:0 1rem;font-size:1rem}#onboarding-footer{text-align:right;background-color:#57483a}#onboarding-footer>*{margin:.5rem 2rem;font-size:1.5rem}@media (height<=750px) and (orientation:portrait){#onboarding{grid-template-rows:250px 1fr 3rem}canvas#onboarding-portrait{transform:scale(.75)translateY(-60px)}}@media (height>=750px) and (height<=850px) and (orientation:portrait){#onboarding{grid-template-rows:280px 1fr 3rem}canvas#onboarding-portrait{transform:scale(.8)translateY(-40px)}}";




class $998dc56d56781bba$export$2e2bcd8739ae039 extends (0, $6WiAp.default) {
    constructor(opt){
        super({
            ...opt,
            css: [
                $7a6386a2737c2878$exports
            ],
            html: ()=>`<div id="onboarding">
        <div id="onboarding-header">
          <canvas id="onboarding-portrait" width="340" height="340"></canvas>
        </div>
        <div id="onboarding-body">
          <form>
            <label>${this.context.onboarding.choose_name}</label>
            <input id="choose-name" type="text">
            <label>${this.context.onboarding.choose_description}</label>
            <textarea id="choose-description"></textarea>
          </form>
        </div>
        <div id="onboarding-footer"></div>
      </div>`
        });
        this.faceDrawer = new (0, $8Fiu8.default)();
    }
    init(params, path) {
        const { eventBus: eventBus, context: context } = this;
        this.addChildren(params, path, new (0, $fd3ae2eb184241db$export$2e2bcd8739ae039)({
            eventBus: eventBus,
            context: context,
            box: 'onboarding-portrait'
        }), new (0, $35eccece47aaa9f5$export$2e2bcd8739ae039)({
            eventBus: eventBus,
            context: context,
            box: 'onboarding-footer',
            back: ()=>this.emit((0, $iLAKo.default).GO, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Face((0, $781ef74ef01a0874$export$2e2bcd8739ae039).Portrait)),
            next: ()=>this.emit((0, $iLAKo.default).GO, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Register())
        }));
        const chooseName = this.gId('choose-name');
        const chooseDescription = this.gId('choose-description');
        const onboardingName = document.getElementById('onboarding-name');
        chooseName.value = onboardingName.value;
        const onboardingDescription = document.getElementById('onboarding-description');
        chooseDescription.value = onboardingDescription.value;
        let chooseNameTO;
        chooseName.addEventListener('keyup', ()=>{
            if (chooseNameTO) clearTimeout(chooseNameTO);
            chooseNameTO = setTimeout(()=>{
                this.emit((0, $2dc6156a1fff4bd3$export$2e2bcd8739ae039).UPDATE_DATA, {
                    name: chooseName.value.trim()
                }, ()=>{
                    chooseName.value = chooseName.value.trim();
                    onboardingName.value = chooseName.value.trim();
                });
            }, 500);
        });
        let chooseDescriptionTO;
        chooseDescription.addEventListener('keyup', ()=>{
            if (chooseDescriptionTO) clearTimeout(chooseDescriptionTO);
            chooseDescriptionTO = setTimeout(()=>{
                this.emit((0, $2dc6156a1fff4bd3$export$2e2bcd8739ae039).UPDATE_DATA, {
                    description: chooseDescription.value
                }, ()=>{
                    onboardingDescription.value = chooseDescription.value;
                });
            }, 500);
        });
    }
}


parcelRequire("1ND9v");
var $6WiAp = parcelRequire("6WiAp");
var $iLAKo = parcelRequire("iLAKo");

var $8Fiu8 = parcelRequire("8Fiu8");



var $bCXGN = parcelRequire("bCXGN");
var $5506bf4062ab865c$exports = {};
$5506bf4062ab865c$exports = ".layer{background-color:#50505033}.layer-top{background-color:#50505099}#popover-box,#popover-box>div.layer{width:100%;height:100%;position:absolute;top:0;left:0}#popover-box>div.layer>div{background-color:#fff;position:absolute;top:10px;left:50%;transform:translate(-50%)}";


var $a6d46cff77829153$exports = {};
$a6d46cff77829153$exports = "<div id=popover-box style=display:none></div>";


var $a737b87c7339b1a1$exports = {};
$a737b87c7339b1a1$exports = "#onboarding{grid-template-rows:350px 1fr 3rem;height:100%;display:grid}#onboarding-header{text-align:center}#onboarding-body>form{grid-template-rows:1fr;display:grid}#onboarding-body>form>label{margin:1rem 1rem 0}#onboarding-body>form>input{margin:0 1rem;font-size:1rem}#onboarding-body>form>textarea{height:6rem;margin:0 1rem;font-size:1rem}#onboarding-footer{text-align:right;background-color:#57483a}#onboarding-footer>*{margin:.5rem 2rem;font-size:1.5rem}@media (height<=750px) and (orientation:portrait){#onboarding{grid-template-rows:250px 1fr 3rem}canvas#onboarding-portrait{transform:scale(.75)translateY(-60px)}}@media (height>=750px) and (height<=850px) and (orientation:portrait){#onboarding{grid-template-rows:280px 1fr 3rem}canvas#onboarding-portrait{transform:scale(.8)translateY(-40px)}}";




const $32ffc19e0727252e$var$passwdRX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[.:;,?!@#$%^&*+_\\/'"{}()[\] -])[A-Za-z\d.:;,?!@#$%^&*+_\\/'"{}()[\] -]{8,}$/;
class $32ffc19e0727252e$export$2e2bcd8739ae039 extends (0, $6WiAp.default) {
    constructor(opt){
        super({
            ...opt,
            css: [
                $5506bf4062ab865c$exports,
                $a737b87c7339b1a1$exports,
                `
        input {
          font-size: xx-large;
        }

        input:focus:invalid {
          outline: 2px solid red;
        }

        input:focus:valid {
          outline: 2px solid black;
        }

        input:valid {
          border: 1px solid black;
        }

        input:invalid {
          border: 1px solid red;
        }

        input:invalid+span:after {
          position: absolute;
          content: '\u{2716}';
          padding-left: 5px;
        }

        input:valid+span:after {
          position: absolute;
          content: '\u{2713}';
          padding-left: 5px;
        }
        
        ul {
          list-style: none;
          margin-left: 0;
          padding-left: 0;
        }
        li {
          font-size: .5rem;
          padding-left: 1rem;
          text-indent: -1rem;
        }
        li::before {
          content: "\u{2716}";
          padding-right: 5px;
        }
        li.ok::before {
          content: "\u{2713}";
          padding-right: 5px;
        }
      `
            ].join('\n'),
            html: ()=>{
                const onboardingName = document.getElementById('onboarding-name');
                const onboardingDescription = document.getElementById('onboarding-description');
                return (0, (/*@__PURE__*/$parcel$interopDefault($a6d46cff77829153$exports))) + `<div id="onboarding">
        <div id="onboarding-header">
          <canvas id="onboarding-portrait" width="340" height="340"></canvas>
        </div>
        <div id="onboarding-body">
          <form id="onboarding-register-form" method="POST"  action="/onboarding/register" method="post">
            <h2>${onboardingName.value}</h2>
            <p>${onboardingDescription.value}</p>
            <label>${this.context.onboarding.email}</label>
            <input id="choose-email" name="email" required type="email">
            <label>${this.context.onboarding.password}</label>
            <input id="choose-password" name="password" required type="password">
            <p><input id="see-password" type="checkbox">${this.context.onboarding.see_password}</p>
            <ul>${Object.entries(this.context.onboarding.password_requirement).map(([k, v])=>`<li id="login-password-${k}">${v}</li>`).join('\n')}</ul>
          </form>
        </div>
        <div id="onboarding-footer"></div>
      </div>`;
            }
        });
        this.faceDrawer = new (0, $8Fiu8.default)();
    }
    init(params, path) {
        const { eventBus: eventBus, context: context } = this;
        this.addChildren(params, path, new (0, $bCXGN.default)({
            eventBus: eventBus,
            context: context,
            box: 'popover-box' //, logger: console
        }), new (0, $fd3ae2eb184241db$export$2e2bcd8739ae039)({
            eventBus: eventBus,
            context: context,
            box: 'onboarding-portrait'
        }), new (0, $35eccece47aaa9f5$export$2e2bcd8739ae039)({
            eventBus: eventBus,
            context: context,
            box: 'onboarding-footer',
            back: ()=>this.emit((0, $iLAKo.default).GO, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Name()),
            submit: ()=>{
                const chooseEmail = this.gId('choose-email');
                const passwordInput = this.gId('choose-password');
                if (chooseEmail.value && passwordInput.value) {
                    if (!chooseEmail.checkValidity()) this.emit((0, $bCXGN.PopOverEvents).MODAL_OPEN, this.context.onboarding.error.email_correct);
                    else if (!passwordInput.checkValidity()) this.emit((0, $bCXGN.PopOverEvents).MODAL_OPEN, this.context.onboarding.error.password_correct);
                    else this.gId('onboarding-register-form').submit();
                } else this.emit((0, $bCXGN.PopOverEvents).MODAL_OPEN, !chooseEmail.value && !passwordInput.value ? this.context.onboarding.error.both : !chooseEmail.value ? this.context.onboarding.error.email : this.context.onboarding.error.password);
            }
        }));
        const chooseEmail = this.gId('choose-email');
        const onboardingEmail = document.getElementById('onboarding-email');
        chooseEmail.value = onboardingEmail.value;
        let chooseEmailTO;
        chooseEmail.addEventListener('input', ()=>{
            if (chooseEmailTO) clearTimeout(chooseEmailTO);
            chooseEmailTO = setTimeout(()=>{
                this.emit((0, $2dc6156a1fff4bd3$export$2e2bcd8739ae039).UPDATE_DATA, {
                    email: chooseEmail.value.trim()
                }, ()=>{
                    chooseEmail.value = chooseEmail.value.trim();
                    onboardingEmail.value = chooseEmail.value.trim();
                });
            }, 500);
        });
        const passwdMin8Cond = (x)=>x.length >= 8;
        const passwdLetterCond = (x)=>/[A-Za-z]/.test(x);
        const passwdDigitCond = (x)=>/\d/.test(x);
        const passwdSpecialCond = (x)=>/[.:;,?!@#$%^&*+_\\/'"{}()[\] -]/.test(x);
        const passwordInput = this.gId('choose-password');
        passwordInput.addEventListener('input', ()=>{
            const value = passwordInput.value;
            if (passwdMin8Cond(value)) this.gId('login-password-min8').classList.add('ok');
            else this.gId('login-password-min8').classList.remove('ok');
            if (passwdLetterCond(value)) this.gId('login-password-letter').classList.add('ok');
            else this.gId('login-password-letter').classList.remove('ok');
            if (passwdDigitCond(value)) this.gId('login-password-digit').classList.add('ok');
            else this.gId('login-password-digit').classList.remove('ok');
            if (passwdSpecialCond(value)) this.gId('login-password-special').classList.add('ok');
            else this.gId('login-password-special').classList.remove('ok');
            if (!$32ffc19e0727252e$var$passwdRX.test(value)) passwordInput.setCustomValidity(this.context.register.invalid_passwd);
            else passwordInput.setCustomValidity('');
            // passwordInput.reportValidity()
            const seePassword = this.gId('see-password');
            seePassword.addEventListener('click', ()=>{
                if (seePassword.checked) passwordInput.type = 'text';
                else passwordInput.type = 'password';
            });
        });
    }
}



var $fFqMn = parcelRequire("fFqMn");

// TODO add a mechanic to change language
const $15d4b20e1d76f9b0$var$i18n = (0, $2SPoJ.default);
const $15d4b20e1d76f9b0$var$eventBus = new (0, $cRMCj.default)({
});
new (0, $2dc6156a1fff4bd3$export$2e2bcd8739ae039)($15d4b20e1d76f9b0$var$eventBus, `${window.location.protocol}//${window.location.host}`).listen();
(0, $fFqMn.default).init($15d4b20e1d76f9b0$var$eventBus);
const $15d4b20e1d76f9b0$var$router = (0, $1ND9v.default)({
    box: 'app-onboarding',
    context: $15d4b20e1d76f9b0$var$i18n,
    eventBus: $15d4b20e1d76f9b0$var$eventBus,
    routes: {
        [(0, $781ef74ef01a0874$export$2e2bcd8739ae039).Root]: {
            onLoad () {
                this.emit((0, $iLAKo.default).GO, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Face((0, $781ef74ef01a0874$export$2e2bcd8739ae039).Portrait, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Head));
            }
        },
        [(0, $781ef74ef01a0874$export$2e2bcd8739ae039).Face()]: {
            sub_box: 'onboarding-part-sub',
            type: (0, $a31e8f1fd23b5c35$export$2e2bcd8739ae039),
            embed: {
                [(0, $781ef74ef01a0874$export$2e2bcd8739ae039).Default]: {
                    onLoad ({ zoom: zoom }) {
                        this.emit((0, $iLAKo.default).GO, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Face(zoom, (0, $781ef74ef01a0874$export$2e2bcd8739ae039).Head));
                    }
                },
                [(0, $781ef74ef01a0874$export$2e2bcd8739ae039).Head]: (0, $352ec128b229fd6d$export$2e2bcd8739ae039),
                [(0, $781ef74ef01a0874$export$2e2bcd8739ae039).Eyes]: (0, $f4666a56d944e575$export$2e2bcd8739ae039),
                [(0, $781ef74ef01a0874$export$2e2bcd8739ae039).NoseMouth]: (0, $febee6fab5582b45$export$2e2bcd8739ae039),
                [(0, $781ef74ef01a0874$export$2e2bcd8739ae039).Hair]: (0, $8cef264d50de8981$export$2e2bcd8739ae039),
                [(0, $781ef74ef01a0874$export$2e2bcd8739ae039).Body]: (0, $6ad9e7aecb3005bf$export$2e2bcd8739ae039)
            }
        },
        [(0, $781ef74ef01a0874$export$2e2bcd8739ae039).Name()]: (0, $998dc56d56781bba$export$2e2bcd8739ae039),
        [(0, $781ef74ef01a0874$export$2e2bcd8739ae039).Register()]: (0, $32ffc19e0727252e$export$2e2bcd8739ae039),
        [(0, $iLAKo.default).NOT_FOUND]: {
            name: (0, $iLAKo.default).NOT_FOUND,
            type: (0, $6WiAp.default),
            html: '404 Page not found'
        }
    }
});
$15d4b20e1d76f9b0$var$router.run();
$15d4b20e1d76f9b0$var$router.route();
// new OnboardingMain({
//   box: 'app-onboarding',
//   context: i18n,
//   eventBus
// }).load()
// FIXME use this fix to bypass error in HMR management
(0, $iqDbY.default)();

})();
//# sourceMappingURL=index.js.map
